msgid ""
msgstr ""
"POT-Creation-Date: 2026-06-09 03:29+0000\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: en\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: nplurals=2; plural=(n != 1);\n"

#. placeholder {0}: conversation.messagesCount
#: app/frontend/pages/v2/contacts/show.tsx
msgid " · {0} {messagesNoun}"
msgstr " · {0} {messagesNoun}"

#: app/frontend/components/v2/inbox/compose/composer-templates-popover.tsx
msgid " · approved by Meta"
msgstr " · approved by Meta"

#: app/frontend/components/v2/inbox/compose/composer-templates-popover.tsx
msgid " · awaiting Meta"
msgstr " · awaiting Meta"

#. placeholder {0}: stage.dealsCount
#: app/frontend/components/v2/deals/mobile-deals-shell.tsx
msgid "· {0} deal"
msgstr "· {0} deal"

#. placeholder {0}: stage.dealsCount
#: app/frontend/components/v2/deals/mobile-deals-shell.tsx
msgid "· {0} deals"
msgstr "· {0} deals"

#: app/frontend/components/v2/voice/after-call-card.tsx
msgid "· edits save to the note"
msgstr "· edits save to the note"

#: app/frontend/components/v2/voice/after-call-subview-header.tsx
#: app/frontend/components/v2/voice/after-call-transcript.tsx
#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "‹ Back"
msgstr "‹ Back"

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "\"{draft}\" — ready to send the moment they reply."
msgstr "\"{draft}\" — ready to send the moment they reply."

#: app/frontend/lib/delete-prompt-copy.ts
msgid "\"{quoted}\" and its history will be permanently deleted."
msgstr "\"{quoted}\" and its history will be permanently deleted."

#: app/frontend/lib/delete-prompt-copy.ts
msgid "\"{quoted}\" will be removed."
msgstr "\"{quoted}\" will be removed."

#: app/frontend/pages/v2/dev/components/voice_card.tsx
msgid "(dev only)"
msgstr "(dev only)"

#: app/frontend/components/v2/inbox/assignment-popover.tsx
msgid "(me)"
msgstr "(me)"

#: app/frontend/components/v2/deals/filter-popover.tsx
#: app/frontend/components/v2/deals/filter-popover.tsx
msgid "(no value needed)"
msgstr "(no value needed)"

#: app/frontend/components/v2/inbox/create-opportunity-panel.tsx
msgid "(optional)"
msgstr "(optional)"

#: app/frontend/components/v2/inbox/compose/composer-templates-popover.tsx
#: app/frontend/components/v2/inbox/compose/staged-template.tsx
msgid "(this template has no body)"
msgstr "(this template has no body)"

#. placeholder {0}: v.token
#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "{{{0}}} — AI filled"
msgstr "{{{0}}} — AI filled"

#. placeholder {0}: v.token
#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "{{{0}}} — AI filling from the call…"
msgstr "{{{0}}} — AI filling from the call…"

#. placeholder {0}: current.trialDaysLeft
#: app/frontend/components/v2/settings/billing/trial-banner.tsx
msgid "{0, plural, one {# day left} other {# days left}}"
msgstr "{0, plural, one {# day left} other {# days left}}"

#. placeholder {0}: conversation.messagesCount
#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
msgid "{0, plural, one {# message} other {# messages}}"
msgstr "{0, plural, one {# message} other {# messages}}"

#. placeholder {0}: preset.label
#: app/frontend/components/v2/deals/next-step-composer.tsx
msgid "{0}"
msgstr "{0}"

#. placeholder {0}: employee?.name ?? t`Teammate`
#: app/frontend/pages/v2/settings/team/show.tsx
msgid "{0} - Team - Conecto"
msgstr "{0} - Team - Conecto"

#. placeholder {0}: formatActivityCount(count, t)
#. placeholder {1}: formatDateLabel(iso)
#: app/frontend/pages/v2/today/show.tsx
msgid "{0} · {1}"
msgstr "{0} · {1}"

#. placeholder {0}: formatActivityCount(count, t)
#: app/frontend/pages/v2/today/show.tsx
msgid "{0} · oldest {oldestLateDays} {dayNoun} late"
msgstr "{0} · oldest {oldestLateDays} {dayNoun} late"

#. placeholder {0}: format || "MEDIA"
#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "{0} · the sample Meta reviews"
msgstr "{0} · the sample Meta reviews"

#. placeholder {0}: deal.created.at
#. placeholder {1}: deal.created.by
#: app/frontend/components/v2/deals/mobile-deal-show-panel.tsx
msgid "{0} by {1}"
msgstr "{0} by {1}"

#. placeholder {0}: formatEmployeeCount(company.employeeCount)
#. placeholder {0}: formatEmployeeCount(deal.company.employeeCount)
#. placeholder {0}: formatInteger(company.employeeCount)
#: app/frontend/components/v2/companies/company-drawer.tsx
#: app/frontend/components/v2/companies/index-table.tsx
#: app/frontend/components/v2/companies/index-table.tsx
#: app/frontend/components/v2/companies/show-hero.tsx
#: app/frontend/components/v2/deals/deal-show-panel.tsx
#: app/frontend/components/v2/deals/mobile-deal-show-panel.tsx
#: app/frontend/components/v2/inbox/company-block.tsx
msgid "{0} employees"
msgstr "{0} employees"

#. placeholder {0}: kpis.closedWon.lifetimeLabel
#: app/frontend/pages/v2/contacts/show.tsx
msgid "{0} lifetime"
msgstr "{0} lifetime"

#. placeholder {0}: employee.numbersCount
#: app/frontend/components/v2/settings/phone-numbers/buy/step-assign.tsx
#: app/frontend/components/v2/settings/phone-numbers/reassign-answerers.tsx
msgid "{0} numbers"
msgstr "{0} numbers"

#. placeholder {0}: stats.voiceEnabled
#. placeholder {1}: stats.members
#: app/frontend/pages/v2/settings/team/index.tsx
msgid "{0} of {1} teammate have voice enabled."
msgstr "{0} of {1} teammate have voice enabled."

#. placeholder {0}: stats.voiceEnabled
#. placeholder {1}: stats.members
#: app/frontend/pages/v2/settings/team/index.tsx
msgid "{0} of {1} teammates have voice enabled."
msgstr "{0} of {1} teammates have voice enabled."

#. placeholder {0}: company.openDealsCount
#. placeholder {0}: deal.company.openDealsCount
#: app/frontend/components/v2/deals/deal-show-panel.tsx
#: app/frontend/components/v2/deals/mobile-deal-show-panel.tsx
#: app/frontend/components/v2/inbox/company-block.tsx
msgid "{0} other deals"
msgstr "{0} other deals"

#. placeholder {0}: counts.overdue
#. placeholder {1}: counts.today
#: app/frontend/pages/v2/today/show.tsx
msgid "{0} overdue · {1} to do"
msgstr "{0} overdue · {1} to do"

#. placeholder {0}: kpis.openDeals.pipelineLabel
#: app/frontend/pages/v2/contacts/show.tsx
msgid "{0} pipeline"
msgstr "{0} pipeline"

#. placeholder {0}: selectedIds.length
#: app/frontend/components/v2/settings/team/team-answers-popover.tsx
msgid "{0} selected"
msgstr "{0} selected"

#. placeholder {0}: stage.name
#: app/frontend/components/v2/deals/deal-column.tsx
msgid "{0} stage"
msgstr "{0} stage"

#. placeholder {0}: stages.length
#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
msgid "{0} stages"
msgstr "{0} stages"

#. placeholder {0}: number.assigneeCount
#: app/frontend/components/v2/settings/team/answers-on-card.tsx
msgid "{0} teammates"
msgstr "{0} teammates"

#. placeholder {0}: formatActivityCount(count, t)
#. placeholder {1}: formatDateLabel(rangeEnd)
#: app/frontend/pages/v2/today/show.tsx
msgid "{0} through {1}"
msgstr "{0} through {1}"

#. placeholder {0}: counts.today
#. placeholder {1}: counts.overdue
#. placeholder {2}: counts.completedToday
#: app/frontend/pages/v2/today/show.tsx
msgid "{0} to do · {1} overdue · {2} completed earlier"
msgstr "{0} to do · {1} overdue · {2} completed earlier"

#. placeholder {0}: counts.unread
#. placeholder {1}: counts.all
#: app/frontend/pages/v2/notifications/index.tsx
#: app/frontend/pages/v2/notifications/index.tsx
msgid "{0} unread of {1} total"
msgstr "{0} unread of {1} total"

#. placeholder {0}: selected.variables.length
#: app/frontend/components/v2/inbox/compose/composer-templates-popover.tsx
msgid "{0} variables auto-filled"
msgstr "{0} variables auto-filled"

#. placeholder {0}: conversation.contact.name
#. placeholder {1}: conversation.contact.name.split(" ")[0] ?? "them"
#: app/frontend/components/v2/inbox/conversation-archive-confirm-sheet.tsx
msgid "{0}'s thread will be hidden from every teammate's inbox. New messages from {1} will bring it back automatically."
msgstr "{0}'s thread will be hidden from every teammate's inbox. New messages from {1} will bring it back automatically."

#. placeholder {0}: Math.round( (stats.linkedToDealCount / stats.totalContacts) * 100, )
#: app/frontend/pages/v2/contacts/index.tsx
msgid "{0}% of total"
msgstr "{0}% of total"

#: app/frontend/components/v2/deals/filter-popover.tsx
msgid "{activeCount} active"
msgstr "{activeCount} active"

#: app/frontend/components/v2/inbox/inbox-list.tsx
msgid "{allCount} active"
msgstr "{allCount} active"

#: app/frontend/pages/v2/settings/phone_numbers/new.tsx
msgid "{answererCount} selected"
msgstr "{answererCount} selected"

#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
msgid "{channelsCount} {channelNoun}"
msgstr "{channelsCount} {channelNoun}"

#: app/frontend/components/v2/deals/mobile-note-sheet.tsx
msgid "{charCount} chars"
msgstr "{charCount} chars"

#: app/frontend/pages/v2/today/show.tsx
msgid "{count} {noun}"
msgstr "{count} {noun}"

#: app/frontend/pages/v2/companies/index.tsx
msgid "{count} companies need enrichment this week."
msgstr "{count} companies need enrichment this week."

#: app/frontend/components/v2/deals/deal-card.tsx
msgid "{count} conversations need a reply"
msgstr "{count} conversations need a reply"

#: app/frontend/components/v2/companies/index-list.tsx
msgid "{count} deals"
msgstr "{count} deals"

#: app/frontend/pages/v2/today/show.tsx
msgid "{count} done · clears at midnight"
msgstr "{count} done · clears at midnight"

#: app/frontend/components/v2/inbox/compose/staged-template.tsx
msgid "{count} fields needed"
msgstr "{count} fields needed"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "{count} of {BUTTONS_MAX} used · quick replies group together, away from URL / call buttons"
msgstr "{count} of {BUTTONS_MAX} used · quick replies group together, away from URL / call buttons"

#: app/frontend/components/v2/inbox/filter-pills.tsx
msgid "{deepFilterCount} active filter"
msgstr "{deepFilterCount} active filter"

#: app/frontend/components/v2/inbox/filter-pills.tsx
msgid "{deepFilterCount} active filters"
msgstr "{deepFilterCount} active filters"

#: app/frontend/components/v2/deals/activity-feed.tsx
msgid "{diffMin}m ago"
msgstr "{diffMin}m ago"

#: app/frontend/components/v2/settings/team/team-member-row.tsx
msgid "{extra} more"
msgstr "{extra} more"

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "{fieldCount} field"
msgstr "{fieldCount} field"

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "{fieldCount} fields"
msgstr "{fieldCount} fields"

#: app/frontend/components/v2/inbox/failed-message-group.tsx
msgid "{firstName} hasn't replied in over 24 hours. WhatsApp only allows freeform messages within 24 hours of the customer's last message — to keep talking, send an approved template."
msgstr "{firstName} hasn't replied in over 24 hours. WhatsApp only allows freeform messages within 24 hours of the customer's last message — to keep talking, send an approved template."

#: app/frontend/components/v2/voice/after-call-link-deal.tsx
msgid "{firstName}'s deals"
msgstr "{firstName}'s deals"

#: app/frontend/components/v2/inbox/compose/freeform-body.tsx
msgid "{label} — coming soon"
msgstr "{label} — coming soon"

#: app/frontend/components/v2/contacts/row-actions.tsx
msgid "{label} ({disabledTitle})"
msgstr "{label} ({disabledTitle})"

#: app/frontend/components/v2/chrome/mobile-bottom-nav.tsx
#: app/frontend/components/v2/deals/mobile-note-sheet.tsx
#: app/frontend/components/v2/deals/note-composer.tsx
msgid "{label} (coming soon)"
msgstr "{label} (coming soon)"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "{label} (wraps selection with {marker})"
msgstr "{label} (wraps selection with {marker})"

#: app/frontend/components/v2/settings/phone-numbers/buy/capability-toggle-row.tsx
msgid "{label} capability"
msgstr "{label} capability"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
msgid "{left} of {editsLimit} edits left in this 30-day window"
msgstr "{left} of {editsLimit} edits left in this 30-day window"

#: app/frontend/components/v2/drawer/entries/company-entry-body.tsx
#: app/frontend/pages/v2/contacts/show.tsx
msgid "{open} open"
msgstr "{open} open"

#: app/frontend/components/v2/inbox/attach-offer-card.tsx
msgid "{selectedCount} of {itemCount} selected"
msgstr "{selectedCount} of {itemCount} selected"

#: app/frontend/components/v2/assignees/assignee-picker.tsx
#: app/frontend/components/v2/settings/phone-numbers/reassign-answerers.tsx
msgid "{selectedCount} selected"
msgstr "{selectedCount} selected"

#: app/frontend/components/v2/deals/next-step-composer.tsx
msgid "{triggerLabel}"
msgstr "{triggerLabel}"

#. placeholder {0}: variableCount === 1 ? "" : "s"
#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "{variableCount} variable{0} · {charCount} / {BODY_MAX} chars"
msgstr "{variableCount} variable{0} · {charCount} / {BODY_MAX} chars"

#: app/frontend/components/v2/drawer/entries/company-entry-body.tsx
#: app/frontend/pages/v2/contacts/show.tsx
msgid "{won} won"
msgstr "{won} won"

#: app/frontend/components/v2/settings/billing/plan-card.tsx
msgid "/ seat / month"
msgstr "/ seat / month"

#: app/frontend/components/v2/landing/landing-footer.tsx
msgid "© 2026 Conecto. All rights reserved."
msgstr "© 2026 Conecto. All rights reserved."

#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "← Back"
msgstr "← Back"

#: app/frontend/pages/v2/dev/components/voice_card.tsx
msgid "↻ Reopen"
msgstr "↻ Reopen"

#: app/frontend/components/v2/deals/deal-contact-card.tsx
#: app/frontend/components/v2/deals/deal-contact-picker.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "+ Add"
msgstr "+ Add"

#: app/frontend/components/v2/inbox/contact-section.tsx
msgid "+ Add details"
msgstr "+ Add details"

#: app/frontend/components/v2/inbox/opportunity-actions-panel.tsx
msgid "+ Link existing"
msgstr "+ Link existing"

#: app/frontend/components/v2/inbox/opportunity-actions-panel.tsx
msgid "+ New opportunity"
msgstr "+ New opportunity"

#: app/frontend/components/v2/inbox/compose/composer-quick-replies-popover.tsx
#: app/frontend/components/v2/inbox/compose/composer-quick-replies.tsx
msgid "+ New shortcut"
msgstr "+ New shortcut"

#: app/frontend/pages/v2/contacts/show.tsx
msgid "+ Open chat"
msgstr "+ Open chat"

#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/components/v2/contacts/filter-popover.tsx
msgid "+ Save as view"
msgstr "+ Save as view"

#: app/frontend/components/v2/drawer/entries/contact-entry-body.tsx
msgid "+1 555 0123"
msgstr "+1 555 0123"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "+1 555 123 4567"
msgstr "+1 555 123 4567"

#: app/frontend/components/v2/deals/next-step-composer.tsx
msgid "⌘+Enter to save"
msgstr "⌘+Enter to save"

#: app/frontend/components/v2/inbox/compose/compose-modal.tsx
msgid "⌘+Enter to send · Esc to close"
msgstr "⌘+Enter to send · Esc to close"

#: app/frontend/components/v2/inbox/compose/freeform-body.tsx
msgid "★ AI draft available"
msgstr "★ AI draft available"

#: app/frontend/components/v2/inbox/template-picker.tsx
msgid "★ AI suggests · current"
msgstr "★ AI suggests · current"

#: app/frontend/components/v2/inbox/failed-template-expander.tsx
msgid "✓ AUTO"
msgstr "✓ AUTO"

#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "✨ from your call"
msgstr "✨ from your call"

#: app/frontend/components/v2/inbox/inbox-list.tsx
msgid "1 active"
msgstr "1 active"

#: app/frontend/pages/v2/companies/index.tsx
msgid "1 company needs enrichment this week."
msgstr "1 company needs enrichment this week."

#: app/frontend/components/v2/companies/index-list.tsx
msgid "1 deal"
msgstr "1 deal"

#: app/frontend/components/v2/settings/team/security-card.tsx
msgid "1 device"
msgstr "1 device"

#: app/frontend/components/v2/inbox/compose/staged-template.tsx
msgid "1 field needed"
msgstr "1 field needed"

#: app/frontend/components/v2/settings/team/team-member-row.tsx
msgid "1 more"
msgstr "1 more"

#: app/frontend/components/v2/settings/phone-numbers/buy/step-assign.tsx
#: app/frontend/components/v2/settings/phone-numbers/reassign-answerers.tsx
msgid "1 number"
msgstr "1 number"

#: app/frontend/components/v2/deals/deal-show-panel.tsx
#: app/frontend/components/v2/deals/mobile-deal-show-panel.tsx
#: app/frontend/components/v2/inbox/company-block.tsx
msgid "1 other deal"
msgstr "1 other deal"

#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
msgid "1 stage"
msgstr "1 stage"

#: app/frontend/components/v2/settings/team/answers-on-card.tsx
msgid "1 teammate"
msgstr "1 teammate"

#: app/frontend/components/v2/inbox/compose/composer-templates-popover.tsx
msgid "1 variable auto-filled"
msgstr "1 variable auto-filled"

#: app/frontend/components/v2/settings/billing/billing-period-toggle.tsx
msgid "2 months free"
msgstr "2 months free"

#: app/frontend/components/v2/deals/create-deal-modal.tsx
msgid "2-yr renewal"
msgstr "2-yr renewal"

#: app/frontend/components/v2/landing/feature-pipeline.tsx
msgid "24 deals · $1.2M"
msgstr "24 deals · $1.2M"

#: app/frontend/components/v2/inbox/compose/compose-modal.tsx
msgid "24-hour window open — freeform messages allowed."
msgstr "24-hour window open — freeform messages allowed."

#: app/frontend/components/v2/today/ai-accept-modal.tsx
#: app/frontend/components/v2/today/ai-accept-sheet.tsx
msgid "24h window open"
msgstr "24h window open"

#: app/frontend/components/v2/today/ai-accept-modal.tsx
msgid "3 variables auto-filled"
msgstr "3 variables auto-filled"

#: app/frontend/components/v2/today/ai-accept-sheet.tsx
msgid "3 vars auto-filled"
msgstr "3 vars auto-filled"

#: app/frontend/components/v2/landing/feature-today.tsx
msgid "5 of 12 done"
msgstr "5 of 12 done"

#: app/frontend/components/v2/landing/integrations.tsx
msgid "A CRM that fits your stack"
msgstr "A CRM that fits your stack"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "A map preview sits at the top of the message and opens the recipient's map app. Nothing to configure on the template."
msgstr "A map preview sits at the top of the message and opens the recipient's map app. Nothing to configure on the template."

#: app/frontend/components/v2/landing/landing-footer.tsx
msgid "About"
msgstr "About"

#: app/frontend/components/v2/suggestions/suggestion-card.tsx
#: app/frontend/components/v2/today/activity-row.tsx
#: app/frontend/components/v2/today/mobile-activity-row.tsx
msgid "Accept"
msgstr "Accept"

#: app/frontend/components/v2/settings/team/access-card.tsx
msgid "Access"
msgstr "Access"

#: app/frontend/lib/settings-nav.ts
msgid "Account"
msgstr "Account"

#: app/frontend/components/v2/chrome/user-menu.tsx
#: app/frontend/components/v2/chrome/user-menu.tsx
msgid "Account menu"
msgstr "Account menu"

#. placeholder {0}: stats.activeConversationContactsCount
#: app/frontend/pages/v2/contacts/index.tsx
msgid "across {0} {acrossContactsNoun}"
msgstr "across {0} {acrossContactsNoun}"

#. placeholder {0}: kpis.conversations.channelsCount
#: app/frontend/pages/v2/contacts/show.tsx
msgid "across {0} {channelNoun}"
msgstr "across {0} {channelNoun}"

#: app/frontend/pages/v2/contacts/index.tsx
msgid "Active"
msgstr "Active"

#: app/frontend/pages/v2/contacts/index.tsx
msgid "Active conversations"
msgstr "Active conversations"

#: app/frontend/components/v2/companies/index-toolbar.tsx
#: app/frontend/pages/v2/companies/index.tsx
#: app/frontend/pages/v2/companies/index.tsx
msgid "Active deals"
msgstr "Active deals"

#: app/frontend/components/v2/settings/usage/usage-stats.tsx
msgid "Active numbers"
msgstr "Active numbers"

#: app/frontend/components/v2/settings/team/security-card.tsx
msgid "Active sessions"
msgstr "Active sessions"

#: app/frontend/pages/v2/today/show.tsx
msgid "activities"
msgstr "activities"

#: app/frontend/pages/v2/today/show.tsx
msgid "activity"
msgstr "activity"

#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/components/v2/deals/activity-feed.tsx
#: app/frontend/components/v2/drawer/entries/contact-entry-body.tsx
#: app/frontend/pages/v2/contacts/show.tsx
#: app/frontend/pages/v2/contacts/show.tsx
msgid "Activity"
msgstr "Activity"

#: app/frontend/components/v2/deals/activity-facet-row.tsx
msgid "Activity facets"
msgstr "Activity facets"

#: app/frontend/components/v2/deals/activity-feed.tsx
msgid "Activity filters"
msgstr "Activity filters"

#: app/frontend/components/v2/contacts/create-contact-modal.tsx
#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/inbox/notes-section.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
#: app/frontend/pages/v2/settings/channels/show.tsx
msgid "Add"
msgstr "Add"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Add a header, footer, or buttons."
msgstr "Add a header, footer, or buttons."

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Add a name + description when editing"
msgstr "Add a name + description when editing"

#: app/frontend/components/v2/deals/mobile-note-sheet.tsx
#: app/frontend/components/v2/deals/mobile-note-sheet.tsx
#: app/frontend/components/v2/deals/mobile-note-sheet.tsx
#: app/frontend/components/v2/deals/note-composer.tsx
#: app/frontend/components/v2/deals/note-composer.tsx
#: app/frontend/components/v2/inbox/notes-section.tsx
#: app/frontend/components/v2/voice/active-call-widget.tsx
msgid "Add a note"
msgstr "Add a note"

#: app/frontend/components/v2/deals/note-composer.tsx
msgid "Add a note about this deal…"
msgstr "Add a note about this deal…"

#: app/frontend/components/v2/voice/after-call-card.tsx
msgid "Add a note for this call…"
msgstr "Add a note for this call…"

#: app/frontend/components/v2/inbox/notes-section.tsx
msgid "Add a note…"
msgstr "Add a note…"

#: app/frontend/components/v2/settings/team/answers-on-card.tsx
msgid "Add a number"
msgstr "Add a number"

#: app/frontend/components/v2/settings/team/answers-on-card.tsx
msgid "Add a number below to start routing calls and messages here."
msgstr "Add a number below to start routing calls and messages here."

#: app/frontend/components/v2/settings/phone-numbers/add-card-interstitial.tsx
#: app/frontend/components/v2/settings/phone-numbers/add-card-interstitial.tsx
msgid "Add a payment method"
msgstr "Add a payment method"

#: app/frontend/components/v2/settings/phone-numbers/add-card-interstitial.tsx
msgid "Add a payment method to buy numbers"
msgstr "Add a payment method to buy numbers"

#: app/frontend/components/v2/voice/after-call-card.tsx
msgid "Add a quick note…"
msgstr "Add a quick note…"

#: app/frontend/components/v2/contacts/create-contact-modal.tsx
msgid "Add an email or company and we’ll enrich the rest — from there and your conversations."
msgstr "Add an email or company and we’ll enrich the rest — from there and your conversations."

#: app/frontend/pages/v2/settings/channels/show.tsx
msgid "Add another"
msgstr "Add another"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Add button"
msgstr "Add button"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Add buttons"
msgstr "Add buttons"

#: app/frontend/components/v2/settings/phone-numbers/add-card-interstitial.tsx
msgid "Add card and continue"
msgstr "Add card and continue"

#: app/frontend/components/v2/contacts/create-contact-modal.tsx
#: app/frontend/components/v2/deals/deal-contact-picker.tsx
msgid "Add contact"
msgstr "Add contact"

#: app/frontend/components/v2/contacts/create-contact-modal.tsx
msgid "Add email or company"
msgstr "Add email or company"

#: app/frontend/lib/settings-nav.ts
msgid "Add fields to contacts and deals."
msgstr "Add fields to contacts and deals."

#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/components/v2/deals/filter-popover.tsx
#: app/frontend/components/v2/deals/filter-popover.tsx
msgid "Add filter"
msgstr "Add filter"

#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "Add follow-up"
msgstr "Add follow-up"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Add footer"
msgstr "Add footer"

#: app/frontend/components/v2/deals/deal-contact-picker.tsx
msgid "Add from {companyName}"
msgstr "Add from {companyName}"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Add header"
msgstr "Add header"

#: app/frontend/components/v2/deals/deal-contact-picker.tsx
#~ msgid "Add new contact (coming soon)"
#~ msgstr "Add new contact (coming soon)"

#: app/frontend/components/v2/deals/deal-contact-picker.tsx
#~ msgid "Add new contact…"
#~ msgstr "Add new contact…"

#: app/frontend/components/v2/deals/mobile-next-step-sheet.tsx
#: app/frontend/components/v2/deals/mobile-next-step-sheet.tsx
#: app/frontend/components/v2/deals/next-steps-section.tsx
#: app/frontend/components/v2/deals/next-steps-section.tsx
#: app/frontend/components/v2/deals/next-steps-section.tsx
#: app/frontend/components/v2/deals/next-steps-section.tsx
msgid "Add next step"
msgstr "Add next step"

#: app/frontend/components/v2/deals/activity-feed.tsx
msgid "Add note"
msgstr "Add note"

#: app/frontend/components/v2/settings/team/answers-on-card.tsx
msgid "Add number"
msgstr "Add number"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Add one {{1}} to personalize the link — Meta needs a sample value."
msgstr "Add one {{1}} to personalize the link — Meta needs a sample value."

#: app/frontend/components/v2/deals/deal-contact-card.tsx
#: app/frontend/components/v2/deals/deal-contact-card.tsx
msgid "Add role"
msgstr "Add role"

#: app/frontend/components/v2/contacts/create-contact-modal.tsx
msgid "Add someone you’re talking to"
msgstr "Add someone you’re talking to"

#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
msgid "Add stage"
msgstr "Add stage"

#: app/frontend/components/v2/deals/pipeline-board.tsx
msgid "Add stages to your pipeline to start tracking deals through your sales process."
msgstr "Add stages to your pipeline to start tracking deals through your sales process."

#: app/frontend/components/v2/inbox/create-opportunity-panel.tsx
msgid "Add the numbers"
msgstr "Add the numbers"

#. placeholder {0}: deal.name
#: app/frontend/components/v2/deals/mobile-history-fab-picker.tsx
msgid "Add to {0}"
msgstr "Add to {0}"

#: app/frontend/components/v2/deals/mobile-history-fab-picker.tsx
msgid "Add to history"
msgstr "Add to history"

#: app/frontend/components/v2/contacts/filter-popover.tsx
msgid "Add value"
msgstr "Add value"

#: app/frontend/components/v2/contacts/create-contact-modal.tsx
#: app/frontend/components/v2/contacts/create-contact-modal.tsx
#: app/frontend/components/v2/suggestions/suggestion-card.tsx
msgid "Adding…"
msgstr "Adding…"

#: app/frontend/components/v2/settings/team/profile-card.tsx
#: app/frontend/components/v2/settings/team/teammate-hero.tsx
msgid "Admin"
msgstr "Admin"

#: app/frontend/components/v2/settings/team/voice-calling-card.tsx
msgid "Admin override coming soon. For now teammates set this themselves from their own status strip."
msgstr "Admin override coming soon. For now teammates set this themselves from their own status strip."

#: app/frontend/components/v2/settings/team/team-filter-chips.tsx
msgid "Admins"
msgstr "Admins"

#: app/frontend/components/v2/voice/after-call-card.tsx
msgid "After call"
msgstr "After call"

#: app/frontend/components/v2/settings/team/team-filter-chips.tsx
msgid "Agents"
msgstr "Agents"

#: app/frontend/components/v2/messages/outbound-sender-avatar.tsx
#: app/frontend/components/v2/today/mobile-tabs.tsx
msgid "AI"
msgstr "AI"

#: app/frontend/components/v2/voice/call-detail-panel.tsx
msgid "AI · may contain errors"
msgstr "AI · may contain errors"

#: app/frontend/components/v2/settings/usage/usage-stats.tsx
msgid "AI actions"
msgstr "AI actions"

#: app/frontend/components/v2/inbox/rail.tsx
#: app/frontend/components/v2/inbox/sidebar.tsx
msgid "AI assistants"
msgstr "AI assistants"

#: app/frontend/components/v2/inbox/failed-message-group.tsx
msgid "AI attempted to send"
msgstr "AI attempted to send"

#: app/frontend/lib/settings-nav.ts
#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "AI behavior"
msgstr "AI behavior"

#. placeholder {0}: stats.newThisWeek
#: app/frontend/pages/v2/contacts/index.tsx
msgid "AI captured {0} new {newNoun} this week."
msgstr "AI captured {0} new {newNoun} this week."

#: app/frontend/components/v2/contacts/index-header.tsx
msgid "AI captured {count} new contacts this week from inbound conversations."
msgstr "AI captured {count} new contacts this week from inbound conversations."

#: app/frontend/components/v2/contacts/index-header.tsx
msgid "AI captured 1 new contact this week."
msgstr "AI captured 1 new contact this week."

#: app/frontend/components/v2/voice/after-call-card.tsx
msgid "AI drafted from the call"
msgstr "AI drafted from the call"

#: app/frontend/components/v2/settings/usage/included-card.tsx
msgid "AI hasn't needed to step in yet — it'll show up here as it helps."
msgstr "AI hasn't needed to step in yet — it'll show up here as it helps."

#: app/frontend/components/v2/voice/active-call-widget.tsx
msgid "AI is listening · live transcript"
msgstr "AI is listening · live transcript"

#: app/frontend/components/v2/contacts/index-toolbar.tsx
msgid "AI needs you"
msgstr "AI needs you"

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "AI on duty"
msgstr "AI on duty"

#: app/frontend/pages/v2/contacts/index.tsx
#: app/frontend/pages/v2/contacts/index.tsx
msgid "AI paused"
msgstr "AI paused"

#: app/frontend/components/v2/deals/ai-paused-banner.tsx
#: app/frontend/components/v2/deals/ai-paused-banner.tsx
msgid "AI paused for your call"
msgstr "AI paused for your call"

#: app/frontend/components/v2/voice/after-call-more-sheet.tsx
msgid "AI picked this deal — confirm it's the right one."
msgstr "AI picked this deal — confirm it's the right one."

#: app/frontend/components/v2/inbox/message-bubble.tsx
msgid "AI replied for you"
msgstr "AI replied for you"

#: app/frontend/components/v2/deals/next-steps-section.tsx
#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/inbox/suggested-next-step-row.tsx
#: app/frontend/components/v2/today/activity-row.tsx
#: app/frontend/components/v2/today/mobile-activity-row.tsx
#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "AI suggested"
msgstr "AI suggested"

#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "AI suggested · dismissed"
msgstr "AI suggested · dismissed"

#: app/frontend/components/v2/inbox/failed-template-expander.tsx
msgid "AI suggests"
msgstr "AI suggests"

#: app/frontend/components/v2/inbox/deal-proposal-card.tsx
msgid "AI suggests a deal"
msgstr "AI suggests a deal"

#: app/frontend/components/v2/settings/team/voice-calling-card.tsx
msgid "AI suggests prompts during the call."
msgstr "AI suggests prompts during the call."

#: app/frontend/components/v2/voice/after-call-card.tsx
#: app/frontend/components/v2/voice/after-call-transcript.tsx
#: app/frontend/components/v2/voice/call-detail-panel.tsx
msgid "AI summary"
msgstr "AI summary"

#: app/frontend/components/v2/voice/after-call-more-sheet.tsx
msgid "AI thinks this call advanced the stage"
msgstr "AI thinks this call advanced the stage"

#: app/frontend/components/v2/inbox/compose/compose-modal.tsx
msgid "AI will suggest a starter template once a contact is selected."
msgstr "AI will suggest a starter template once a contact is selected."

#: app/frontend/components/v2/inbox/linked-deal-section.tsx
msgid "AI will suggest one once it learns more."
msgstr "AI will suggest one once it learns more."

#: app/frontend/components/v2/voice/incoming-call-sheet.tsx
msgid "AI will transcribe this call"
msgstr "AI will transcribe this call"

#: app/frontend/components/v2/companies/pill.tsx
msgid "AI working"
msgstr "AI working"

#: app/frontend/components/v2/voice/after-call-card.tsx
msgid "AI-detected"
msgstr "AI-detected"

#: app/frontend/components/v2/auth/auth-layout.tsx
msgid "AI-native CRM"
msgstr "AI-native CRM"

#: app/frontend/components/v2/companies/index-toolbar.tsx
#: app/frontend/components/v2/contacts/index-toolbar.tsx
#: app/frontend/components/v2/deals/activity-feed.tsx
#: app/frontend/components/v2/inbox/filter-pills.tsx
#: app/frontend/components/v2/notifications/notifications-list-content.tsx
#: app/frontend/components/v2/settings/team/team-filter-chips.tsx
#: app/frontend/lib/phone-number-display.ts
#: app/frontend/pages/v2/companies/index.tsx
#: app/frontend/pages/v2/notifications/index.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/index.tsx
#: app/frontend/types/v2/search.ts
msgid "All"
msgstr "All"

#: app/frontend/components/v2/settings/team/access-card.tsx
msgid "All deals"
msgstr "All deals"

#: app/frontend/components/v2/inbox/teammates-sub-view.tsx
msgid "All teammates"
msgstr "All teammates"

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/index.tsx
msgid "All templates"
msgstr "All templates"

#: app/frontend/pages/v2/registrations/new.tsx
msgid "Already have an account?"
msgstr "Already have an account?"

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "Already suggested on this call"
msgstr "Already suggested on this call"

#: app/frontend/components/v2/deals/deal-contact-picker.tsx
#~ msgid "Also at {companyName}"
#~ msgstr "Also at {companyName}"

#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "Also dismiss this suggestion?"
msgstr "Also dismiss this suggestion?"

#: app/frontend/components/v2/deals/deal-contact-picker.tsx
#~ msgid "Also linked"
#~ msgstr "Also linked"

#: app/frontend/components/v2/inbox/message-bubble.tsx
#: app/frontend/components/v2/voice/after-call-card.tsx
#: app/frontend/components/v2/voice/call-row.tsx
msgid "Analyzing call…"
msgstr "Analyzing call…"

#: app/frontend/components/v2/voice/call-detail-panel.tsx
msgid "Analyzing…"
msgstr "Analyzing…"

#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/components/v2/deals/filter-popover.tsx
msgid "and"
msgstr "and"

#: app/frontend/components/v2/settings/billing/billing-period-toggle.tsx
msgid "Annual"
msgstr "Annual"

#: app/frontend/components/v2/voice/incoming-call-sheet.tsx
msgid "Answer"
msgstr "Answer"

#: app/frontend/components/v2/voice/incoming-call-sheet.tsx
msgid "Answer call"
msgstr "Answer call"

#: app/frontend/components/v2/settings/team/team-member-row.tsx
msgid "Answers"
msgstr "Answers"

#: app/frontend/components/v2/settings/team/answers-on-card.tsx
#: app/frontend/components/v2/settings/team/team-members-table.tsx
msgid "Answers on"
msgstr "Answers on"

#: app/frontend/lib/settings-nav.ts
msgid "API keys"
msgstr "API keys"

#: app/frontend/components/v2/auth/oauth-buttons.tsx
msgid "Apple sign-in is coming soon"
msgstr "Apple sign-in is coming soon"

#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/components/v2/deals/filter-popover.tsx
msgid "Apply"
msgstr "Apply"

#. placeholder {0}: previewCount.toLocaleString("en-US")
#: app/frontend/components/v2/contacts/filter-popover.tsx
msgid "Apply · {0} {contactsNoun}"
msgstr "Apply · {0} {contactsNoun}"

#. placeholder {0}: previewCount.toLocaleString("en-US")
#: app/frontend/components/v2/deals/filter-popover.tsx
msgid "Apply · {0} deal"
msgstr "Apply · {0} deal"

#. placeholder {0}: previewCount.toLocaleString("en-US")
#: app/frontend/components/v2/deals/filter-popover.tsx
msgid "Apply · {0} deals"
msgstr "Apply · {0} deals"

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Approve before send"
msgstr "Approve before send"

#: app/frontend/components/v2/whatsapp-templates/follow-up-template-card.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/index.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/index.tsx
msgid "Approved"
msgstr "Approved"

#: app/frontend/components/v2/today/ai-accept-sheet.tsx
msgid "APPROVED"
msgstr "APPROVED"

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Approved {approvedAge}"
msgstr "Approved {approvedAge}"

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "Approved templates"
msgstr "Approved templates"

#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
#: app/frontend/components/v2/inline-edit/date-popover.tsx
msgid "April"
msgstr "April"

#: app/frontend/components/v2/deals/deal-more-menu.tsx
#: app/frontend/components/v2/deals/deal-more-menu.tsx
#: app/frontend/components/v2/inbox/conversation-archive-confirm-sheet.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Archive"
msgstr "Archive"

#: app/frontend/components/v2/inbox/conversation-archive-confirm-sheet.tsx
#: app/frontend/components/v2/inbox/conversation-archive-confirm-sheet.tsx
#: app/frontend/components/v2/inbox/conversation-more-menu.tsx
msgid "Archive conversation"
msgstr "Archive conversation"

#: app/frontend/components/v2/inbox/conversation-archive-confirm-sheet.tsx
msgid "Archive this conversation?"
msgstr "Archive this conversation?"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "As {recipientLabel} will see it"
msgstr "As {recipientLabel} will see it"

#: app/frontend/components/v2/inbox/compose/composer-actions-sheet.tsx
msgid "Ask AI"
msgstr "Ask AI"

#: app/frontend/components/v2/inbox/chat-header.tsx
#: app/frontend/types/v2/buy-number.ts
msgid "Assign"
msgstr "Assign"

#: app/frontend/components/v2/contacts/contact-assignees-cell.tsx
#: app/frontend/components/v2/settings/phone-numbers/answerer-cell.tsx
msgid "Assign →"
msgstr "Assign →"

#: app/frontend/components/v2/inbox/assignment-popover.tsx
msgid "Assign conversation"
msgstr "Assign conversation"

#: app/frontend/lib/phone-number-display.ts
msgid "Assigned"
msgstr "Assigned"

#: app/frontend/components/v2/settings/team/access-card.tsx
msgid "Assigned conversations"
msgstr "Assigned conversations"

#: app/frontend/components/v2/settings/phone-numbers/buy/step-confirm.tsx
#: app/frontend/components/v2/settings/phone-numbers/phone-numbers-table.tsx
msgid "Assigned to"
msgstr "Assigned to"

#: app/frontend/components/v2/deals/next-step-composer.tsx
#~ msgid "ASSIGNED TO"
#~ msgstr "ASSIGNED TO"

#. placeholder {0}: assignee.name
#: app/frontend/components/v2/inbox/chat-header.tsx
msgid "Assigned to {0}"
msgstr "Assigned to {0}"

#: app/frontend/pages/v2/notifications/index.tsx
msgid "Assigned to me"
msgstr "Assigned to me"

#: app/frontend/components/v2/deals/next-step-composer.tsx
#: app/frontend/components/v2/deals/next-step-composer.tsx
#: app/frontend/components/v2/inbox/filter-panel.tsx
msgid "Assignee"
msgstr "Assignee"

#: app/frontend/components/v2/inbox/conversation-snooze-date-picker-sheet.tsx
msgid "at"
msgstr "at"

#: app/frontend/components/v2/inbox/compose/composer-attach-popover.tsx
msgid "Attach"
msgstr "Attach"

#: app/frontend/components/v2/inbox/attach-offer-card.tsx
msgid "Attach {selectedCount}"
msgstr "Attach {selectedCount}"

#: app/frontend/components/v2/deals/mobile-note-sheet.tsx
#: app/frontend/components/v2/deals/note-composer.tsx
#: app/frontend/components/v2/inbox/chat-panel.tsx
#: app/frontend/components/v2/inbox/compose/freeform-body.tsx
msgid "Attach file"
msgstr "Attach file"

#: app/frontend/components/v2/inbox/chat-panel.tsx
msgid "Attach image"
msgstr "Attach image"

#. placeholder {0}: offer.dealName
#: app/frontend/components/v2/inbox/attach-offer-card.tsx
msgid "Attach to {0}?"
msgstr "Attach to {0}?"

#: app/frontend/components/v2/inbox/attach-offer-card.tsx
msgid "Attaching…"
msgstr "Attaching…"

#: app/frontend/lib/settings-nav.ts
msgid "Audit log"
msgstr "Audit log"

#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
#: app/frontend/components/v2/inline-edit/date-popover.tsx
msgid "August"
msgstr "August"

#: app/frontend/components/v2/inbox/template-picker.tsx
msgid "Auth"
msgstr "Auth"

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Auto-escalate"
msgstr "Auto-escalate"

#: app/frontend/components/v2/voice/after-call-transcript.tsx
msgid "Auto-transcribed · tap a line to seek"
msgstr "Auto-transcribed · tap a line to seek"

#: app/frontend/components/v2/landing/landing-footer.tsx
#: app/frontend/lib/settings-nav.ts
msgid "Automations"
msgstr "Automations"

#: app/frontend/components/v2/chrome/status-strip.tsx
msgid "Availability"
msgstr "Availability"

#: app/frontend/components/v2/chrome/status-strip.tsx
#: app/frontend/components/v2/chrome/status-strip.tsx
#: app/frontend/components/v2/settings/team/teammate-hero.tsx
#: app/frontend/pages/v2/settings/channels/show.tsx
#: app/frontend/pages/v2/settings/channels/show.tsx
msgid "Available"
msgstr "Available"

#: app/frontend/components/v2/settings/team/voice-calling-card.tsx
msgid "Available for calls"
msgstr "Available for calls"

#: app/frontend/components/v2/settings/team/teammate-stats.tsx
msgid "Avg call duration"
msgstr "Avg call duration"

#: app/frontend/pages/v2/companies/index.tsx
msgid "Awaiting enrichment"
msgstr "Awaiting enrichment"

#: app/frontend/components/v2/chrome/status-strip.tsx
#: app/frontend/components/v2/chrome/status-strip.tsx
#: app/frontend/components/v2/settings/team/teammate-hero.tsx
msgid "Away"
msgstr "Away"

#: app/frontend/components/v2/chrome/smart-back-link.tsx
#: app/frontend/components/v2/companies/page-shell.tsx
#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/components/v2/deals/mobile-deal-show-panel.tsx
#: app/frontend/components/v2/inbox/create-opportunity-panel.tsx
#: app/frontend/components/v2/inbox/sub-sheet-header.tsx
#: app/frontend/components/v2/settings/phone-numbers/buy/wizard-frame.tsx
#: app/frontend/components/v2/voice/after-call-subview-header.tsx
#: app/frontend/components/v2/voice/after-call-transcript.tsx
#: app/frontend/components/v2/voice/call-detail-panel.tsx
#: app/frontend/pages/v2/notifications/index.tsx
#: app/frontend/pages/v2/settings/team/show.tsx
msgid "Back"
msgstr "Back"

#. placeholder {0}: fallbackLabel.toLowerCase()
#: app/frontend/components/v2/chrome/smart-back-link.tsx
msgid "Back to {0}"
msgstr "Back to {0}"

#: app/frontend/pages/v2/deals/show.tsx
msgid "Back to deals"
msgstr "Back to deals"

#: app/frontend/components/v2/inbox/filter-sheet.tsx
msgid "Back to filters"
msgstr "Back to filters"

#: app/frontend/components/v2/inbox/mobile-conversation-detail.tsx
msgid "Back to inbox"
msgstr "Back to inbox"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Basics"
msgstr "Basics"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
msgid "Before you resubmit"
msgstr "Before you resubmit"

#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Before you submit"
msgstr "Before you submit"

#: app/frontend/components/v2/search/search-results-list.tsx
msgid "Best matches"
msgstr "Best matches"

#. placeholder {0}: plan.annual!.totalFormatted
#: app/frontend/components/v2/settings/billing/plan-card.tsx
msgid "Billed annually · {0}/yr"
msgstr "Billed annually · {0}/yr"

#: app/frontend/components/v2/settings/billing/plan-card.tsx
msgid "Billed monthly"
msgstr "Billed monthly"

#: app/frontend/lib/settings-nav.ts
msgid "Billing"
msgstr "Billing"

#: app/frontend/components/v2/settings/usage/period-toggle.tsx
msgid "Billing period"
msgstr "Billing period"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Body"
msgstr "Body"

#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Body doesn't include promotional copy that could mis-classify the template"
msgstr "Body doesn't include promotional copy that could mis-classify the template"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Body status"
msgstr "Body status"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
msgid "Body still under 1024 characters"
msgstr "Body still under 1024 characters"

#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Body under 1024 characters"
msgstr "Body under 1024 characters"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Bold"
msgstr "Bold"

#: app/frontend/components/v2/landing/landing-footer.tsx
msgid "Book a demo"
msgstr "Book a demo"

#: app/frontend/pages/v2/contacts/show.tsx
msgid "Breadcrumb"
msgstr "Breadcrumb"

#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "Bring back"
msgstr "Bring back"

#: app/frontend/components/v2/settings/phone-numbers/buy/step-country.tsx
msgid "Browse all countries →"
msgstr "Browse all countries →"

#: app/frontend/components/v2/deals/mobile-note-sheet.tsx
#: app/frontend/components/v2/deals/note-composer.tsx
msgid "Bulleted list"
msgstr "Bulleted list"

#: app/frontend/lib/settings-nav.ts
msgid "Business name, branding, and time zone."
msgstr "Business name, branding, and time zone."

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Business number"
msgstr "Business number"

#: app/frontend/components/v2/voice/after-call-card.tsx
#: app/frontend/lib/voice-disposition.ts
msgid "Busy"
msgstr "Busy"

#: app/frontend/lib/voice-disposition.ts
msgid "Busy — couldn't connect"
msgstr "Busy — couldn't connect"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Button text"
msgstr "Button text"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Button type"
msgstr "Button type"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Buttons"
msgstr "Buttons"

#: app/frontend/components/v2/settings/phone-numbers/buy-number-button.tsx
#: app/frontend/pages/v2/settings/phone_numbers/index.tsx
msgid "Buy a number"
msgstr "Buy a number"

#. placeholder {0}: stepIndex + 1
#: app/frontend/components/v2/settings/phone-numbers/buy/wizard-frame.tsx
msgid "BUY A NUMBER · STEP {0} OF {totalSteps} · {crumb}"
msgstr "BUY A NUMBER · STEP {0} OF {totalSteps} · {crumb}"

#: app/frontend/components/v2/settings/phone-numbers/empty-state.tsx
msgid "Buy a number to start making calls, sending SMS, or routing WhatsApp through your business. You can assign it to a teammate or let AI answer."
msgstr "Buy a number to start making calls, sending SMS, or routing WhatsApp through your business. You can assign it to a teammate or let AI answer."

#: app/frontend/pages/v2/settings/phone_numbers/new.tsx
msgid "Buy number"
msgstr "Buy number"

#: app/frontend/lib/settings-nav.ts
msgid "Buy numbers and assign answerers."
msgstr "Buy numbers and assign answerers."

#: app/frontend/components/v2/settings/phone-numbers/empty-state.tsx
msgid "Buy your first number"
msgstr "Buy your first number"

#: app/frontend/components/v2/contacts/index-toolbar.tsx
msgid "By AI"
msgstr "By AI"

#: app/frontend/components/v2/settings/phone-numbers/buy/step-confirm.tsx
msgid "Calculating your total…"
msgstr "Calculating your total…"

#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/components/v2/contacts/row-actions.tsx
#: app/frontend/components/v2/deals/deal-contact-card.tsx
#: app/frontend/components/v2/deals/next-steps-section.tsx
#: app/frontend/components/v2/drawer/drawer.tsx
#: app/frontend/components/v2/drawer/entries/contact-entry-body.tsx
#: app/frontend/components/v2/drawer/entries/contact-entry-body.tsx
#: app/frontend/components/v2/inbox/header-call-button.tsx
#: app/frontend/components/v2/today/call-next-step-button.tsx
#: app/frontend/components/v2/today/call-next-step-button.tsx
#: app/frontend/components/v2/voice/after-call-transcript.tsx
#: app/frontend/components/v2/voice/call-detail-panel.tsx
#: app/frontend/components/v2/voice/softphone.tsx
#: app/frontend/lib/follow-up-method.ts
#: app/frontend/lib/follow-up-method.ts
#: app/frontend/lib/follow-up-method.ts
#: app/frontend/lib/follow-up-method.ts
#: app/frontend/pages/v2/contacts/show.tsx
#: app/frontend/pages/v2/contacts/show.tsx
msgid "Call"
msgstr "Call"

#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/components/v2/deals/deal-contact-card.tsx
#: app/frontend/components/v2/drawer/entries/contact-entry-body.tsx
#: app/frontend/components/v2/inbox/header-call-button.tsx
#: app/frontend/components/v2/today/call-next-step-button.tsx
#: app/frontend/pages/v2/contacts/show.tsx
msgid "Call ({disabledReason})"
msgstr "Call ({disabledReason})"

#. placeholder {0}: contact.phone
#: app/frontend/components/v2/inbox/other-ways-popover.tsx
msgid "Call {0}"
msgstr "Call {0}"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Call button phone number"
msgstr "Call button phone number"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Call button text"
msgstr "Call button text"

#: app/frontend/components/v2/voice/call-transcript-overlay.tsx
msgid "Call detail"
msgstr "Call detail"

#: app/frontend/components/v2/voice/active-call-widget.tsx
msgid "Call ended"
msgstr "Call ended"

#. placeholder {0}: formatDuration(voiceCall.durationSeconds ?? 0)
#: app/frontend/components/v2/voice/after-call-card.tsx
msgid "Call ended · {0}"
msgstr "Call ended · {0}"

#: app/frontend/components/v2/voice/after-call-card.tsx
#: app/frontend/components/v2/voice/after-call-card.tsx
msgid "Call note"
msgstr "Call note"

#: app/frontend/components/v2/voice/after-call-card.tsx
msgid "Call outcome"
msgstr "Call outcome"

#: app/frontend/components/v2/whatsapp-templates/template-editor-utils.ts
msgid "Call phone"
msgstr "Call phone"

#: app/frontend/components/v2/inbox/message-bubble.tsx
msgid "Call too short to summarize"
msgstr "Call too short to summarize"

#: app/frontend/components/v2/voice/after-call-transcript.tsx
msgid "Call with {name}"
msgstr "Call with {name}"

#: app/frontend/components/v2/settings/team/voice-calling-card.tsx
msgid "Calling, recording, and AI assist for this teammate."
msgstr "Calling, recording, and AI assist for this teammate."

#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/components/v2/drawer/entries/contact-entry-body.tsx
#: app/frontend/components/v2/today/call-next-step-button.tsx
#: app/frontend/components/v2/voice/active-call-widget.tsx
#: app/frontend/pages/v2/contacts/show.tsx
msgid "Calling…"
msgstr "Calling…"

#: app/frontend/components/v2/deals/activity-feed.tsx
msgid "Calls"
msgstr "Calls"

#: app/frontend/components/v2/chrome/status-strip.tsx
msgid "Calls go to voicemail, messages queue"
msgstr "Calls go to voicemail, messages queue"

#: app/frontend/components/v2/settings/team/teammate-stats.tsx
msgid "Calls this week"
msgstr "Calls this week"

#: app/frontend/components/v2/inbox/compose/composer-actions-sheet.tsx
msgid "Camera"
msgstr "Camera"

#: app/frontend/components/v2/settings/team/access-card.tsx
msgid "Can edit AI behavior"
msgstr "Can edit AI behavior"

#: app/frontend/components/v2/settings/team/access-card.tsx
msgid "Can invite teammates"
msgstr "Can invite teammates"

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "Can't message {firstName} on WhatsApp yet"
msgstr "Can't message {firstName} on WhatsApp yet"

#: app/frontend/components/v2/chrome/mobile-search-overlay.tsx
#: app/frontend/components/v2/contacts/create-contact-modal.tsx
#: app/frontend/components/v2/contacts/create-contact-modal.tsx
#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/components/v2/deals/create-deal-modal.tsx
#: app/frontend/components/v2/deals/create-deal-modal.tsx
#: app/frontend/components/v2/deals/deal-properties-card.tsx
#: app/frontend/components/v2/deals/filter-popover.tsx
#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
#: app/frontend/components/v2/deals/mobile-next-step-sheet.tsx
#: app/frontend/components/v2/deals/mobile-note-sheet.tsx
#: app/frontend/components/v2/deals/mobile-stage-picker.tsx
#: app/frontend/components/v2/deals/next-step-composer.tsx
#: app/frontend/components/v2/deals/next-steps-section.tsx
#: app/frontend/components/v2/deals/note-composer.tsx
#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
#: app/frontend/components/v2/filters/saved-view-list.tsx
#: app/frontend/components/v2/inbox/compose/compose-modal.tsx
#: app/frontend/components/v2/inbox/compose/compose-modal.tsx
#: app/frontend/components/v2/inbox/compose/composer-templates-popover.tsx
#: app/frontend/components/v2/inbox/compose/staged-template.tsx
#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/inbox/conversation-archive-confirm-sheet.tsx
#: app/frontend/components/v2/inbox/conversation-more-menu.tsx
#: app/frontend/components/v2/inbox/conversation-reassign-sheet.tsx
#: app/frontend/components/v2/inbox/conversation-snooze-date-picker-sheet.tsx
#: app/frontend/components/v2/inbox/conversation-snooze-sheet.tsx
#: app/frontend/components/v2/inbox/create-opportunity-panel.tsx
#: app/frontend/components/v2/inbox/deal-proposal-card.tsx
#: app/frontend/components/v2/inbox/filter-panel.tsx
#: app/frontend/components/v2/inbox/link-opportunity-panel.tsx
#: app/frontend/components/v2/inbox/mobile-row-inline-editor.tsx
#: app/frontend/components/v2/inbox/notes-section.tsx
#: app/frontend/components/v2/inbox/notes-section.tsx
#: app/frontend/components/v2/inbox/notes-section.tsx
#: app/frontend/components/v2/inbox/template-picker-bottom-sheet.tsx
#: app/frontend/components/v2/inbox/template-picker-popover.tsx
#: app/frontend/components/v2/inline-edit/inline-text-edit-row.tsx
#: app/frontend/components/v2/settings/phone-numbers/buy/wizard-frame.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Cancel"
msgstr "Cancel"

#: app/frontend/components/v2/inbox/compose/staged-template.tsx
msgid "Cancel template"
msgstr "Cancel template"

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "Cancel watch"
msgstr "Cancel watch"

#: app/frontend/components/v2/settings/phone-numbers/buy/step-confirm.tsx
#: app/frontend/components/v2/settings/phone-numbers/phone-numbers-table.tsx
#: app/frontend/types/v2/buy-number.ts
msgid "Capabilities"
msgstr "Capabilities"

#: app/frontend/components/v2/landing/feature-capture.tsx
msgid "Capture"
msgstr "Capture"

#: app/frontend/components/v2/deals/mobile-history-fab-picker.tsx
msgid "Capture context, decisions, or @mention a teammate. No due date."
msgstr "Capture context, decisions, or @mention a teammate. No due date."

#: app/frontend/pages/v2/dev/components/voice_card.tsx
msgid "Card"
msgstr "Card"

#: app/frontend/components/v2/landing/landing-footer.tsx
msgid "Careers"
msgstr "Careers"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/index.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Category"
msgstr "Category"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
msgid "Category is locked for approved templates. Reject or pause it to change category."
msgstr "Category is locked for approved templates. Reject or pause it to change category."

#: app/frontend/components/v2/inbox/compose/staged-template.tsx
#: app/frontend/components/v2/inbox/compose/template-body.tsx
#: app/frontend/components/v2/settings/phone-numbers/buy/step-confirm.tsx
#: app/frontend/components/v2/settings/phone-numbers/buy/step-confirm.tsx
#: app/frontend/components/v2/voice/after-call-card.tsx
#: app/frontend/components/v2/voice/after-call-link-deal.tsx
#: app/frontend/components/v2/voice/after-call-more-sheet.tsx
#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
#: app/frontend/components/v2/voice/call-detail-panel.tsx
msgid "Change"
msgstr "Change"

#: app/frontend/components/v2/whatsapp-templates/follow-up-template-card.tsx
msgid "Change ▾"
msgstr "Change ▾"

#: app/frontend/components/v2/voice/after-call-card.tsx
msgid "Change deal"
msgstr "Change deal"

#. placeholder {0}: deal.name
#: app/frontend/components/v2/deals/deal-card.tsx
msgid "Change owners for {0}"
msgstr "Change owners for {0}"

#: app/frontend/components/v2/deals/mobile-deal-contact-card.tsx
#: app/frontend/components/v2/deals/mobile-deal-contact-card.tsx
#~ msgid "Change primary contact"
#~ msgstr "Change primary contact"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
msgid "Changes don't shift this template into Marketing (different pricing tier)"
msgstr "Changes don't shift this template into Marketing (different pricing tier)"

#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/pages/v2/contacts/show.tsx
msgid "channel"
msgstr "channel"

#: app/frontend/components/v2/inbox/filter-panel.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/index.tsx
#: app/frontend/types/v2/contact-filters.ts
msgid "Channel"
msgstr "Channel"

#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/pages/v2/contacts/show.tsx
msgid "channels"
msgstr "channels"

#: app/frontend/lib/settings-nav.ts
#: app/frontend/pages/v2/settings/channels/show.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Channels"
msgstr "Channels"

#: app/frontend/lib/settings-nav.ts
msgid "Channels & AI"
msgstr "Channels & AI"

#: app/frontend/components/v2/settings/phone-numbers/buy/step-confirm.tsx
msgid "Charged today"
msgstr "Charged today"

#. placeholder {0}: item.ok ? "ok" : "not satisfied"
#. placeholder {1}: item.label
#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
msgid "Checklist item {0}: {1}"
msgstr "Checklist item {0}: {1}"

#: app/frontend/pages/v2/settings/billing/show.tsx
msgid "Checkout cancelled — no charge was made."
msgstr "Checkout cancelled — no charge was made."

#: app/frontend/components/v2/whatsapp-templates/follow-up-template-card.tsx
msgid "Choose a follow-up template"
msgstr "Choose a follow-up template"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Choose a source…"
msgstr "Choose a source…"

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "Choose a template"
msgstr "Choose a template"

#: app/frontend/components/v2/voice/call-detail-panel.tsx
msgid "Choose call outcome"
msgstr "Choose call outcome"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Choose header media file"
msgstr "Choose header media file"

#: app/frontend/components/v2/settings/phone-numbers/buy/step-capabilities.tsx
msgid "Choose what this number can do."
msgstr "Choose what this number can do."

#: app/frontend/pages/v2/settings/billing/show.tsx
msgid "Choose your plan"
msgstr "Choose your plan"

#: app/frontend/components/v2/companies/index-toolbar.tsx
#: app/frontend/pages/v2/companies/index.tsx
msgid "Churned"
msgstr "Churned"

#: app/frontend/components/v2/deals/deal-properties-card.tsx
#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
msgid "Clear"
msgstr "Clear"

#. placeholder {0}: group.label
#: app/frontend/components/v2/deals/activity-facet-row.tsx
msgid "Clear {0} filter"
msgstr "Clear {0} filter"

#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/components/v2/deals/filter-popover.tsx
#: app/frontend/components/v2/deals/filter-popover.tsx
#: app/frontend/components/v2/inbox/filter-panel.tsx
#: app/frontend/components/v2/inbox/filter-sheet.tsx
msgid "Clear all"
msgstr "Clear all"

#: app/frontend/components/v2/contacts/active-filter-chips.tsx
msgid "Clear filters"
msgstr "Clear filters"

#: app/frontend/components/v2/inbox/compose/recipient-picker.tsx
msgid "Clear recipient"
msgstr "Clear recipient"

#: app/frontend/components/v2/chrome/mobile-search-overlay.tsx
#: app/frontend/components/v2/inbox/inbox-list.tsx
#: app/frontend/components/v2/search/search-input.tsx
msgid "Clear search"
msgstr "Clear search"

#: app/frontend/components/v2/contacts/create-contact-modal.tsx
#: app/frontend/components/v2/deals/create-deal-modal.tsx
#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
#: app/frontend/components/v2/inbox/compose/compose-modal.tsx
#: app/frontend/components/v2/inbox/compose/composer-actions-sheet.tsx
#: app/frontend/components/v2/inbox/compose/composer-quick-replies-popover.tsx
#: app/frontend/components/v2/inbox/compose/composer-quick-replies-sheet.tsx
#: app/frontend/components/v2/inbox/failed-template-expander.tsx
#: app/frontend/components/v2/inbox/linked-deal-section.tsx
#: app/frontend/components/v2/settings/phone-numbers/buy/wizard-frame.tsx
#: app/frontend/components/v2/settings/team/danger-zone-card.tsx
#: app/frontend/components/v2/today/ai-accept-modal.tsx
#: app/frontend/components/v2/voice/call-detail-panel.tsx
msgid "Close"
msgstr "Close"

#. placeholder {0}: proposal.closeDate
#: app/frontend/components/v2/inbox/deal-proposal-card.tsx
msgid "close {0}"
msgstr "close {0}"

#: app/frontend/components/v2/companies/company-drawer.tsx
msgid "Close company drawer"
msgstr "Close company drawer"

#: app/frontend/components/v2/deals/deal-contact-picker.tsx
msgid "Close contact picker"
msgstr "Close contact picker"

#: app/frontend/components/v2/deals/create-deal-modal.tsx
#: app/frontend/components/v2/deals/deal-properties-card.tsx
#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
#: app/frontend/components/v2/deals/mobile-deal-show-panel.tsx
#: app/frontend/components/v2/inbox/deal-proposal-card.tsx
#: app/frontend/components/v2/inbox/deal-proposal-card.tsx
#: app/frontend/types/v2/deal-filters.ts
#: app/frontend/types/v2/deal-filters.ts
msgid "Close date"
msgstr "Close date"

#: app/frontend/components/v2/inbox/deal-drawer.tsx
msgid "Close deal drawer"
msgstr "Close deal drawer"

#: app/frontend/components/v2/drawer/drawer.tsx
msgid "Close drawer"
msgstr "Close drawer"

#: app/frontend/components/v2/deals/filter-popover.tsx
msgid "Close filter"
msgstr "Close filter"

#: app/frontend/components/v2/deals/mobile-history-fab-picker.tsx
msgid "Close picker"
msgstr "Close picker"

#: app/frontend/components/v2/search/command-palette.tsx
#: app/frontend/components/v2/search/search-input.tsx
msgid "Close search"
msgstr "Close search"

#: app/frontend/components/v2/deals/mobile-stage-picker.tsx
msgid "Close stage picker"
msgstr "Close stage picker"

#: app/frontend/components/v2/inbox/compose/composer-templates-popover.tsx
#: app/frontend/components/v2/inbox/compose/composer-templates-sheet.tsx
msgid "Close templates"
msgstr "Close templates"

#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
msgid "Closed · lost"
msgstr "Closed · lost"

#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
msgid "Closed · won"
msgstr "Closed · won"

#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/pages/v2/companies/show.tsx
#: app/frontend/pages/v2/contacts/show.tsx
msgid "Closed won"
msgstr "Closed won"

#: app/frontend/components/v2/deals/filter-bar.tsx
#: app/frontend/components/v2/deals/mobile-filter-strip.tsx
msgid "Closing this month"
msgstr "Closing this month"

#: app/frontend/components/v2/inbox/sidebar.tsx
msgid "Collapse sidebar"
msgstr "Collapse sidebar"

#: app/frontend/components/v2/companies/index-header.tsx
#: app/frontend/components/v2/companies/index-header.tsx
#: app/frontend/components/v2/companies/index-header.tsx
#: app/frontend/components/v2/settings/team/security-card.tsx
#: app/frontend/components/v2/settings/team/security-card.tsx
#: app/frontend/components/v2/settings/team/security-card.tsx
#: app/frontend/components/v2/settings/team/voice-calling-card.tsx
#: app/frontend/pages/v2/settings/channels/show.tsx
#: app/frontend/pages/v2/today/show.tsx
#: app/frontend/pages/v2/today/show.tsx
msgid "Coming soon"
msgstr "Coming soon"

#: app/frontend/components/v2/settings/team/danger-zone-card.tsx
msgid "Coming soon — this action will be wired in a follow-up."
msgstr "Coming soon — this action will be wired in a follow-up."

#: app/frontend/components/v2/deals/filter-bar.tsx
#: app/frontend/components/v2/deals/mobile-filter-strip.tsx
msgid "Coming with AI"
msgstr "Coming with AI"

#: app/frontend/components/v2/companies/index-header.tsx
#: app/frontend/components/v2/companies/page-shell.tsx
#: app/frontend/components/v2/inbox/rail.tsx
#: app/frontend/components/v2/inbox/sidebar.tsx
#: app/frontend/pages/v2/companies/index.tsx
#: app/frontend/pages/v2/companies/show.tsx
#: app/frontend/types/v2/search.ts
msgid "Companies"
msgstr "Companies"

#: app/frontend/components/v2/companies/company-drawer.tsx
#: app/frontend/components/v2/companies/index-table.tsx
#: app/frontend/components/v2/contacts/create-contact-modal.tsx
#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/components/v2/deals/deal-show-panel.tsx
#: app/frontend/components/v2/deals/mobile-deal-show-panel.tsx
#: app/frontend/components/v2/drawer/drawer.tsx
#: app/frontend/components/v2/inbox/company-block.tsx
#: app/frontend/components/v2/inbox/company-block.tsx
#: app/frontend/components/v2/landing/feature-capture.tsx
#: app/frontend/components/v2/landing/landing-footer.tsx
#: app/frontend/components/v2/search/drawer-preview-pane.tsx
#: app/frontend/pages/v2/contacts/show.tsx
#: app/frontend/types/v2/contact-filters.ts
#: app/frontend/types/v2/deal-filters.ts
msgid "Company"
msgstr "Company"

#: app/frontend/components/v2/companies/company-drawer.tsx
msgid "Company details"
msgstr "Company details"

#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "Completed"
msgstr "Completed"

#: app/frontend/pages/v2/today/show.tsx
msgid "Completed today"
msgstr "Completed today"

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Components"
msgstr "Components"

#: app/frontend/components/v2/landing/landing-nav.tsx
msgid "Conecto — back to top"
msgstr "Conecto — back to top"

#: app/frontend/components/v2/landing/landing-hero.tsx
msgid "Conecto captures every WhatsApp conversation in a beautifully simple CRM. Its AI drafts the replies, logs the deals, and lines up tomorrow's follow-ups — so nothing slips."
msgstr "Conecto captures every WhatsApp conversation in a beautifully simple CRM. Its AI drafts the replies, logs the deals, and lines up tomorrow's follow-ups — so nothing slips."

#: app/frontend/components/v2/auth/auth-layout.tsx
msgid "Conecto handles every conversation across every channel. It works while you sleep, and asks for your call when it matters."
msgstr "Conecto handles every conversation across every channel. It works while you sleep, and asks for your call when it matters."

#: app/frontend/components/v2/landing/integrations.tsx
msgid "Conecto plugs into the tools your team already runs on — and keeps everything in sync, automatically."
msgstr "Conecto plugs into the tools your team already runs on — and keeps everything in sync, automatically."

#: app/frontend/types/v2/buy-number.ts
msgid "Confirm & pay"
msgstr "Confirm & pay"

#: app/frontend/components/v2/deals/next-step-composer.tsx
msgid "Confirm 18% counter-offer details"
msgstr "Confirm 18% counter-offer details"

#: app/frontend/types/v2/buy-number.ts
msgid "Confirm and pay"
msgstr "Confirm and pay"

#: app/frontend/pages/v2/settings/channels/show.tsx
msgid "Connect"
msgstr "Connect"

#: app/frontend/pages/v2/settings/channels/show.tsx
msgid "Connect another business number."
msgstr "Connect another business number."

#: app/frontend/pages/v2/settings/channels/show.tsx
#: app/frontend/pages/v2/settings/channels/show.tsx
msgid "Connect the places your customers already are. Your AI handles every channel from one inbox."
msgstr "Connect the places your customers already are. Your AI handles every channel from one inbox."

#: app/frontend/lib/settings-nav.ts
msgid "Connect the rest of your stack."
msgstr "Connect the rest of your stack."

#: app/frontend/components/v2/landing/final-cta.tsx
msgid "Connect WhatsApp and let the AI work your inbox tonight. You'll wake up to a queue that's ready."
msgstr "Connect WhatsApp and let the AI work your inbox tonight. You'll wake up to a queue that's ready."

#: app/frontend/pages/v2/settings/channels/show.tsx
msgid "Connect WhatsApp first — it's the fastest way to give your AI something to do."
msgstr "Connect WhatsApp first — it's the fastest way to give your AI something to do."

#: app/frontend/components/v2/chrome/status-strip.tsx
#: app/frontend/components/v2/chrome/status-strip.tsx
#: app/frontend/components/v2/voice/active-call-widget.tsx
#: app/frontend/components/v2/voice/after-call-card.tsx
#: app/frontend/components/v2/voice/call-row.tsx
#: app/frontend/lib/voice-disposition.ts
#: app/frontend/pages/v2/settings/channels/show.tsx
#: app/frontend/pages/v2/settings/channels/show.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Connected"
msgstr "Connected"

#: app/frontend/components/v2/voice/incoming-call-sheet.tsx
msgid "Connecting call"
msgstr "Connecting call"

#: app/frontend/components/v2/chrome/status-strip.tsx
#: app/frontend/components/v2/chrome/status-strip.tsx
#: app/frontend/components/v2/voice/active-call-widget.tsx
#: app/frontend/components/v2/voice/call-duration.tsx
#: app/frontend/pages/v2/settings/channels/show.tsx
msgid "Connecting…"
msgstr "Connecting…"

#: app/frontend/components/v2/chrome/status-strip.tsx
#: app/frontend/components/v2/chrome/status-strip.tsx
msgid "Connection error"
msgstr "Connection error"

#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/components/v2/contacts/reassign-contact-assignees.tsx
#: app/frontend/components/v2/contacts/reassign-contact-assignees.tsx
#: app/frontend/components/v2/today/ai-accept-modal.tsx
#: app/frontend/components/v2/today/ai-accept-sheet.tsx
#: app/frontend/pages/v2/contacts/index.tsx
#: app/frontend/pages/v2/contacts/index.tsx
#: app/frontend/pages/v2/contacts/index.tsx
#: app/frontend/pages/v2/contacts/index.tsx
msgid "contact"
msgstr "contact"

#: app/frontend/components/v2/drawer/drawer.tsx
#: app/frontend/components/v2/inbox/contact-section.tsx
#: app/frontend/components/v2/inbox/contact-section.tsx
#: app/frontend/components/v2/inbox/contact-section.tsx
#: app/frontend/components/v2/landing/landing-footer.tsx
#: app/frontend/components/v2/search/drawer-preview-pane.tsx
msgid "Contact"
msgstr "Contact"

#: app/frontend/lib/conversation-formatting.ts
msgid "Contact card"
msgstr "Contact card"

#: app/frontend/components/v2/landing/feature-capture.tsx
msgid "Contact created automatically"
msgstr "Contact created automatically"

#: app/frontend/components/v2/deals/deal-contact-card.tsx
msgid "Contact options"
msgstr "Contact options"

#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/pages/v2/contacts/show.tsx
msgid "Contact sections"
msgstr "Contact sections"

#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/pages/v2/contacts/index.tsx
#: app/frontend/pages/v2/contacts/index.tsx
#: app/frontend/pages/v2/contacts/index.tsx
#: app/frontend/pages/v2/contacts/index.tsx
msgid "contacts"
msgstr "contacts"

#: app/frontend/components/v2/chrome/mobile-bottom-nav.tsx
#: app/frontend/components/v2/companies/company-drawer.tsx
#: app/frontend/components/v2/contacts/index-header.tsx
#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/components/v2/deals/deal-contact-card.tsx
#: app/frontend/components/v2/drawer/entries/company-entry-body.tsx
#: app/frontend/components/v2/inbox/rail.tsx
#: app/frontend/components/v2/inbox/sidebar.tsx
#: app/frontend/pages/v2/companies/show.tsx
#: app/frontend/pages/v2/contacts/index.tsx
#: app/frontend/pages/v2/contacts/show.tsx
#: app/frontend/types/v2/search.ts
msgid "Contacts"
msgstr "Contacts"

#: app/frontend/components/v2/inbox/create-opportunity-panel.tsx
#: app/frontend/pages/v2/settings/phone_numbers/new.tsx
msgid "Continue"
msgstr "Continue"

#: app/frontend/components/v2/auth/oauth-buttons.tsx
msgid "Continue with Apple"
msgstr "Continue with Apple"

#: app/frontend/components/v2/auth/oauth-buttons.tsx
msgid "Continue with Google"
msgstr "Continue with Google"

#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/pages/v2/contacts/show.tsx
msgid "Conversation"
msgstr "Conversation"

#: app/frontend/components/v2/inbox/conversation-more-menu.tsx
msgid "Conversation actions"
msgstr "Conversation actions"

#: app/frontend/pages/v2/contacts/index.tsx
msgid "conversations"
msgstr "conversations"

#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/components/v2/deals/deal-conversations-card.tsx
#: app/frontend/components/v2/inbox/inbox-list.tsx
#: app/frontend/components/v2/inbox/mobile-shell.tsx
#: app/frontend/pages/v2/contacts/show.tsx
#: app/frontend/pages/v2/contacts/show.tsx
#: app/frontend/pages/v2/contacts/show.tsx
#: app/frontend/types/v2/search.ts
msgid "Conversations"
msgstr "Conversations"

#. placeholder {0}: conversations.length
#: app/frontend/pages/v2/contacts/show.tsx
msgid "Conversations {0}"
msgstr "Conversations {0}"

#: app/frontend/components/v2/notifications/notifications-list-content.tsx
msgid "Conversations and deals you're assigned to land here."
msgstr "Conversations and deals you're assigned to land here."

#: app/frontend/components/v2/inbox/inbox-list.tsx
#: app/frontend/components/v2/inbox/mobile-shell.tsx
msgid "Conversations appear here when a contact reaches out on any connected channel."
msgstr "Conversations appear here when a contact reaches out on any connected channel."

#: app/frontend/components/v2/settings/team/teammate-stats.tsx
msgid "Conversations open"
msgstr "Conversations open"

#: app/frontend/components/v2/voice/call-detail-panel.tsx
msgid "Copied"
msgstr "Copied"

#: app/frontend/components/v2/whatsapp-templates/template-editor-utils.ts
msgid "Copy code"
msgstr "Copy code"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Copy code sample"
msgstr "Copy code sample"

#: app/frontend/components/v2/settings/phone-numbers/row-kebab.tsx
msgid "Copy number"
msgstr "Copy number"

#: app/frontend/components/v2/deals/deal-more-menu.tsx
#: app/frontend/components/v2/deals/deal-more-menu.tsx
msgid "Copy share link"
msgstr "Copy share link"

#: app/frontend/components/v2/voice/call-detail-panel.tsx
msgid "Copy transcript"
msgstr "Copy transcript"

#: app/frontend/components/v2/voice/active-call-widget.tsx
msgid "Couldn't connect"
msgstr "Couldn't connect"

#: app/frontend/components/v2/filters/saved-view-list.tsx
msgid "Couldn't delete — please try again."
msgstr "Couldn't delete — please try again."

#: app/frontend/components/v2/search/drawer-preview-pane.tsx
msgid "Couldn't load this preview. Try selecting it again."
msgstr "Couldn't load this preview. Try selecting it again."

#: app/frontend/components/v2/voice/after-call-card.tsx
#: app/frontend/components/v2/voice/after-call-card.tsx
#: app/frontend/components/v2/voice/after-call-card.tsx
#: app/frontend/components/v2/voice/after-call-card.tsx
#: app/frontend/components/v2/voice/after-call-card.tsx
msgid "Couldn't save — please try again."
msgstr "Couldn't save — please try again."

#: app/frontend/components/v2/deals/deal-properties-card.tsx
#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
msgid "Couldn't save the date. Try again."
msgstr "Couldn't save the date. Try again."

#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
msgid "Couldn't save the name. Try again."
msgstr "Couldn't save the name. Try again."

#: app/frontend/components/v2/deals/next-step-composer.tsx
msgid "Couldn't save the next step. Try again."
msgstr "Couldn't save the next step. Try again."

#: app/frontend/components/v2/deals/mobile-note-sheet.tsx
#: app/frontend/components/v2/deals/note-composer.tsx
msgid "Couldn't save the note. Try again."
msgstr "Couldn't save the note. Try again."

#: app/frontend/components/v2/deals/deal-properties-card.tsx
#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
msgid "Couldn't save the value. Try again."
msgstr "Couldn't save the value. Try again."

#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/components/v2/deals/filter-popover.tsx
#: app/frontend/components/v2/inbox/filter-panel.tsx
msgid "Couldn't save view — please try again."
msgstr "Couldn't save view — please try again."

#: app/frontend/components/v2/contacts/contact-inline-edit-row.tsx
#: app/frontend/components/v2/settings/team/profile-card.tsx
msgid "Couldn't save."
msgstr "Couldn't save."

#: app/frontend/components/v2/inbox/message-bubble.tsx
msgid "Couldn't summarize this call"
msgstr "Couldn't summarize this call"

#: app/frontend/types/v2/buy-number.ts
msgid "Country"
msgstr "Country"

#: app/frontend/components/v2/contacts/create-contact-modal.tsx
msgid "Country code"
msgstr "Country code"

#: app/frontend/components/v2/deals/create-deal-modal.tsx
#: app/frontend/lib/commands.ts
msgid "Create"
msgstr "Create"

#: app/frontend/components/v2/voice/after-call-link-deal.tsx
msgid "Create & link"
msgstr "Create & link"

#: app/frontend/components/v2/whatsapp-templates/follow-up-template-card.tsx
msgid "Create a template →"
msgstr "Create a template →"

#: app/frontend/pages/v2/registrations/new.tsx
msgid "Create account"
msgstr "Create account"

#: app/frontend/components/v2/deals/create-deal-modal.tsx
#: app/frontend/components/v2/inbox/deal-proposal-card.tsx
#: app/frontend/lib/commands.ts
msgid "Create deal"
msgstr "Create deal"

#: app/frontend/components/v2/deals/deal-contact-picker.tsx
msgid "Create new contact (coming soon)"
msgstr "Create new contact (coming soon)"

#: app/frontend/components/v2/deals/deal-contact-picker.tsx
msgid "Create new contact…"
msgstr "Create new contact…"

#: app/frontend/components/v2/inbox/create-opportunity-panel.tsx
msgid "Create opportunity"
msgstr "Create opportunity"

#: app/frontend/components/v2/inbox/compose/composer-templates-popover.tsx
#: app/frontend/components/v2/inbox/compose/composer-templates-sheet.tsx
msgid "Create your first one from Settings."
msgstr "Create your first one from Settings."

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/index.tsx
msgid "Create your first template to start sending messages outside the 24-hour window."
msgstr "Create your first template to start sending messages outside the 24-hour window."

#: app/frontend/pages/v2/registrations/new.tsx
msgid "Create your workspace"
msgstr "Create your workspace"

#: app/frontend/components/v2/deals/deal-properties-card.tsx
#: app/frontend/components/v2/deals/mobile-deal-show-panel.tsx
msgid "Created"
msgstr "Created"

#: app/frontend/components/v2/deals/create-deal-modal.tsx
#: app/frontend/components/v2/deals/create-deal-modal.tsx
#: app/frontend/components/v2/inbox/deal-proposal-card.tsx
#: app/frontend/components/v2/voice/after-call-link-deal.tsx
msgid "Creating…"
msgstr "Creating…"

#: app/frontend/components/v2/deals/deal-contact-picker.tsx
#~ msgid "Current"
#~ msgstr "Current"

#: app/frontend/components/v2/settings/billing/plan-card.tsx
#: app/frontend/pages/v2/settings/billing/show.tsx
msgid "Current plan"
msgstr "Current plan"

#. placeholder {0}: currentAssigneeLabel(conversation, t)
#: app/frontend/components/v2/inbox/conversation-more-menu.tsx
msgid "Currently: {0}"
msgstr "Currently: {0}"

#: app/frontend/components/v2/inbox/conversation-snooze-date-picker-sheet.tsx
msgid "Custom"
msgstr "Custom"

#: app/frontend/components/v2/deals/next-step-composer.tsx
msgid "Custom due date"
msgstr "Custom due date"

#: app/frontend/lib/settings-nav.ts
msgid "Custom fields"
msgstr "Custom fields"

#: app/frontend/components/v2/voice/after-call-transcript.tsx
msgid "Customer"
msgstr "Customer"

#: app/frontend/components/v2/companies/index-toolbar.tsx
#: app/frontend/components/v2/landing/landing-nav.tsx
#: app/frontend/pages/v2/companies/index.tsx
msgid "Customers"
msgstr "Customers"

#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
msgid "Customize"
msgstr "Customize"

#: app/frontend/components/v2/deals/starter-pipeline-banner.tsx
#: app/frontend/components/v2/deals/starter-pipeline-banner.tsx
msgid "Customize stages"
msgstr "Customize stages"

#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
msgid "Customize your pipeline"
msgstr "Customize your pipeline"

#: app/frontend/components/v2/settings/usage/daily-spend-chart.tsx
msgid "Daily spend"
msgstr "Daily spend"

#: app/frontend/components/v2/settings/team/danger-zone-card.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Danger zone"
msgstr "Danger zone"

#: app/frontend/components/v2/inbox/rail.tsx
#: app/frontend/components/v2/inbox/sidebar.tsx
msgid "Dashboard"
msgstr "Dashboard"

#: app/frontend/pages/v2/today/show.tsx
msgid "day"
msgstr "day"

#: app/frontend/pages/v2/today/show.tsx
msgid "days"
msgstr "days"

#: app/frontend/components/v2/drawer/drawer.tsx
#: app/frontend/components/v2/inbox/deal-drawer.tsx
#: app/frontend/components/v2/landing/feature-capture.tsx
#: app/frontend/components/v2/search/drawer-preview-pane.tsx
msgid "Deal"
msgstr "Deal"

#: app/frontend/components/v2/settings/team/access-card.tsx
msgid "Deal access"
msgstr "Deal access"

#: app/frontend/components/v2/deals/deal-more-menu.tsx
#: app/frontend/components/v2/deals/deal-more-menu.tsx
#: app/frontend/components/v2/deals/deal-more-menu.tsx
#: app/frontend/components/v2/deals/deal-more-trigger.tsx
#: app/frontend/components/v2/deals/deal-more-trigger.tsx
#: app/frontend/components/v2/deals/mobile-deal-show-panel.tsx
msgid "Deal actions"
msgstr "Deal actions"

#: app/frontend/components/v2/inbox/deal-proposal-card.tsx
msgid "Deal created"
msgstr "Deal created"

#: app/frontend/components/v2/deals/deal-show-panel.tsx
#: app/frontend/components/v2/inbox/deal-drawer.tsx
msgid "Deal details"
msgstr "Deal details"

#: app/frontend/pages/v2/dev/components/voice_card.tsx
msgid "Deal linked"
msgstr "Deal linked"

#: app/frontend/components/v2/deals/create-deal-modal.tsx
#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
#: app/frontend/components/v2/inbox/deal-proposal-card.tsx
#: app/frontend/components/v2/inbox/deal-proposal-card.tsx
msgid "Deal name"
msgstr "Deal name"

#: app/frontend/types/v2/contact-filters.ts
msgid "Deal stage"
msgstr "Deal stage"

#: app/frontend/components/v2/deals/deal-properties-card.tsx
#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
#: app/frontend/components/v2/inbox/deal-proposal-card.tsx
msgid "Deal value"
msgstr "Deal value"

#. placeholder {0}: deal.name
#: app/frontend/components/v2/deals/deal-card.tsx
#: app/frontend/components/v2/deals/mobile-deal-card.tsx
msgid "Deal: {0}"
msgstr "Deal: {0}"

#: app/frontend/components/v2/chrome/mobile-bottom-nav.tsx
#: app/frontend/components/v2/companies/index-table.tsx
#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/components/v2/deals/deal-show-panel.tsx
#: app/frontend/components/v2/deals/mobile-deal-show-panel.tsx
#: app/frontend/components/v2/deals/mobile-deals-shell.tsx
#: app/frontend/components/v2/deals/pipeline-board.tsx
#: app/frontend/components/v2/drawer/entries/company-entry-body.tsx
#: app/frontend/components/v2/inbox/rail.tsx
#: app/frontend/components/v2/inbox/sidebar.tsx
#: app/frontend/pages/v2/contacts/show.tsx
#: app/frontend/pages/v2/contacts/show.tsx
#: app/frontend/types/v2/search.ts
msgid "Deals"
msgstr "Deals"

#. placeholder {0}: parts.join(" · ")
#: app/frontend/components/v2/drawer/entries/company-entry-body.tsx
msgid "Deals · {0}"
msgstr "Deals · {0}"

#: app/frontend/pages/v2/contacts/show.tsx
msgid "Deals {summary}"
msgstr "Deals {summary}"

#: app/frontend/components/v2/landing/landing-footer.tsx
msgid "Deals & pipeline"
msgstr "Deals & pipeline"

#: app/frontend/components/v2/landing/feature-pipeline.tsx
msgid "Deals move stages, values update, and health flags turn red on their own — read from the conversation, not typed into a form."
msgstr "Deals move stages, values update, and health flags turn red on their own — read from the conversation, not typed into a form."

#: app/frontend/components/v2/settings/team/teammate-stats.tsx
msgid "Deals owned"
msgstr "Deals owned"

#: app/frontend/components/v2/deals/mobile-deals-shell.tsx
msgid "Deals show up here as they move through this stage."
msgstr "Deals show up here as they move through this stage."

#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
#: app/frontend/components/v2/inline-edit/date-popover.tsx
msgid "December"
msgstr "December"

#: app/frontend/components/v2/voice/incoming-call-sheet.tsx
msgid "Decline"
msgstr "Decline"

#: app/frontend/components/v2/voice/incoming-call-sheet.tsx
msgid "Decline call"
msgstr "Decline call"

#: app/frontend/components/v2/voice/call-row.tsx
msgid "Declined"
msgstr "Declined"

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Default assignee"
msgstr "Default assignee"

#: app/frontend/components/v2/filters/saved-view-list.tsx
#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/inbox/notes-section.tsx
#: app/frontend/components/v2/inbox/notes-section.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Delete"
msgstr "Delete"

#. placeholder {0}: view.name
#: app/frontend/components/v2/filters/saved-view-list.tsx
msgid "Delete \"{0}\"?"
msgstr "Delete \"{0}\"?"

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Delete {templateName}?"
msgstr "Delete {templateName}?"

#: app/frontend/components/v2/deals/deal-more-menu.tsx
#: app/frontend/components/v2/deals/deal-more-menu.tsx
msgid "Delete deal"
msgstr "Delete deal"

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Delete template"
msgstr "Delete template"

#: app/frontend/lib/delete-prompt-copy.ts
msgid "Delete this deal?"
msgstr "Delete this deal?"

#: app/frontend/lib/delete-prompt-copy.ts
msgid "Delete this follow-up?"
msgstr "Delete this follow-up?"

#: app/frontend/components/v2/voice/after-call-more-sheet.tsx
msgid "Delete this note"
msgstr "Delete this note"

#: app/frontend/lib/delete-prompt-copy.ts
msgid "Delete this note?"
msgstr "Delete this note?"

#: app/frontend/components/v2/filters/saved-view-list.tsx
msgid "Deleting…"
msgstr "Deleting…"

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Delivered"
msgstr "Delivered"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Description (helper text — shown on the template detail)"
msgstr "Description (helper text — shown on the template detail)"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Description for variable {n}"
msgstr "Description for variable {n}"

#. placeholder {0}: item.title
#: app/frontend/components/v2/inbox/attach-offer-card.tsx
msgid "Deselect {0}"
msgstr "Deselect {0}"

#: app/frontend/pages/v2/dev/components/voice_card.tsx
msgid "Desktop dock"
msgstr "Desktop dock"

#. placeholder {0}: employee.name
#: app/frontend/components/v2/settings/team/danger-zone-card.tsx
msgid "Destructive actions for {0}."
msgstr "Destructive actions for {0}."

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Determines pricing and Meta's review rules. Pick the one that matches your intent."
msgstr "Determines pricing and Meta's review rules. Pick the one that matches your intent."

#: app/frontend/components/v2/voice/dtmf-pad.tsx
msgid "Dial {tone}"
msgstr "Dial {tone}"

#: app/frontend/components/v2/voice/dtmf-pad.tsx
msgid "Dial pad"
msgstr "Dial pad"

#: app/frontend/components/v2/voice/dtmf-pad.tsx
msgid "Dial pound"
msgstr "Dial pound"

#: app/frontend/components/v2/voice/dtmf-pad.tsx
msgid "Dial star"
msgstr "Dial star"

#: app/frontend/components/v2/settings/team/team-voice-switch.tsx
msgid "Disable voice for teammate {employeeId}"
msgstr "Disable voice for teammate {employeeId}"

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Disconnect"
msgstr "Disconnect"

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Disconnect WhatsApp number"
msgstr "Disconnect WhatsApp number"

#: app/frontend/components/v2/chrome/status-strip.tsx
#: app/frontend/components/v2/chrome/status-strip.tsx
msgid "Disconnected"
msgstr "Disconnected"

#: app/frontend/components/v2/chrome/user-menu.tsx
#: app/frontend/components/v2/deals/starter-pipeline-banner.tsx
#: app/frontend/components/v2/deals/starter-pipeline-banner.tsx
#: app/frontend/components/v2/inbox/deal-proposal-card.tsx
#: app/frontend/components/v2/settings/team/danger-zone-card.tsx
#: app/frontend/components/v2/suggestions/suggestion-card.tsx
#: app/frontend/components/v2/today/activity-row.tsx
#: app/frontend/components/v2/today/ai-accept-modal.tsx
#: app/frontend/components/v2/today/ai-accept-sheet.tsx
#: app/frontend/components/v2/today/mobile-activity-row.tsx
#: app/frontend/components/v2/voice/active-call-widget.tsx
msgid "Dismiss"
msgstr "Dismiss"

#: app/frontend/components/v2/suggestions/suggestion-card.tsx
#: app/frontend/components/v2/today/activity-row.tsx
#: app/frontend/components/v2/today/mobile-activity-row.tsx
msgid "Dismiss suggestion"
msgstr "Dismiss suggestion"

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Display name"
msgstr "Display name"

#: app/frontend/components/v2/today/activity-row.tsx
#: app/frontend/components/v2/today/mobile-activity-row.tsx
msgid "Do it"
msgstr "Do it"

#: app/frontend/components/v2/chrome/status-strip.tsx
#: app/frontend/components/v2/chrome/status-strip.tsx
msgid "Do not disturb"
msgstr "Do not disturb"

#: app/frontend/components/v2/inbox/message-bubble.tsx
#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
#: app/frontend/lib/conversation-formatting.ts
msgid "Document"
msgstr "Document"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Document up to 100 MB · the sample Meta reviews"
msgstr "Document up to 100 MB · the sample Meta reviews"

#: app/frontend/components/v2/voice/after-call-link-deal.tsx
msgid "Don't link a deal"
msgstr "Don't link a deal"

#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
#: app/frontend/components/v2/inbox/filter-sheet.tsx
#: app/frontend/components/v2/voice/after-call-card.tsx
#: app/frontend/components/v2/voice/after-call-link-deal.tsx
#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "Done"
msgstr "Done"

#: app/frontend/components/v2/voice/call-detail-panel.tsx
msgid "Download"
msgstr "Download"

#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Draft"
msgstr "Draft"

#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Draft save status"
msgstr "Draft save status"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Drag a file here, or <0>browse</0>"
msgstr "Drag a file here, or <0>browse</0>"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Drag to reorder"
msgstr "Drag to reorder"

#: app/frontend/components/v2/drawer/drawer.tsx
msgid "Drawer details"
msgstr "Drawer details"

#: app/frontend/components/v2/deals/deal-column.tsx
msgid "Drop"
msgstr "Drop"

#: app/frontend/pages/v2/settings/channels/show.tsx
msgid "Drop a chat bubble on your site. AI greets and qualifies visitors."
msgstr "Drop a chat bubble on your site. AI greets and qualifies visitors."

#. placeholder {0}: stage.name
#: app/frontend/components/v2/deals/deal-column.tsx
msgid "Drop here to move to {0}"
msgstr "Drop here to move to {0}"

#: app/frontend/components/v2/deals/next-step-composer.tsx
#~ msgid "DUE"
#~ msgstr "DUE"

#. placeholder {0}: formatDueAt(dueAt)
#: app/frontend/components/v2/deals/next-step-composer.tsx
msgid "Due {0}"
msgstr "Due {0}"

#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "Due date"
msgstr "Due date"

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Duplicate"
msgstr "Duplicate"

#: app/frontend/components/v2/deals/deal-more-menu.tsx
#: app/frontend/components/v2/deals/deal-more-menu.tsx
msgid "Duplicate deal"
msgstr "Duplicate deal"

#: app/frontend/components/v2/voice/after-call-link-deal.tsx
msgid "e.g. {firstName} — annual renewal"
msgstr "e.g. {firstName} — annual renewal"

#: app/frontend/components/v2/inbox/create-opportunity-panel.tsx
msgid "e.g. Acme · annual renewal"
msgstr "e.g. Acme · annual renewal"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "e.g. customer_name"
msgstr "e.g. customer_name"

#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "e.g. deal_followup_v3"
msgstr "e.g. deal_followup_v3"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "e.g. Order update"
msgstr "e.g. Order update"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "e.g. Reply STOP to opt out"
msgstr "e.g. Reply STOP to opt out"

#: app/frontend/pages/v2/notifications/index.tsx
msgid "Earlier"
msgstr "Earlier"

#: app/frontend/pages/v2/notifications/index.tsx
msgid "Earlier this week"
msgstr "Earlier this week"

#: app/frontend/components/v2/deals/next-steps-section.tsx
#: app/frontend/components/v2/suggestions/suggestion-card.tsx
#: app/frontend/components/v2/today/activity-row.tsx
#: app/frontend/components/v2/today/ai-accept-modal.tsx
#: app/frontend/components/v2/today/mobile-activity-row.tsx
#: app/frontend/components/v2/voice/call-detail-panel.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
#: app/frontend/pages/v2/contacts/show.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Edit"
msgstr "Edit"

#. placeholder {0}: label.toLowerCase()
#: app/frontend/components/v2/inline-edit/inline-text-edit-row.tsx
#: app/frontend/components/v2/inline-edit/inline-text-edit-row.tsx
msgid "Edit {0}"
msgstr "Edit {0}"

#: app/frontend/components/v2/voice/call-detail-panel.tsx
msgid "Edit AI summary"
msgstr "Edit AI summary"

#: app/frontend/components/v2/settings/phone-numbers/row-kebab.tsx
msgid "Edit capabilities"
msgstr "Edit capabilities"

#: app/frontend/components/v2/deals/deal-properties-card.tsx
#: app/frontend/components/v2/deals/mobile-deal-show-panel.tsx
msgid "Edit close date"
msgstr "Edit close date"

#: app/frontend/components/v2/deals/mobile-deal-show-panel.tsx
msgid "Edit deal name"
msgstr "Edit deal name"

#: app/frontend/components/v2/deals/mobile-deal-show-panel.tsx
msgid "Edit deal value"
msgstr "Edit deal value"

#: app/frontend/components/v2/inbox/context-pane.tsx
msgid "Edit due date"
msgstr "Edit due date"

#: app/frontend/components/v2/inbox/deal-proposal-card.tsx
msgid "Edit first"
msgstr "Edit first"

#: app/frontend/components/v2/today/ai-accept-sheet.tsx
msgid "Edit message"
msgstr "Edit message"

#: app/frontend/components/v2/deals/mobile-next-step-sheet.tsx
#: app/frontend/components/v2/deals/mobile-next-step-sheet.tsx
msgid "Edit next step"
msgstr "Edit next step"

#: app/frontend/components/v2/inbox/context-pane.tsx
msgid "Edit next step title"
msgstr "Edit next step title"

#. placeholder {0}: member.name
#: app/frontend/components/v2/settings/team/team-member-row.tsx
#: app/frontend/components/v2/settings/team/team-member-row.tsx
msgid "Edit numbers that ring {0}"
msgstr "Edit numbers that ring {0}"

#: app/frontend/components/v2/deals/deal-properties-card.tsx
#: app/frontend/components/v2/deals/mobile-deal-show-panel.tsx
msgid "Edit owners"
msgstr "Edit owners"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
msgid "Edit quota exhausted"
msgstr "Edit quota exhausted"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
msgid "Edit quota exhausted — try again next window"
msgstr "Edit quota exhausted — try again next window"

#: app/frontend/components/v2/deals/next-steps-section.tsx
#~ msgid "Edit step"
#~ msgstr "Edit step"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Edit template"
msgstr "Edit template"

#: app/frontend/components/v2/deals/deal-properties-card.tsx
#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
msgid "Edit value"
msgstr "Edit value"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
msgid "Editing this template will resubmit it to Meta for review. Only category and components can be changed — name and language are locked."
msgstr "Editing this template will resubmit it to Meta for review. Only category and components can be changed — name and language are locked."

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
msgid "Editing will resubmit this template to Meta"
msgstr "Editing will resubmit this template to Meta"

#: app/frontend/components/v2/contacts/create-contact-modal.tsx
#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/components/v2/deals/next-steps-section.tsx
#: app/frontend/components/v2/drawer/entries/contact-entry-body.tsx
#: app/frontend/components/v2/landing/feature-capture.tsx
#: app/frontend/components/v2/settings/team/profile-card.tsx
#: app/frontend/lib/follow-up-method.ts
#: app/frontend/lib/follow-up-method.ts
#: app/frontend/lib/follow-up-method.ts
#: app/frontend/lib/follow-up-method.ts
#: app/frontend/pages/v2/contacts/show.tsx
#: app/frontend/pages/v2/registrations/new.tsx
#: app/frontend/pages/v2/sessions/new.tsx
#: app/frontend/pages/v2/settings/channels/show.tsx
#: app/frontend/pages/v2/settings/channels/show.tsx
msgid "Email"
msgstr "Email"

#. placeholder {0}: contact.email
#: app/frontend/components/v2/inbox/other-ways-popover.tsx
msgid "Email {0}"
msgstr "Email {0}"

#: app/frontend/components/v2/settings/team/team-voice-switch.tsx
msgid "Enable voice for teammate {employeeId}"
msgstr "Enable voice for teammate {employeeId}"

#: app/frontend/components/v2/voice/active-call-widget.tsx
msgid "End"
msgstr "End"

#: app/frontend/components/v2/deals/deal-properties-card.tsx
#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
#: app/frontend/components/v2/inbox/context-pane.tsx
msgid "End of month"
msgstr "End of month"

#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
msgid "End of quarter"
msgstr "End of quarter"

#: app/frontend/components/v2/whatsapp-templates/template-editor-utils.ts
msgid "English (US)"
msgstr "English (US)"

#: app/frontend/components/v2/settings/phone-numbers/buy/step-capabilities.tsx
msgid "Estimated monthly cost"
msgstr "Estimated monthly cost"

#: app/frontend/pages/v2/companies/index.tsx
msgid "Every company is enriched."
msgstr "Every company is enriched."

#: app/frontend/components/v2/landing/feature-capture.tsx
msgid "Every lead captured at the speed of a text"
msgstr "Every lead captured at the speed of a text"

#: app/frontend/components/v2/settings/team/answers-on-card.tsx
msgid "Every number is already on this teammate."
msgstr "Every number is already on this teammate."

#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Every variable has a source and sample value"
msgstr "Every variable has a source and sample value"

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Everyone on the workspace has access."
msgstr "Everyone on the workspace has access."

#: app/frontend/components/v2/inbox/rail.tsx
msgid "Expand sidebar"
msgstr "Expand sidebar"

#: app/frontend/components/v2/inbox/create-opportunity-panel.tsx
msgid "Expected close date"
msgstr "Expected close date"

#: app/frontend/components/v2/voice/call-row.tsx
msgid "Failed"
msgstr "Failed"

#: app/frontend/components/v2/landing/landing-nav.tsx
msgid "Features"
msgstr "Features"

#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
#: app/frontend/components/v2/inline-edit/date-popover.tsx
msgid "February"
msgstr "February"

#: app/frontend/components/v2/voice/active-call-widget.tsx
msgid "Feeds the AI summary when the call ends."
msgstr "Feeds the AI summary when the call ends."

#: app/frontend/components/v2/inbox/compose/composer-actions-sheet.tsx
#: app/frontend/components/v2/inbox/compose/composer-attach-popover.tsx
msgid "File"
msgstr "File"

#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/pages/v2/contacts/show.tsx
#: app/frontend/pages/v2/contacts/show.tsx
msgid "Files"
msgstr "Files"

#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/pages/v2/contacts/show.tsx
msgid "Files shared in conversations will show up here."
msgstr "Files shared in conversations will show up here."

#: app/frontend/components/v2/inbox/failed-template-expander.tsx
msgid "Fill in variables"
msgstr "Fill in variables"

#: app/frontend/components/v2/inbox/compose/staged-template.tsx
msgid "Fill variable {token}"
msgstr "Fill variable {token}"

#: app/frontend/pages/v2/contacts/index.tsx
msgid "filter"
msgstr "filter"

#: app/frontend/components/v2/companies/index-header.tsx
#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/components/v2/contacts/index-header.tsx
#: app/frontend/components/v2/deals/filter-popover.tsx
#: app/frontend/components/v2/deals/filter-popover.tsx
#: app/frontend/components/v2/deals/pipeline-board.tsx
#: app/frontend/components/v2/inbox/filter-pills.tsx
#: app/frontend/components/v2/landing/feature-pipeline.tsx
#: app/frontend/pages/v2/contacts/index.tsx
#: app/frontend/pages/v2/today/show.tsx
#: app/frontend/pages/v2/today/show.tsx
msgid "Filter"
msgstr "Filter"

#: app/frontend/pages/v2/contacts/index.tsx
msgid "Filter ({activeMobileFilterCount} active)"
msgstr "Filter ({activeMobileFilterCount} active)"

#. placeholder {0}: group.label
#: app/frontend/components/v2/deals/activity-facet-row.tsx
msgid "Filter by {0}"
msgstr "Filter by {0}"

#: app/frontend/components/v2/inbox/attach-offer-card.tsx
msgid "Filter by title…"
msgstr "Filter by title…"

#: app/frontend/components/v2/inbox/attach-offer-card.tsx
msgid "Filter captures"
msgstr "Filter captures"

#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/components/v2/contacts/index-header.tsx
msgid "Filter contacts"
msgstr "Filter contacts"

#: app/frontend/components/v2/contacts/index-header.tsx
msgid "Filter contacts ({activeFilterCount} active)"
msgstr "Filter contacts ({activeFilterCount} active)"

#: app/frontend/components/v2/deals/filter-popover.tsx
msgid "Filter date"
msgstr "Filter date"

#: app/frontend/components/v2/deals/filter-popover.tsx
#: app/frontend/components/v2/deals/filter-popover.tsx
msgid "Filter deals"
msgstr "Filter deals"

#: app/frontend/components/v2/deals/filter-popover.tsx
msgid "Filter field"
msgstr "Filter field"

#: app/frontend/components/v2/inbox/filter-panel.tsx
#: app/frontend/components/v2/inbox/filter-popover.tsx
#: app/frontend/components/v2/inbox/filter-sheet.tsx
#: app/frontend/components/v2/inbox/filter-sheet.tsx
msgid "Filter inbox"
msgstr "Filter inbox"

#: app/frontend/pages/v2/notifications/index.tsx
msgid "Filter notifications"
msgstr "Filter notifications"

#: app/frontend/components/v2/deals/filter-popover.tsx
msgid "Filter operator"
msgstr "Filter operator"

#: app/frontend/components/v2/search/search-tabs.tsx
msgid "Filter results by type"
msgstr "Filter results by type"

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/index.tsx
msgid "Filter templates by status"
msgstr "Filter templates by status"

#: app/frontend/components/v2/deals/filter-bar.tsx
#: app/frontend/components/v2/deals/mobile-filter-strip.tsx
msgid "Filter to deals closing this month"
msgstr "Filter to deals closing this month"

#: app/frontend/components/v2/deals/filter-bar.tsx
#: app/frontend/components/v2/deals/mobile-filter-strip.tsx
msgid "Filter to deals that need you (coming with AI)"
msgstr "Filter to deals that need you (coming with AI)"

#: app/frontend/components/v2/deals/filter-bar.tsx
#: app/frontend/components/v2/deals/mobile-filter-strip.tsx
msgid "Filter to deals with no next step"
msgstr "Filter to deals with no next step"

#: app/frontend/components/v2/deals/filter-bar.tsx
#: app/frontend/components/v2/deals/mobile-filter-strip.tsx
msgid "Filter to my deals"
msgstr "Filter to my deals"

#: app/frontend/components/v2/deals/filter-popover.tsx
msgid "Filter value"
msgstr "Filter value"

#: app/frontend/components/v2/deals/filter-popover.tsx
msgid "Filter values"
msgstr "Filter values"

#: app/frontend/pages/v2/contacts/index.tsx
msgid "filters"
msgstr "filters"

#: app/frontend/components/v2/search/cold-start.tsx
msgid "Find any deal, contact, company, conversation, or note. Type > to run a command instead."
msgstr "Find any deal, contact, company, conversation, or note. Type > to run a command instead."

#: app/frontend/components/v2/inbox/compose/compose-modal.tsx
msgid "First-touch must use an approved template"
msgstr "First-touch must use an approved template"

#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "Follow-up"
msgstr "Follow-up"

#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "Follow-up actions"
msgstr "Follow-up actions"

#: app/frontend/components/v2/deals/next-steps-section.tsx
#: app/frontend/components/v2/inbox/context-pane.tsx
msgid "Follow-up deleted"
msgstr "Follow-up deleted"

#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "Follow-up scheduled"
msgstr "Follow-up scheduled"

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "Follow-up sent"
msgstr "Follow-up sent"

#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "Follow-ups"
msgstr "Follow-ups"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Footer"
msgstr "Footer"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Footer text"
msgstr "Footer text"

#: app/frontend/components/v2/voice/after-call-link-deal.tsx
#: app/frontend/components/v2/voice/after-call-link-deal.tsx
msgid "for {firstName}"
msgstr "for {firstName}"

#: app/frontend/pages/v2/sessions/new.tsx
msgid "Forgot?"
msgstr "Forgot?"

#: app/frontend/pages/v2/settings/channels/show.tsx
msgid "Forward emails into the inbox so AI replies in your tone."
msgstr "Forward emails into the inbox so AI replies in your tone."

#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
msgid "Fr"
msgstr "Fr"

#: app/frontend/components/v2/landing/final-cta.tsx
msgid "Free 14-day trial · no credit card · cancel anytime"
msgstr "Free 14-day trial · no credit card · cancel anytime"

#: app/frontend/components/v2/landing/landing-hero.tsx
msgid "Free 14-day trial · no credit card required"
msgstr "Free 14-day trial · no credit card required"

#: app/frontend/components/v2/whatsapp-templates/template-editor-utils.ts
msgid "French (France)"
msgstr "French (France)"

#: app/frontend/components/v2/landing/feature-today.tsx
msgid "Friday, May 31"
msgstr "Friday, May 31"

#: app/frontend/components/v2/settings/phone-numbers/buy/step-capabilities.tsx
msgid "From "
msgstr "From "

#. placeholder {0}: pricing.baseFromLabel
#: app/frontend/components/v2/settings/phone-numbers/add-card-interstitial.tsx
msgid "from {0}"
msgstr "from {0}"

#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "from your call"
msgstr "from your call"

#. placeholder {0}: row.fromCallLabel
#. placeholder {0}: step.fromCallLabel
#: app/frontend/components/v2/deals/next-steps-section.tsx
#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/inbox/context-pane.tsx
msgid "from your call {0}"
msgstr "from your call {0}"

#: app/frontend/components/v2/deals/next-steps-section.tsx
#: app/frontend/components/v2/today/from-call-breadcrumb.tsx
msgid "from your call {label}"
msgstr "from your call {label}"

#: app/frontend/components/v2/settings/team/profile-card.tsx
#: app/frontend/pages/v2/registrations/new.tsx
msgid "Full name"
msgstr "Full name"

#: app/frontend/components/v2/landing/landing-footer.tsx
msgid "Get started"
msgstr "Get started"

#: app/frontend/components/v2/deals/next-steps-section.tsx
#~ msgid "Gift"
#~ msgstr "Gift"

#: app/frontend/components/v2/inbox/context-pane.tsx
msgid "Give the next step a title."
msgstr "Give the next step a title."

#: app/frontend/lib/commands.ts
msgid "Go to Deals"
msgstr "Go to Deals"

#: app/frontend/lib/commands.ts
msgid "Go to Inbox"
msgstr "Go to Inbox"

#: app/frontend/lib/commands.ts
msgid "Go to Settings › Channels"
msgstr "Go to Settings › Channels"

#: app/frontend/lib/commands.ts
msgid "Go to Settings › Templates"
msgstr "Go to Settings › Templates"

#: app/frontend/lib/commands.ts
msgid "Go to Today"
msgstr "Go to Today"

#: app/frontend/components/v2/auth/oauth-buttons.tsx
msgid "Google sign-in is coming soon"
msgstr "Google sign-in is coming soon"

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Hand off to a teammate when the conversation needs a human."
msgstr "Hand off to a teammate when the conversation needs a human."

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Handled by AI"
msgstr "Handled by AI"

#: app/frontend/components/v2/voice/active-call-widget.tsx
msgid "Hang up"
msgstr "Hang up"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Header"
msgstr "Header"

#. placeholder {0}: i18n._(seg.label)
#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Header {0}"
msgstr "Header {0}"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Header media format"
msgstr "Header media format"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Header text"
msgstr "Header text"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Header type"
msgstr "Header type"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Header variable — Meta needs a sample value"
msgstr "Header variable — Meta needs a sample value"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Header variable sample"
msgstr "Header variable sample"

#: app/frontend/components/v2/notifications/notifications-list-content.tsx
#: app/frontend/pages/v2/notifications/index.tsx
msgid "Heads-up on conversations, deals, and AI handoffs lands here."
msgstr "Heads-up on conversations, deals, and AI handoffs lands here."

#: app/frontend/components/v2/chrome/user-menu.tsx
msgid "Help & support"
msgstr "Help & support"

#: app/frontend/components/v2/landing/landing-footer.tsx
msgid "Help center"
msgstr "Help center"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Hi {{1}}, your order is on its way."
msgstr "Hi {{1}}, your order is on its way."

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Hide"
msgstr "Hide"

#: app/frontend/components/v2/voice/active-call-widget.tsx
msgid "Hide dial pad"
msgstr "Hide dial pad"

#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "Hide dismissed"
msgstr "Hide dismissed"

#. placeholder {0}: firstName(conversation)
#: app/frontend/components/v2/inbox/conversation-snooze-sheet.tsx
msgid "Hide from inbox until {0} replies, the time below, or anything new comes in — whichever first."
msgstr "Hide from inbox until {0} replies, the time below, or anything new comes in — whichever first."

#: app/frontend/components/v2/voice/active-call-widget.tsx
msgid "Hide note"
msgstr "Hide note"

#: app/frontend/components/v2/auth/auth-text-field.tsx
msgid "Hide password"
msgstr "Hide password"

#: app/frontend/components/v2/deals/deal-show-panel.tsx
#: app/frontend/components/v2/deals/mobile-deal-show-panel.tsx
#: app/frontend/components/v2/drawer/entries/deal-entry-body.tsx
#: app/frontend/components/v2/inbox/deal-drawer.tsx
msgid "History"
msgstr "History"

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Hold AI replies for review before they go out."
msgstr "Hold AI replies for review before they go out."

#: app/frontend/components/v2/inbox/mobile-conversation-detail.tsx
msgid "Hold to record"
msgstr "Hold to record"

#: app/frontend/components/v2/settings/usage/how-billing-works.tsx
msgid "How billing works"
msgstr "How billing works"

#: app/frontend/components/v2/drawer/entries/contact-entry-body.tsx
msgid "https://linkedin.com/in/…"
msgstr "https://linkedin.com/in/…"

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Identity"
msgstr "Identity"

#: app/frontend/components/v2/inbox/message-bubble.tsx
#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Image"
msgstr "Image"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Image up to 5 MB · the sample Meta reviews"
msgstr "Image up to 5 MB · the sample Meta reviews"

#: app/frontend/components/v2/companies/index-header.tsx
#: app/frontend/components/v2/contacts/index-header.tsx
msgid "Import"
msgstr "Import"

#: app/frontend/components/v2/deals/deal-properties-card.tsx
#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
#: app/frontend/components/v2/inbox/context-pane.tsx
msgid "In 1 week"
msgstr "In 1 week"

#: app/frontend/components/v2/companies/company-drawer.tsx
#: app/frontend/components/v2/companies/people-section.tsx
#: app/frontend/components/v2/drawer/entries/company-entry-body.tsx
msgid "In active deal"
msgstr "In active deal"

#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
msgid "In progress"
msgstr "In progress"

#: app/frontend/components/v2/inbox/conversation-snooze-date-picker-sheet.tsx
msgid "in the past"
msgstr "in the past"

#: app/frontend/components/v2/chrome/mobile-bottom-nav.tsx
#: app/frontend/components/v2/inbox/inbox-list.tsx
#: app/frontend/components/v2/inbox/mobile-shell.tsx
#: app/frontend/components/v2/inbox/rail.tsx
#: app/frontend/components/v2/inbox/sidebar.tsx
#: app/frontend/components/v2/landing/landing-footer.tsx
#: app/frontend/pages/v2/notifications/index.tsx
msgid "Inbox"
msgstr "Inbox"

#: app/frontend/components/v2/settings/team/access-card.tsx
msgid "Inbox access"
msgstr "Inbox access"

#: app/frontend/components/v2/inbox/filter-pills.tsx
msgid "Inbox filters"
msgstr "Inbox filters"

#: app/frontend/pages/v2/today/show.tsx
msgid "Inbox zero"
msgstr "Inbox zero"

#: app/frontend/components/v2/settings/usage/usage-stats.tsx
msgid "included"
msgstr "included"

#: app/frontend/components/v2/settings/phone-numbers/buy/capability-toggle-row.tsx
msgid "Included"
msgstr "Included"

#: app/frontend/components/v2/settings/usage/included-card.tsx
msgid "Included with your plan"
msgstr "Included with your plan"

#: app/frontend/components/v2/voice/call-row.tsx
#: app/frontend/components/v2/voice/incoming-call-sheet.tsx
msgid "Incoming call"
msgstr "Incoming call"

#: app/frontend/components/v2/deals/activity-feed.tsx
msgid "Incoming message"
msgstr "Incoming message"

#: app/frontend/components/v2/companies/index-table.tsx
#: app/frontend/components/v2/companies/properties-section.tsx
msgid "Industry"
msgstr "Industry"

#: app/frontend/components/v2/inbox/chat-panel.tsx
msgid "Insert emoji"
msgstr "Insert emoji"

#: app/frontend/components/v2/inbox/compose/freeform-body.tsx
msgid "Insert image"
msgstr "Insert image"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Insert variable"
msgstr "Insert variable"

#: app/frontend/pages/v2/settings/channels/show.tsx
#: app/frontend/pages/v2/settings/channels/show.tsx
msgid "Instagram DM"
msgstr "Instagram DM"

#: app/frontend/lib/settings-nav.ts
msgid "Integrations"
msgstr "Integrations"

#: app/frontend/pages/v2/settings/team/index.tsx
#: app/frontend/pages/v2/settings/team/index.tsx
msgid "Invite teammate"
msgstr "Invite teammate"

#: app/frontend/lib/settings-nav.ts
msgid "Invite teammates and set roles."
msgstr "Invite teammates and set roles."

#: app/frontend/pages/v2/settings/team/index.tsx
msgid "Invite teammates is coming soon."
msgstr "Invite teammates is coming soon."

#: app/frontend/pages/v2/settings/team/index.tsx
msgid "Invite your first teammate to start sharing the inbox."
msgstr "Invite your first teammate to start sharing the inbox."

#: app/frontend/types/v2/contact-filters.ts
msgid "is"
msgstr "is"

#: app/frontend/types/v2/deal-filters.ts
msgid "is after"
msgstr "is after"

#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/types/v2/contact-filters.ts
#: app/frontend/types/v2/contact-filters.ts
#: app/frontend/types/v2/contact-filters.ts
#: app/frontend/types/v2/contact-filters.ts
#: app/frontend/types/v2/contact-filters.ts
#: app/frontend/types/v2/contact-filters.ts
#: app/frontend/types/v2/deal-filters.ts
#: app/frontend/types/v2/deal-filters.ts
#: app/frontend/types/v2/deal-filters.ts
#: app/frontend/types/v2/deal-filters.ts
#: app/frontend/types/v2/deal-filters.ts
msgid "is any of"
msgstr "is any of"

#: app/frontend/types/v2/deal-filters.ts
msgid "is at least"
msgstr "is at least"

#: app/frontend/types/v2/deal-filters.ts
msgid "is at most"
msgstr "is at most"

#: app/frontend/types/v2/deal-filters.ts
msgid "is before"
msgstr "is before"

#: app/frontend/types/v2/deal-filters.ts
msgid "is between"
msgstr "is between"

#: app/frontend/types/v2/deal-filters.ts
msgid "is in"
msgstr "is in"

#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/types/v2/contact-filters.ts
#: app/frontend/types/v2/deal-filters.ts
msgid "is not"
msgstr "is not"

#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/types/v2/contact-filters.ts
#: app/frontend/types/v2/deal-filters.ts
msgid "is stale"
msgstr "is stale"

#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/types/v2/contact-filters.ts
#: app/frontend/types/v2/deal-filters.ts
msgid "is unassigned"
msgstr "is unassigned"

#: app/frontend/pages/v2/deals/show.tsx
msgid "It may have been deleted, or it belongs to a different workspace. Head back to your deals to see what's open."
msgstr "It may have been deleted, or it belongs to a different workspace. Head back to your deals to see what's open."

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "It's been over 24h since {firstName} last messaged. Only an approved template can send."
msgstr "It's been over 24h since {firstName} last messaged. Only an approved template can send."

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "It's been over 24h, so WhatsApp only allows an approved template — and you don't have one set up. Here's what works instead:"
msgstr "It's been over 24h, so WhatsApp only allows an approved template — and you don't have one set up. Here's what works instead:"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Italic"
msgstr "Italic"

#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
#: app/frontend/components/v2/inline-edit/date-popover.tsx
msgid "January"
msgstr "January"

#. placeholder {0}: employee.createdAtLabel
#: app/frontend/components/v2/settings/team/teammate-hero.tsx
msgid "Joined {0}"
msgstr "Joined {0}"

#: app/frontend/components/v2/voice/active-call-widget.tsx
msgid "Jot something for the summary…"
msgstr "Jot something for the summary…"

#: app/frontend/components/v2/inbox/compose/composer-attach-popover.tsx
msgid "JPG, PNG, GIF · up to 5 MB"
msgstr "JPG, PNG, GIF · up to 5 MB"

#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
#: app/frontend/components/v2/inline-edit/date-popover.tsx
msgid "July"
msgstr "July"

#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
#: app/frontend/components/v2/inline-edit/date-popover.tsx
msgid "June"
msgstr "June"

#: app/frontend/components/v2/deals/activity-feed.tsx
msgid "just now"
msgstr "just now"

#: app/frontend/components/v2/inbox/attach-offer-card.tsx
msgid "Keep separate"
msgstr "Keep separate"

#: app/frontend/components/v2/voice/after-call-more-sheet.tsx
msgid "Keep this deal"
msgstr "Keep this deal"

#: app/frontend/components/v2/voice/active-call-widget.tsx
msgid "Keypad"
msgstr "Keypad"

#: app/frontend/components/v2/deals/next-step-composer.tsx
#~ msgid "KIND"
#~ msgstr "KIND"

#: app/frontend/components/v2/settings/team/profile-card.tsx
#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/index.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Language"
msgstr "Language"

#: app/frontend/lib/usage-props.ts
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Last 30 days"
msgstr "Last 30 days"

#: app/frontend/components/v2/companies/index-table.tsx
#: app/frontend/components/v2/companies/index-toolbar.tsx
#: app/frontend/components/v2/contacts/index-toolbar.tsx
#: app/frontend/types/v2/contact-filters.ts
#: app/frontend/types/v2/deal-filters.ts
msgid "Last activity"
msgstr "Last activity"

#: app/frontend/components/v2/settings/team/security-card.tsx
msgid "Last sign-in"
msgstr "Last sign-in"

#. placeholder {0}: relativeTimeLabel(lastSyncedAt, now)
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/index.tsx
msgid "Last synced {0}"
msgstr "Last synced {0}"

#: app/frontend/components/v2/companies/company-drawer.tsx
#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/components/v2/drawer/entries/company-entry-body.tsx
#: app/frontend/pages/v2/companies/show.tsx
#: app/frontend/pages/v2/contacts/show.tsx
msgid "Last touch"
msgstr "Last touch"

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/index.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Last used"
msgstr "Last used"

#: app/frontend/pages/v2/today/show.tsx
msgid "Later this week"
msgstr "Later this week"

#: app/frontend/components/v2/voice/after-call-card.tsx
msgid "Left voicemail"
msgstr "Left voicemail"

#: app/frontend/components/v2/voice/after-call-card.tsx
#: app/frontend/components/v2/voice/after-call-card.tsx
#: app/frontend/components/v2/voice/after-call-more-sheet.tsx
#: app/frontend/components/v2/voice/call-detail-panel.tsx
msgid "Link a deal"
msgstr "Link a deal"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Link sample · e.g. https://example.com/order/1234"
msgstr "Link sample · e.g. https://example.com/order/1234"

#: app/frontend/components/v2/inbox/link-opportunity-panel.tsx
msgid "Link to an opportunity"
msgstr "Link to an opportunity"

#: app/frontend/components/v2/inbox/linked-deal-section.tsx
#: app/frontend/components/v2/inbox/linked-deal-section.tsx
#: app/frontend/components/v2/voice/after-call-more-sheet.tsx
#: app/frontend/components/v2/voice/call-detail-panel.tsx
msgid "Linked deal"
msgstr "Linked deal"

#: app/frontend/components/v2/inbox/filter-panel.tsx
msgid "Linked deal stage"
msgstr "Linked deal stage"

#. placeholder {0}: dealSubtitle(deal)
#: app/frontend/components/v2/voice/after-call-link-deal.tsx
msgid "Linked now · {0}"
msgstr "Linked now · {0}"

#: app/frontend/components/v2/inbox/linked-deal-section.tsx
msgid "Linked opportunities"
msgstr "Linked opportunities"

#: app/frontend/components/v2/inbox/linked-deal-section.tsx
msgid "Linked opportunity"
msgstr "Linked opportunity"

#. placeholder {0}: deal.name
#: app/frontend/components/v2/inbox/link-opportunity-panel.tsx
msgid "Linked to {0}"
msgstr "Linked to {0}"

#: app/frontend/pages/v2/contacts/index.tsx
msgid "Linked to a deal"
msgstr "Linked to a deal"

#: app/frontend/components/v2/companies/properties-section.tsx
#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/components/v2/drawer/entries/contact-entry-body.tsx
#: app/frontend/pages/v2/contacts/show.tsx
msgid "LinkedIn"
msgstr "LinkedIn"

#: app/frontend/pages/v2/settings/channels/show.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Live"
msgstr "Live"

#: app/frontend/pages/v2/settings/channels/show.tsx
msgid "Live chat"
msgstr "Live chat"

#: app/frontend/pages/v2/settings/channels/show.tsx
msgid "Live chat widget"
msgstr "Live chat widget"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Live preview"
msgstr "Live preview"

#: app/frontend/components/v2/companies/company-drawer.tsx
msgid "Loading company…"
msgstr "Loading company…"

#: app/frontend/components/v2/inbox/deal-drawer.tsx
msgid "Loading deal…"
msgstr "Loading deal…"

#: app/frontend/components/v2/inbox/mobile-row-pickers.tsx
#: app/frontend/components/v2/inbox/next-step-deal-popover.tsx
#: app/frontend/components/v2/voice/after-call-link-deal.tsx
#: app/frontend/components/v2/voice/call-detail-panel.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "Loading deals…"
msgstr "Loading deals…"

#: app/frontend/components/v2/inbox/message-transcript.tsx
msgid "Loading older messages"
msgstr "Loading older messages"

#: app/frontend/components/v2/search/drawer-preview-pane.tsx
msgid "Loading preview…"
msgstr "Loading preview…"

#: app/frontend/components/v2/settings/phone-numbers/buy/step-region.tsx
msgid "Loading regions…"
msgstr "Loading regions…"

#: app/frontend/components/v2/assignees/assignee-picker.tsx
#: app/frontend/components/v2/settings/phone-numbers/reassign-answerers.tsx
msgid "Loading teammates…"
msgstr "Loading teammates…"

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "Loading the follow-up…"
msgstr "Loading the follow-up…"

#: app/frontend/components/v2/drawer/drawer.tsx
msgid "Loading…"
msgstr "Loading…"

#: app/frontend/components/v2/settings/phone-numbers/add-card-interstitial.tsx
msgid "Local number (most countries)"
msgstr "Local number (most countries)"

#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/components/v2/drawer/entries/contact-entry-body.tsx
#: app/frontend/components/v2/inbox/compose/composer-actions-sheet.tsx
#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
#: app/frontend/lib/conversation-formatting.ts
#: app/frontend/pages/v2/contacts/show.tsx
msgid "Location"
msgstr "Location"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Location pin"
msgstr "Location pin"

#: app/frontend/components/v2/chrome/user-menu.tsx
msgid "Log out"
msgstr "Log out"

#: app/frontend/components/v2/voice/after-call-link-deal.tsx
msgid "Log this call against a deal — follow-ups move with it."
msgstr "Log this call against a deal — follow-ups move with it."

#: app/frontend/components/v2/voice/after-call-card.tsx
#: app/frontend/components/v2/voice/call-detail-panel.tsx
msgid "Logged"
msgstr "Logged"

#: app/frontend/pages/v2/companies/index.tsx
#: app/frontend/pages/v2/contacts/index.tsx
msgid "Loosen the filters above to see more."
msgstr "Loosen the filters above to see more."

#: app/frontend/components/v2/companies/pill.tsx
#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
#: app/frontend/lib/deal-stage.ts
msgid "Lost"
msgstr "Lost"

#: app/frontend/components/v2/landing/testimonials.tsx
msgid "Loved by closers"
msgstr "Loved by closers"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Lowercase, numbers, and underscores only. Internal — recipients don't see this."
msgstr "Lowercase, numbers, and underscores only. Internal — recipients don't see this."

#: app/frontend/components/v2/deals/deal-contact-card.tsx
#: app/frontend/components/v2/deals/deal-contact-picker.tsx
msgid "Make primary"
msgstr "Make primary"

#: app/frontend/components/v2/inbox/template-picker-bottom-sheet.tsx
#: app/frontend/pages/v2/settings/channels/show.tsx
msgid "Manage"
msgstr "Manage"

#: app/frontend/pages/v2/settings/billing/show.tsx
msgid "Manage billing"
msgstr "Manage billing"

#: app/frontend/components/v2/deals/deal-contact-card.tsx
#: app/frontend/components/v2/deals/deal-contact-picker.tsx
#: app/frontend/components/v2/deals/deal-contact-picker.tsx
msgid "Manage contacts"
msgstr "Manage contacts"

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Manage templates"
msgstr "Manage templates"

#: app/frontend/components/v2/inbox/compose/composer-templates-popover.tsx
#: app/frontend/components/v2/inbox/compose/composer-templates-popover.tsx
#: app/frontend/components/v2/inbox/compose/composer-templates-sheet.tsx
#: app/frontend/components/v2/inbox/template-picker-popover.tsx
#: app/frontend/components/v2/whatsapp-templates/follow-up-template-card.tsx
msgid "Manage templates →"
msgstr "Manage templates →"

#: app/frontend/pages/v2/settings/billing/show.tsx
msgid "Manage your plan, seats, and payment method."
msgstr "Manage your plan, seats, and payment method."

#: app/frontend/components/v2/settings/team/profile-card.tsx
#: app/frontend/components/v2/settings/team/teammate-hero.tsx
msgid "Manager"
msgstr "Manager"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Map each placeholder to a default source. Meta requires a sample value for review."
msgstr "Map each placeholder to a default source. Meta requires a sample value for review."

#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
#: app/frontend/components/v2/inline-edit/date-popover.tsx
msgid "March"
msgstr "March"

#. placeholder {0}: step.title ?? t`next step`
#: app/frontend/components/v2/deals/next-steps-section.tsx
msgid "Mark {0} complete"
msgstr "Mark {0} complete"

#: app/frontend/components/v2/notifications/notifications-list-content.tsx
#: app/frontend/pages/v2/notifications/index.tsx
#: app/frontend/pages/v2/notifications/index.tsx
msgid "Mark all read"
msgstr "Mark all read"

#: app/frontend/components/v2/deals/deal-more-menu.tsx
#: app/frontend/components/v2/deals/deal-more-menu.tsx
msgid "Mark as lost"
msgstr "Mark as lost"

#: app/frontend/components/v2/inbox/context-pane.tsx
msgid "Mark as not done"
msgstr "Mark as not done"

#: app/frontend/components/v2/inbox/conversation-more-menu.tsx
msgid "Mark as resolved"
msgstr "Mark as resolved"

#: app/frontend/components/v2/deals/deal-more-menu.tsx
#: app/frontend/components/v2/deals/deal-more-menu.tsx
msgid "Mark as won"
msgstr "Mark as won"

#: app/frontend/components/v2/inbox/context-pane.tsx
msgid "Mark complete"
msgstr "Mark complete"

#: app/frontend/components/v2/inbox/template-picker.tsx
msgid "Marketing"
msgstr "Marketing"

#: app/frontend/components/v2/deals/filter-popover.tsx
msgid "Maximum value"
msgstr "Maximum value"

#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
#: app/frontend/components/v2/inline-edit/date-popover.tsx
msgid "May"
msgstr "May"

#: app/frontend/components/v2/settings/phone-numbers/add-card-interstitial.tsx
msgid "Maybe later"
msgstr "Maybe later"

#: app/frontend/components/v2/inbox/compose/compose-modal.tsx
#: app/frontend/components/v2/inbox/compose/compose-modal.tsx
#: app/frontend/pages/v2/deals/show.tsx
msgid "Me"
msgstr "Me"

#: app/frontend/components/v2/deals/next-step-composer.tsx
#~ msgid "Me — {0}"
#~ msgstr "Me — {0}"

#. placeholder {0}: option.name
#: app/frontend/components/v2/inbox/mobile-row-pickers.tsx
msgid "Me · {0}"
msgstr "Me · {0}"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Media"
msgstr "Media"

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Median response"
msgstr "Median response"

#: app/frontend/components/v2/settings/team/team-stats-strip.tsx
msgid "Members"
msgstr "Members"

#: app/frontend/components/v2/deals/mobile-note-sheet.tsx
#: app/frontend/components/v2/deals/note-composer.tsx
msgid "Mention someone"
msgstr "Mention someone"

#: app/frontend/components/v2/deals/note-composer.tsx
msgid "Mention suggestions"
msgstr "Mention suggestions"

#: app/frontend/components/v2/notifications/notifications-list-content.tsx
#: app/frontend/pages/v2/notifications/index.tsx
msgid "Mentions"
msgstr "Mentions"

#: app/frontend/pages/v2/contacts/show.tsx
msgid "message"
msgstr "message"

#: app/frontend/components/v2/inbox/compose/freeform-body.tsx
#: app/frontend/components/v2/inbox/compose/freeform-body.tsx
#: app/frontend/lib/conversation-formatting.ts
#: app/frontend/lib/conversation-formatting.ts
#: app/frontend/lib/conversation-formatting.ts
msgid "Message"
msgstr "Message"

#: app/frontend/components/v2/voice/after-call-card.tsx
msgid "Message on WhatsApp"
msgstr "Message on WhatsApp"

#: app/frontend/pages/v2/contacts/show.tsx
msgid "messages"
msgstr "messages"

#: app/frontend/components/v2/deals/activity-feed.tsx
msgid "Messages"
msgstr "Messages"

#: app/frontend/pages/v2/settings/channels/show.tsx
msgid "messages this month"
msgstr "messages this month"

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Messages this month"
msgstr "Messages this month"

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Meta details"
msgstr "Meta details"

#: app/frontend/components/v2/inbox/failed-message-group.tsx
msgid "Meta is running an experiment on this recipient that temporarily caps sends. Try again later, or reach out another way in the meantime."
msgstr "Meta is running an experiment on this recipient that temporarily caps sends. Try again later, or reach out another way in the meantime."

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Meta rejected this template"
msgstr "Meta rejected this template"

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Meta removes it once any in-flight messages settle. You can't reuse this name for 30 days after deletion."
msgstr "Meta removes it once any in-flight messages settle. You can't reuse this name for 30 days after deletion."

#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Meta usually approves templates in under 30 minutes, but it can take up to 24h. You'll get a notification when it's ready to send."
msgstr "Meta usually approves templates in under 30 minutes, but it can take up to 24h. You'll get a notification when it's ready to send."

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
msgid "Meta usually re-approves edits in under 30 minutes. Sends pause until approval lands."
msgstr "Meta usually re-approves edits in under 30 minutes. Sends pause until approval lands."

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Meta-approved category"
msgstr "Meta-approved category"

#: app/frontend/components/v2/inbox/failed-message-group.tsx
msgid "Meta's algorithm blocked this delivery to protect message quality on this number. Try a different template, wait a bit, or reach out another way — repeated sends in the same template can make this worse."
msgstr "Meta's algorithm blocked this delivery to protect message quality on this number. Try a different template, wait a bit, or reach out another way — repeated sends in the same template can make this worse."

#: app/frontend/components/v2/deals/next-step-composer.tsx
#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "Method"
msgstr "Method"

#: app/frontend/components/v2/deals/next-step-composer.tsx
#~ msgid "METHOD"
#~ msgstr "METHOD"

#: app/frontend/components/v2/chrome/status-strip.tsx
msgid "Microphone"
msgstr "Microphone"

#: app/frontend/components/v2/chrome/status-strip.tsx
#: app/frontend/components/v2/chrome/status-strip.tsx
msgid "Microphones will appear once voice connects."
msgstr "Microphones will appear once voice connects."

#: app/frontend/components/v2/contacts/index-toolbar.tsx
#: app/frontend/components/v2/deals/filter-bar.tsx
#: app/frontend/components/v2/deals/mobile-filter-strip.tsx
#: app/frontend/components/v2/inbox/filter-pills.tsx
#: app/frontend/components/v2/today/mobile-tabs.tsx
msgid "Mine"
msgstr "Mine"

#: app/frontend/components/v2/deals/filter-popover.tsx
msgid "Minimum value"
msgstr "Minimum value"

#: app/frontend/components/v2/settings/usage/daily-spend-chart.tsx
msgid "Minutes"
msgstr "Minutes"

#: app/frontend/components/v2/voice/call-row.tsx
msgid "Missed"
msgstr "Missed"

#: app/frontend/pages/v2/companies/index.tsx
msgid "missing data"
msgstr "missing data"

#: app/frontend/pages/v2/companies/index.tsx
msgid "missing industry or size"
msgstr "missing industry or size"

#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
msgid "Mo"
msgstr "Mo"

#: app/frontend/pages/v2/dev/components/voice_card.tsx
msgid "Mobile sheet"
msgstr "Mobile sheet"

#: app/frontend/components/v2/settings/billing/billing-period-toggle.tsx
#: app/frontend/components/v2/settings/phone-numbers/phone-numbers-table.tsx
msgid "Monthly"
msgstr "Monthly"

#: app/frontend/components/v2/settings/phone-numbers/phone-number-stats.tsx
msgid "Monthly cost"
msgstr "Monthly cost"

#: app/frontend/components/v2/voice/after-call-card.tsx
#: app/frontend/components/v2/voice/after-call-more-sheet.tsx
msgid "More"
msgstr "More"

#: app/frontend/components/v2/inbox/chat-header.tsx
#: app/frontend/components/v2/inbox/mobile-conversation-detail.tsx
#: app/frontend/pages/v2/settings/channels/show.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/index.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "More actions"
msgstr "More actions"

#: app/frontend/components/v2/today/activity-row.tsx
#~ msgid "More options"
#~ msgstr "More options"

#: app/frontend/components/v2/settings/billing/plan-card.tsx
msgid "Most popular"
msgstr "Most popular"

#: app/frontend/components/v2/search/search-results-list.tsx
msgid "Most recent"
msgstr "Most recent"

#: app/frontend/components/v2/voice/after-call-more-sheet.tsx
msgid "Move deal to the next stage"
msgstr "Move deal to the next stage"

#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "Move to another deal"
msgstr "Move to another deal"

#. placeholder {0}: row.dealName
#: app/frontend/components/v2/inbox/context-pane.tsx
msgid "Move to another deal — currently {0}"
msgstr "Move to another deal — currently {0}"

#: app/frontend/components/v2/inbox/notes-section.tsx
msgid "Move to another deal — currently {label}"
msgstr "Move to another deal — currently {label}"

#: app/frontend/components/v2/inbox/next-step-deal-popover.tsx
#: app/frontend/components/v2/inbox/next-step-deal-popover.tsx
msgid "Move to deal"
msgstr "Move to deal"

#: app/frontend/components/v2/deals/mobile-stage-picker.tsx
#: app/frontend/components/v2/deals/mobile-stage-picker.tsx
#: app/frontend/components/v2/deals/stage-picker.tsx
#: app/frontend/components/v2/deals/stage-picker.tsx
msgid "Move to stage"
msgstr "Move to stage"

#: app/frontend/components/v2/voice/active-call-widget.tsx
msgid "Mute"
msgstr "Mute"

#: app/frontend/components/v2/inbox/conversation-more-menu.tsx
msgid "Mute notifications"
msgstr "Mute notifications"

#: app/frontend/components/v2/voice/active-call-widget.tsx
msgid "Muted"
msgstr "Muted"

#: app/frontend/pages/v2/today/show.tsx
msgid "My activities"
msgstr "My activities"

#: app/frontend/components/v2/companies/index-toolbar.tsx
#: app/frontend/components/v2/contacts/create-contact-modal.tsx
#: app/frontend/lib/activity-facets.ts
msgid "Name"
msgstr "Name"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
msgid "Name and language are locked once a template is approved by Meta."
msgstr "Name and language are locked once a template is approved by Meta."

#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Name and language stay the same after submission — choose carefully."
msgstr "Name and language stay the same after submission — choose carefully."

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
msgid "Name and language stay unchanged — you can't edit those for an approved template"
msgstr "Name and language stay unchanged — you can't edit those for an approved template"

#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
msgid "Name can't be blank."
msgstr "Name can't be blank."

#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Name character count"
msgstr "Name character count"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Name for variable {n}"
msgstr "Name for variable {n}"

#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/components/v2/deals/filter-popover.tsx
#: app/frontend/components/v2/inbox/filter-panel.tsx
msgid "Name this view"
msgstr "Name this view"

#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Name uses only lowercase letters, numbers, and underscores"
msgstr "Name uses only lowercase letters, numbers, and underscores"

#: app/frontend/components/v2/drawer/entries/contact-entry-body.tsx
msgid "name@example.com"
msgstr "name@example.com"

#: app/frontend/components/v2/search/palette-footer.tsx
#: app/frontend/lib/commands.ts
msgid "Navigate"
msgstr "Navigate"

#: app/frontend/components/v2/chrome/mobile-nav-drawer.tsx
msgid "Navigation"
msgstr "Navigation"

#: app/frontend/components/v2/companies/pill.tsx
#: app/frontend/components/v2/companies/pill.tsx
#: app/frontend/pages/v2/companies/index.tsx
msgid "Needs enrichment"
msgstr "Needs enrichment"

#: app/frontend/components/v2/deals/deal-conversations-card.tsx
#: app/frontend/components/v2/inbox/filter-panel.tsx
msgid "Needs reply"
msgstr "Needs reply"

#: app/frontend/components/v2/companies/pill.tsx
#: app/frontend/components/v2/deals/filter-bar.tsx
#: app/frontend/components/v2/deals/mobile-deal-show-panel.tsx
#: app/frontend/components/v2/deals/mobile-filter-strip.tsx
#: app/frontend/pages/v2/contacts/index.tsx
#: app/frontend/pages/v2/contacts/index.tsx
msgid "Needs you"
msgstr "Needs you"

#: app/frontend/components/v2/inbox/summary-section.tsx
#: app/frontend/components/v2/voice/sentiment.tsx
#: app/frontend/lib/voice-disposition.ts
msgid "Negative"
msgstr "Negative"

#: app/frontend/components/v2/inbox/summary-section.tsx
#: app/frontend/components/v2/voice/sentiment.tsx
#: app/frontend/lib/voice-disposition.ts
msgid "Neutral"
msgstr "Neutral"

#: app/frontend/components/v2/contacts/index-toolbar.tsx
msgid "Never contacted"
msgstr "Never contacted"

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Never sent"
msgstr "Never sent"

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/index.tsx
msgid "Never synced"
msgstr "Never synced"

#: app/frontend/components/v2/inbox/inbox-list.tsx
#: app/frontend/components/v2/landing/feature-capture.tsx
msgid "New"
msgstr "New"

#: app/frontend/components/v2/companies/index-header.tsx
msgid "New company"
msgstr "New company"

#: app/frontend/components/v2/contacts/create-contact-modal.tsx
#: app/frontend/components/v2/contacts/create-contact-modal.tsx
#: app/frontend/components/v2/contacts/create-contact-modal.tsx
#: app/frontend/components/v2/contacts/create-contact-modal.tsx
#: app/frontend/components/v2/contacts/index-header.tsx
#: app/frontend/components/v2/inbox/compose/compose-modal.tsx
#: app/frontend/components/v2/inbox/compose/recipient-picker.tsx
#: app/frontend/pages/v2/contacts/index.tsx
msgid "New contact"
msgstr "New contact"

#: app/frontend/components/v2/inbox/compose/compose-modal.tsx
#: app/frontend/components/v2/inbox/compose/compose-modal.tsx
#: app/frontend/components/v2/inbox/compose/compose-modal.tsx
#: app/frontend/components/v2/inbox/compose/compose-modal.tsx
msgid "New conversation"
msgstr "New conversation"

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "New conversations on this channel are assigned to this teammate by default."
msgstr "New conversations on this channel are assigned to this teammate by default."

#: app/frontend/components/v2/deals/create-deal-modal.tsx
#: app/frontend/components/v2/deals/create-deal-modal.tsx
#: app/frontend/components/v2/deals/create-deal-modal.tsx
#: app/frontend/components/v2/deals/create-deal-modal.tsx
#: app/frontend/components/v2/deals/mobile-deals-shell.tsx
#: app/frontend/components/v2/deals/pipeline-board.tsx
#: app/frontend/components/v2/deals/pipeline-board.tsx
#: app/frontend/components/v2/landing/feature-pipeline.tsx
#: app/frontend/components/v2/voice/after-call-link-deal.tsx
#: app/frontend/components/v2/voice/after-call-link-deal.tsx
#: app/frontend/components/v2/voice/call-detail-panel.tsx
msgid "New deal"
msgstr "New deal"

#: app/frontend/components/v2/voice/after-call-link-deal.tsx
msgid "New deal for {firstName}"
msgstr "New deal for {firstName}"

#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "New follow-up"
msgstr "New follow-up"

#: app/frontend/components/v2/inbox/chat-panel.tsx
msgid "new line"
msgstr "new line"

#: app/frontend/components/v2/inbox/notes-section.tsx
msgid "New note"
msgstr "New note"

#: app/frontend/components/v2/notifications/notifications-list-content.tsx
msgid "New notifications will show up here."
msgstr "New notifications will show up here."

#: app/frontend/components/v2/inbox/create-opportunity-panel.tsx
msgid "New opportunity"
msgstr "New opportunity"

#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/index.tsx
msgid "New template"
msgstr "New template"

#: app/frontend/components/v2/landing/feature-capture.tsx
msgid "New WhatsApp message"
msgstr "New WhatsApp message"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
msgid "Next edit available in ~{hrs}h"
msgstr "Next edit available in ~{hrs}h"

#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
#: app/frontend/components/v2/inbox/conversation-snooze-date-picker-sheet.tsx
#: app/frontend/components/v2/inline-edit/date-popover.tsx
msgid "Next month"
msgstr "Next month"

#: app/frontend/components/v2/deals/next-steps-section.tsx
msgid "next step"
msgstr "next step"

#: app/frontend/components/v2/deals/mobile-history-fab-picker.tsx
#: app/frontend/components/v2/deals/next-steps-section.tsx
#: app/frontend/components/v2/deals/next-steps-section.tsx
msgid "Next step"
msgstr "Next step"

#: app/frontend/components/v2/inbox/suggested-next-step-row.tsx
msgid "Next step added"
msgstr "Next step added"

#: app/frontend/components/v2/deals/next-steps-section.tsx
msgid "Next step options"
msgstr "Next step options"

#: app/frontend/components/v2/deals/next-step-composer.tsx
#: app/frontend/components/v2/inbox/context-pane.tsx
msgid "Next step title"
msgstr "Next step title"

#: app/frontend/components/v2/deals/next-steps-section.tsx
#: app/frontend/components/v2/deals/next-steps-section.tsx
#: app/frontend/components/v2/inbox/context-pane.tsx
msgid "Next steps"
msgstr "Next steps"

#: app/frontend/components/v2/inbox/mobile-row-pickers.tsx
msgid "Next week"
msgstr "Next week"

#: app/frontend/pages/v2/sessions/new.tsx
msgid "No account?"
msgstr "No account?"

#: app/frontend/pages/v2/today/show.tsx
msgid "No activities for tomorrow yet."
msgstr "No activities for tomorrow yet."

#: app/frontend/components/v2/companies/company-drawer.tsx
#: app/frontend/components/v2/drawer/entries/company-entry-body.tsx
msgid "No activity yet for this company."
msgstr "No activity yet for this company."

#: app/frontend/components/v2/voice/after-call-card.tsx
#: app/frontend/components/v2/voice/after-call-card.tsx
#: app/frontend/lib/voice-disposition.ts
msgid "No answer"
msgstr "No answer"

#: app/frontend/lib/voice-disposition.ts
msgid "No answer — line rang out"
msgstr "No answer — line rang out"

#: app/frontend/components/v2/voice/after-call-card.tsx
msgid "No answer · rang {ringSeconds}s"
msgstr "No answer · rang {ringSeconds}s"

#: app/frontend/components/v2/inbox/template-picker.tsx
msgid "No approved templates in this category yet."
msgstr "No approved templates in this category yet."

#: app/frontend/components/v2/inbox/failed-template-expander.tsx
msgid "No approved templates yet"
msgstr "No approved templates yet"

#: app/frontend/components/v2/whatsapp-templates/follow-up-template-card.tsx
msgid "No approved templates yet."
msgstr "No approved templates yet."

#: app/frontend/components/v2/chrome/status-strip.tsx
msgid "No calls, notifications muted"
msgstr "No calls, notifications muted"

#: app/frontend/components/v2/search/command-list.tsx
msgid "No command matches \"{filter}\""
msgstr "No command matches \"{filter}\""

#: app/frontend/pages/v2/companies/index.tsx
msgid "No companies match"
msgstr "No companies match"

#: app/frontend/pages/v2/companies/index.tsx
msgid "No companies yet"
msgstr "No companies yet"

#: app/frontend/components/v2/companies/company-drawer.tsx
#: app/frontend/components/v2/companies/people-section.tsx
#: app/frontend/components/v2/drawer/entries/company-entry-body.tsx
msgid "No contacts linked to this company yet."
msgstr "No contacts linked to this company yet."

#: app/frontend/pages/v2/contacts/index.tsx
msgid "No contacts match"
msgstr "No contacts match"

#: app/frontend/pages/v2/contacts/index.tsx
msgid "No contacts yet"
msgstr "No contacts yet"

#: app/frontend/components/v2/inbox/inbox-list.tsx
#: app/frontend/components/v2/inbox/mobile-shell.tsx
msgid "No conversations match \"{query}\""
msgstr "No conversations match \"{query}\""

#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/pages/v2/contacts/show.tsx
msgid "No conversations yet."
msgstr "No conversations yet."

#. placeholder {0}: query.trim()
#: app/frontend/components/v2/settings/phone-numbers/buy/step-country.tsx
msgid "No countries match \"{0}\". Try another search."
msgstr "No countries match \"{0}\". Try another search."

#: app/frontend/components/v2/inbox/compose/compose-modal.tsx
#: app/frontend/components/v2/inbox/compose/compose-modal.tsx
#: app/frontend/components/v2/inbox/notes-section.tsx
#: app/frontend/pages/v2/dev/components/voice_card.tsx
msgid "No deal"
msgstr "No deal"

#: app/frontend/components/v2/inbox/mobile-row-pickers.tsx
#: app/frontend/components/v2/inbox/next-step-deal-popover.tsx
msgid "No deal — just the contact"
msgstr "No deal — just the contact"

#: app/frontend/components/v2/inbox/filter-panel.tsx
msgid "No deal stages yet. Add a pipeline to filter by stage."
msgstr "No deal stages yet. Add a pipeline to filter by stage."

#: app/frontend/components/v2/inbox/linked-deal-section.tsx
msgid "No deal yet"
msgstr "No deal yet"

#. placeholder {0}: voiceCall.contact?.name ?? t`this contact`
#: app/frontend/components/v2/voice/call-detail-panel.tsx
msgid "No deals linked to <0>{0}</0> yet. Create one to attach this call."
msgstr "No deals linked to <0>{0}</0> yet. Create one to attach this call."

#: app/frontend/components/v2/voice/after-call-link-deal.tsx
msgid "No deals match \"{search}\"."
msgstr "No deals match \"{search}\"."

#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/pages/v2/contacts/show.tsx
msgid "No deals tracked for this contact yet."
msgstr "No deals tracked for this contact yet."

#: app/frontend/components/v2/voice/after-call-link-deal.tsx
msgid "No deals with {firstName} yet"
msgstr "No deals with {firstName} yet"

#: app/frontend/components/v2/companies/company-drawer.tsx
#: app/frontend/components/v2/companies/deals-section.tsx
#: app/frontend/components/v2/drawer/entries/company-entry-body.tsx
msgid "No deals yet at this company."
msgstr "No deals yet at this company."

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "No default assignee"
msgstr "No default assignee"

#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/pages/v2/contacts/show.tsx
msgid "No files yet"
msgstr "No files yet"

#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "No follow-ups yet."
msgstr "No follow-ups yet."

#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "No follow-ups yet. Add one to keep things moving."
msgstr "No follow-ups yet. Add one to keep things moving."

#: app/frontend/components/v2/voice/call-detail-panel.tsx
#: app/frontend/components/v2/voice/call-detail-panel.tsx
msgid "No linked deal"
msgstr "No linked deal"

#: app/frontend/components/v2/deals/create-deal-modal.tsx
msgid "No matches. Try a different name, email, or phone."
msgstr "No matches. Try a different name, email, or phone."

#: app/frontend/components/v2/deals/deal-contact-picker.tsx
msgid "No matches. Try a different name."
msgstr "No matches. Try a different name."

#: app/frontend/components/v2/inbox/compose/recipient-picker.tsx
msgid "No matching contact"
msgstr "No matching contact"

#: app/frontend/components/v2/notifications/notifications-list-content.tsx
msgid "No mentions yet."
msgstr "No mentions yet."

#: app/frontend/components/v2/inbox/conversation-row.tsx
#: app/frontend/components/v2/inbox/message-transcript.tsx
msgid "No messages yet"
msgstr "No messages yet"

#: app/frontend/components/v2/chrome/status-strip.tsx
msgid "No microphone detected. Connect one and allow mic access to choose it here."
msgstr "No microphone detected. Connect one and allow mic access to choose it here."

#: app/frontend/components/v2/landing/feature-today.tsx
msgid "No more deciding where to start. The AI lines up exactly who to follow up with, and why — you just work the queue."
msgstr "No more deciding where to start. The AI lines up exactly who to follow up with, and why — you just work the queue."

#. placeholder {0}: contact.addedAgo
#: app/frontend/components/v2/inbox/contact-section.tsx
msgid "No name yet · {0}"
msgstr "No name yet · {0}"

#: app/frontend/components/v2/deals/filter-bar.tsx
#: app/frontend/components/v2/deals/mobile-filter-strip.tsx
#: app/frontend/components/v2/deals/next-steps-section.tsx
msgid "No next step"
msgstr "No next step"

#: app/frontend/components/v2/deals/next-steps-section.tsx
msgid "No next steps yet. Add one to track what comes next on this deal."
msgstr "No next steps yet. Add one to track what comes next on this deal."

#: app/frontend/components/v2/notifications/notifications-list-content.tsx
msgid "No notifications yet."
msgstr "No notifications yet."

#: app/frontend/pages/v2/settings/phone_numbers/index.tsx
msgid "No numbers match"
msgstr "No numbers match"

#. placeholder {0}: query.trim()
#: app/frontend/components/v2/settings/team/team-answers-popover.tsx
msgid "No numbers match \"{0}\"."
msgstr "No numbers match \"{0}\"."

#: app/frontend/components/v2/settings/team/team-member-row.tsx
msgid "No numbers yet"
msgstr "No numbers yet"

#: app/frontend/components/v2/settings/team/team-answers-popover.tsx
msgid "No numbers yet. Buy one from the Phone numbers settings."
msgstr "No numbers yet. Buy one from the Phone numbers settings."

#: app/frontend/components/v2/inbox/mobile-row-pickers.tsx
#: app/frontend/components/v2/inbox/next-step-deal-popover.tsx
msgid "No open deals for this contact yet."
msgstr "No open deals for this contact yet."

#: app/frontend/components/v2/contacts/filter-popover.tsx
msgid "No options available"
msgstr "No options available"

#: app/frontend/components/v2/inbox/other-ways-popover.tsx
msgid "No other contact details on file yet. Add a phone or email on the contact card to reach out elsewhere."
msgstr "No other contact details on file yet. Add a phone or email on the contact card to reach out elsewhere."

#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "No other deals to move this to yet."
msgstr "No other deals to move this to yet."

#: app/frontend/components/v2/inbox/link-opportunity-panel.tsx
msgid "No other open opportunities to link."
msgstr "No other open opportunities to link."

#: app/frontend/components/v2/contacts/row-actions.tsx
msgid "No phone number on file"
msgstr "No phone number on file"

#: app/frontend/components/v2/settings/phone-numbers/empty-state.tsx
msgid "No phone numbers yet"
msgstr "No phone numbers yet"

#: app/frontend/components/v2/voice/after-call-link-deal.tsx
msgid "No pipeline available"
msgstr "No pipeline available"

#: app/frontend/components/v2/deals/mobile-deals-shell.tsx
#: app/frontend/components/v2/deals/pipeline-board.tsx
msgid "No pipeline set up yet."
msgstr "No pipeline set up yet."

#: app/frontend/pages/v2/dev/components/voice_card.tsx
msgid "No preview call available — run <0>db:seed</0> in the agent."
msgstr "No preview call available — run <0>db:seed</0> in the agent."

#: app/frontend/components/v2/voice/after-call-link-deal.tsx
msgid "No problem — this call's follow-ups track on {firstName}'s contact. Link a deal anytime later."
msgstr "No problem — this call's follow-ups track on {firstName}'s contact. Link a deal anytime later."

#: app/frontend/components/v2/inbox/compose/composer-quick-replies.tsx
msgid "No quick replies yet. Create your first one from Settings."
msgstr "No quick replies yet. Create your first one from Settings."

#: app/frontend/components/v2/settings/phone-numbers/buy/step-region.tsx
msgid "No regions match. Try another search."
msgstr "No regions match. Try another search."

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "No sends yet"
msgstr "No sends yet"

#: app/frontend/components/v2/inbox/compose/composer-quick-replies.tsx
msgid "No shortcuts match “{query}”."
msgstr "No shortcuts match “{query}”."

#: app/frontend/components/v2/voice/transcript-turns.tsx
msgid "No speech was captured on this call."
msgstr "No speech was captured on this call."

#: app/frontend/components/v2/deals/pipeline-board.tsx
msgid "No stages yet."
msgstr "No stages yet."

#: app/frontend/components/v2/inbox/compose/staged-template.tsx
msgid "No suggestion"
msgstr "No suggestion"

#: app/frontend/pages/v2/contacts/show.tsx
msgid "No tags yet."
msgstr "No tags yet."

#: app/frontend/components/v2/settings/team/team-members-table.tsx
#: app/frontend/pages/v2/settings/team/index.tsx
msgid "No teammates match"
msgstr "No teammates match"

#. placeholder {0}: query.trim()
#: app/frontend/components/v2/assignees/assignee-picker.tsx
#: app/frontend/components/v2/settings/phone-numbers/buy/step-assign.tsx
#: app/frontend/components/v2/settings/phone-numbers/reassign-answerers.tsx
msgid "No teammates match \"{0}\"."
msgstr "No teammates match \"{0}\"."

#: app/frontend/components/v2/inbox/assignment-popover.tsx
msgid "No teammates match \"{query}\"."
msgstr "No teammates match \"{query}\"."

#: app/frontend/components/v2/inbox/teammates-sub-view.tsx
msgid "No teammates match “{query}”."
msgstr "No teammates match “{query}”."

#: app/frontend/components/v2/whatsapp-templates/follow-up-template-card.tsx
msgid "No template (let AI pick the best match)"
msgstr "No template (let AI pick the best match)"

#: app/frontend/components/v2/whatsapp-templates/follow-up-template-card.tsx
msgid "No template pinned — the AI picks the best match."
msgstr "No template pinned — the AI picks the best match."

#: app/frontend/components/v2/whatsapp-templates/follow-up-template-card.tsx
msgid "No template pinned? The AI picks the best-matching approved template. No approved templates at all → the post-call card offers a call-back instead of dead-ending."
msgstr "No template pinned? The AI picks the best-matching approved template. No approved templates at all → the post-call card offers a call-back instead of dead-ending."

#: app/frontend/components/v2/inbox/compose/composer-templates-popover.tsx
#: app/frontend/components/v2/inbox/compose/composer-templates-sheet.tsx
#: app/frontend/components/v2/inbox/template-picker.tsx
msgid "No templates match “{query}”."
msgstr "No templates match “{query}”."

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "No templates match \"{search}\"."
msgstr "No templates match \"{search}\"."

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/index.tsx
msgid "No templates yet"
msgstr "No templates yet"

#: app/frontend/components/v2/inbox/compose/composer-templates-popover.tsx
#: app/frontend/components/v2/inbox/compose/composer-templates-sheet.tsx
msgid "No templates yet."
msgstr "No templates yet."

#: app/frontend/components/v2/inbox/mobile-row-pickers.tsx
msgid "No value"
msgstr "No value"

#: app/frontend/components/v2/inbox/attach-offer-card.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "None"
msgstr "None"

#: app/frontend/components/v2/inbox/failed-message-group.tsx
msgid "Not delivered"
msgstr "Not delivered"

#: app/frontend/components/v2/settings/team/security-card.tsx
msgid "Not enabled"
msgstr "Not enabled"

#: app/frontend/components/v2/chrome/status-strip.tsx
msgid "Not routing anything to you"
msgstr "Not routing anything to you"

#: app/frontend/components/v2/deals/mobile-history-fab-picker.tsx
#: app/frontend/components/v2/voice/active-call-widget.tsx
msgid "Note"
msgstr "Note"

#: app/frontend/components/v2/inbox/notes-section.tsx
msgid "Note actions"
msgstr "Note actions"

#: app/frontend/components/v2/inbox/notes-section.tsx
#: app/frontend/components/v2/voice/after-call-card.tsx
msgid "Note deleted"
msgstr "Note deleted"

#: app/frontend/components/v2/voice/after-call-more-sheet.tsx
msgid "Note visibility"
msgstr "Note visibility"

#: app/frontend/components/v2/deals/activity-feed.tsx
#: app/frontend/components/v2/inbox/notes-section.tsx
#: app/frontend/types/v2/search.ts
msgid "Notes"
msgstr "Notes"

#: app/frontend/components/v2/inbox/inbox-list.tsx
#: app/frontend/components/v2/inbox/mobile-shell.tsx
msgid "Nothing assigned to you right now"
msgstr "Nothing assigned to you right now"

#: app/frontend/components/v2/notifications/notifications-list-content.tsx
msgid "Nothing assigned to you."
msgstr "Nothing assigned to you."

#: app/frontend/pages/v2/today/show.tsx
msgid "Nothing completed today yet."
msgstr "Nothing completed today yet."

#: app/frontend/components/v2/companies/activity-section.tsx
msgid "Nothing has happened at this company yet."
msgstr "Nothing has happened at this company yet."

#: app/frontend/components/v2/deals/deal-column.tsx
#: app/frontend/components/v2/deals/mobile-deals-shell.tsx
msgid "Nothing here yet."
msgstr "Nothing here yet."

#: app/frontend/components/v2/inbox/inbox-list.tsx
#: app/frontend/components/v2/inbox/mobile-shell.tsx
msgid "Nothing in your inbox yet"
msgstr "Nothing in your inbox yet"

#: app/frontend/components/v2/search/search-results-list.tsx
msgid "Nothing matches “{query}” yet"
msgstr "Nothing matches “{query}” yet"

#: app/frontend/pages/v2/today/show.tsx
msgid "Nothing on your plate right now. Enjoy the breathing room — new work shows up here as it comes in."
msgstr "Nothing on your plate right now. Enjoy the breathing room — new work shows up here as it comes in."

#: app/frontend/pages/v2/today/show.tsx
msgid "Nothing overdue — you're caught up."
msgstr "Nothing overdue — you're caught up."

#: app/frontend/pages/v2/today/show.tsx
#: app/frontend/pages/v2/today/show.tsx
msgid "Nothing scheduled"
msgstr "Nothing scheduled"

#: app/frontend/pages/v2/today/show.tsx
msgid "Nothing scheduled for today yet."
msgstr "Nothing scheduled for today yet."

#: app/frontend/pages/v2/today/show.tsx
msgid "Nothing scheduled later this week yet."
msgstr "Nothing scheduled later this week yet."

#: app/frontend/components/v2/settings/usage/daily-spend-chart.tsx
msgid "Nothing to chart yet — your daily telephony will appear here as you make and receive calls."
msgstr "Nothing to chart yet — your daily telephony will appear here as you make and receive calls."

#: app/frontend/components/v2/deals/filter-popover.tsx
#: app/frontend/components/v2/deals/filter-popover.tsx
msgid "Nothing to pick yet."
msgstr "Nothing to pick yet."

#: app/frontend/components/v2/settings/team/recent-activity-card.tsx
msgid "Nothing to show yet. Once they make calls, send messages, or close deals, you'll see it here."
msgstr "Nothing to show yet. Once they make calls, send messages, or close deals, you'll see it here."

#: app/frontend/pages/v2/today/show.tsx
msgid "Nothing yet"
msgstr "Nothing yet"

#: app/frontend/components/v2/settings/usage/billed-card.tsx
msgid "Nothing yet this period — your phone numbers and calls will show up here as you use them."
msgstr "Nothing yet this period — your phone numbers and calls will show up here as you use them."

#: app/frontend/pages/v2/notifications/index.tsx
msgid "Notification settings"
msgstr "Notification settings"

#: app/frontend/components/v2/chrome/notifications-bell.tsx
#: app/frontend/components/v2/notifications/notifications-list-content.tsx
#: app/frontend/lib/settings-nav.ts
#: app/frontend/pages/v2/notifications/index.tsx
#: app/frontend/pages/v2/notifications/index.tsx
#: app/frontend/pages/v2/notifications/index.tsx
msgid "Notifications"
msgstr "Notifications"

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "Notify me when {firstName} replies"
msgstr "Notify me when {firstName} replies"

#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
#: app/frontend/components/v2/inline-edit/date-popover.tsx
msgid "November"
msgstr "November"

#: app/frontend/components/v2/settings/phone-numbers/phone-numbers-table.tsx
#: app/frontend/components/v2/settings/phone-numbers/row-kebab.tsx
msgid "Number"
msgstr "Number"

#: app/frontend/components/v2/settings/phone-numbers/row-kebab.tsx
#: app/frontend/components/v2/settings/phone-numbers/row-kebab.tsx
#: app/frontend/components/v2/settings/phone-numbers/row-kebab.tsx
msgid "Number actions"
msgstr "Number actions"

#: app/frontend/components/v2/settings/usage/daily-spend-chart.tsx
msgid "Numbers"
msgstr "Numbers"

#: app/frontend/components/v2/settings/phone-numbers/empty-state.tsx
msgid "Numbers start at {priceLabel}"
msgstr "Numbers start at {priceLabel}"

#: app/frontend/components/v2/settings/team/answers-on-card.tsx
msgid "Numbers this teammate picks up for."
msgstr "Numbers this teammate picks up for."

#: app/frontend/pages/v2/settings/phone_numbers/index.tsx
msgid "Numbers your team uses to call and message customers. Buy and assign them here."
msgstr "Numbers your team uses to call and message customers. Buy and assign them here."

#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
#: app/frontend/components/v2/inline-edit/date-popover.tsx
msgid "October"
msgstr "October"

#: app/frontend/components/v2/settings/team/team-member-row.tsx
msgid "Off"
msgstr "Off"

#: app/frontend/components/v2/chrome/status-strip.tsx
#: app/frontend/components/v2/chrome/status-strip.tsx
msgid "Offline"
msgstr "Offline"

#: app/frontend/components/v2/settings/team/team-member-row.tsx
msgid "On"
msgstr "On"

#. placeholder {0}: linkedDeal.name
#. placeholder {0}: voiceCall.deal.name
#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/inbox/notes-section.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "On {0}"
msgstr "On {0}"

#: app/frontend/components/v2/inbox/header-call-button.tsx
msgid "On call"
msgstr "On call"

#: app/frontend/components/v2/deals/deal-contact-picker.tsx
msgid "On this deal"
msgstr "On this deal"

#: app/frontend/components/v2/inbox/message-transcript.tsx
msgid "Once a message comes in, it'll show up here."
msgstr "Once a message comes in, it'll show up here."

#: app/frontend/components/v2/whatsapp-templates/follow-up-template-card.tsx
msgid "Once a template is approved by Meta, pin it here."
msgstr "Once a template is approved by Meta, pin it here."

#: app/frontend/pages/v2/contacts/index.tsx
msgid "Once you start a WhatsApp or voice conversation, the person on the other end shows up here."
msgstr "Once you start a WhatsApp or voice conversation, the person on the other end shows up here."

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "One header per template — text, image, video, document, or a map location."
msgstr "One header per template — text, image, video, document, or a map location."

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "Only an approved template can send outside the 24h window. AI refills the blanks for whichever you pick."
msgstr "Only an approved template can send outside the 24h window. AI refills the blanks for whichever you pick."

#: app/frontend/components/v2/whatsapp-templates/follow-up-template-card.tsx
msgid "Only approved templates appear here."
msgstr "Only approved templates appear here."

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
msgid "Only category and components can change. Template name and language are locked once approved. Meta usually re-approves in under 30 minutes."
msgstr "Only category and components can change. Template name and language are locked once approved. Meta usually re-approves in under 30 minutes."

#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
#: app/frontend/components/v2/search/palette-footer.tsx
#: app/frontend/lib/deal-stage.ts
msgid "Open"
msgstr "Open"

#. placeholder {0}: template.name
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/index.tsx
msgid "Open {0}"
msgstr "Open {0}"

#. placeholder {0}: company.name
#. placeholder {0}: deal.company.name
#: app/frontend/components/v2/deals/deal-show-panel.tsx
#: app/frontend/components/v2/deals/mobile-deal-show-panel.tsx
msgid "Open {0} details"
msgstr "Open {0} details"

#: app/frontend/components/v2/chrome/user-menu.tsx
#: app/frontend/components/v2/chrome/user-menu.tsx
msgid "Open account menu"
msgstr "Open account menu"

#: app/frontend/components/v2/chrome/status-strip.tsx
msgid "Open availability menu"
msgstr "Open availability menu"

#: app/frontend/components/v2/voice/call-row.tsx
msgid "Open call"
msgstr "Open call"

#: app/frontend/components/v2/inbox/message-bubble.tsx
msgid "Open call →"
msgstr "Open call →"

#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/components/v2/deals/mobile-deal-show-panel.tsx
#: app/frontend/components/v2/drawer/entries/contact-entry-body.tsx
msgid "Open chat"
msgstr "Open chat"

#: app/frontend/components/v2/deals/mobile-deal-show-panel.tsx
msgid "Open chat (coming soon)"
msgstr "Open chat (coming soon)"

#. placeholder {0}: deal.name
#: app/frontend/components/v2/deals/deal-card.tsx
#: app/frontend/components/v2/deals/mobile-deal-card.tsx
msgid "Open deal: {0}"
msgstr "Open deal: {0}"

#: app/frontend/components/v2/companies/company-drawer.tsx
#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/components/v2/drawer/entries/company-entry-body.tsx
#: app/frontend/pages/v2/companies/show.tsx
#: app/frontend/pages/v2/contacts/show.tsx
msgid "Open deals"
msgstr "Open deals"

#: app/frontend/components/v2/deals/mobile-deals-shell.tsx
#: app/frontend/components/v2/deals/pipeline-board.tsx
msgid "Open filter builder"
msgstr "Open filter builder"

#: app/frontend/components/v2/inbox/filter-pills.tsx
msgid "Open filter panel"
msgstr "Open filter panel"

#: app/frontend/components/v2/drawer/drawer-header.tsx
#: app/frontend/components/v2/drawer/drawer-header.tsx
#: app/frontend/components/v2/search/drawer-preview-pane.tsx
msgid "Open full page"
msgstr "Open full page"

#: app/frontend/components/v2/inbox/other-ways-popover.tsx
msgid "Open in WhatsApp Business"
msgstr "Open in WhatsApp Business"

#: app/frontend/components/v2/chrome/mobile-top-bar.tsx
msgid "Open navigation"
msgstr "Open navigation"

#: app/frontend/components/v2/chrome/notifications-bell.tsx
#: app/frontend/components/v2/chrome/notifications-bell.tsx
#: app/frontend/components/v2/chrome/notifications-bell.tsx
msgid "Open notifications"
msgstr "Open notifications"

#: app/frontend/components/v2/inbox/summary-section.tsx
msgid "Open question"
msgstr "Open question"

#: app/frontend/components/v2/inbox/mobile-conversation-detail.tsx
msgid "Open send actions"
msgstr "Open send actions"

#: app/frontend/components/v2/landing/feature-capture.tsx
msgid "Opened"
msgstr "Opened"

#: app/frontend/lib/commands.ts
msgid "Opens form"
msgstr "Opens form"

#: app/frontend/components/v2/inbox/other-ways-popover.tsx
msgid "Opens your mail app · won't be logged"
msgstr "Opens your mail app · won't be logged"

#: app/frontend/components/v2/inbox/create-opportunity-panel.tsx
msgid "Opportunity created"
msgstr "Opportunity created"

#: app/frontend/components/v2/inbox/create-opportunity-panel.tsx
msgid "Opportunity name"
msgstr "Opportunity name"

#: app/frontend/components/v2/contacts/create-contact-modal.tsx
#: app/frontend/components/v2/deals/create-deal-modal.tsx
#: app/frontend/components/v2/voice/after-call-card.tsx
msgid "optional"
msgstr "optional"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Optional components"
msgstr "Optional components"

#: app/frontend/components/v2/search/cold-start.tsx
msgid "Or run a command"
msgstr "Or run a command"

#: app/frontend/components/v2/auth/oauth-buttons.tsx
msgid "or with email"
msgstr "or with email"

#: app/frontend/components/v2/inbox/failed-message-group.tsx
#: app/frontend/components/v2/inbox/other-ways-popover.tsx
#: app/frontend/components/v2/inbox/other-ways-popover.tsx
msgid "Other ways to reach {firstName}"
msgstr "Other ways to reach {firstName}"

#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
msgid "Outcome"
msgstr "Outcome"

#: app/frontend/components/v2/voice/after-call-card.tsx
msgid "Outcome — change if the AI got it wrong"
msgstr "Outcome — change if the AI got it wrong"

#. placeholder {0}: i18n._(STAGE_TYPE_LABEL[stageType])
#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
msgid "Outcome: {0}. Click to change."
msgstr "Outcome: {0}. Click to change."

#: app/frontend/components/v2/voice/call-row.tsx
msgid "Outgoing call"
msgstr "Outgoing call"

#: app/frontend/components/v2/deals/activity-feed.tsx
msgid "Outgoing message"
msgstr "Outgoing message"

#: app/frontend/components/v2/inbox/failed-message-group.tsx
msgid "Outside the 24-hour window"
msgstr "Outside the 24-hour window"

#: app/frontend/pages/v2/today/show.tsx
msgid "Overdue"
msgstr "Overdue"

#: app/frontend/components/v2/companies/show-tabs.tsx
#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/pages/v2/contacts/show.tsx
msgid "Overview"
msgstr "Overview"

#: app/frontend/components/v2/inbox/mobile-row-pickers.tsx
msgid "Owned by"
msgstr "Owned by"

#: app/frontend/components/v2/companies/index-table.tsx
#: app/frontend/components/v2/companies/properties-section.tsx
#: app/frontend/components/v2/contacts/contact-assignees-row.tsx
#: app/frontend/components/v2/deals/create-deal-modal.tsx
#: app/frontend/components/v2/deals/deal-properties-card.tsx
#: app/frontend/components/v2/deals/mobile-deal-show-panel.tsx
#: app/frontend/lib/activity-facets.ts
#: app/frontend/types/v2/contact-filters.ts
#: app/frontend/types/v2/deal-filters.ts
msgid "Owner"
msgstr "Owner"

#: app/frontend/components/v2/settings/team/security-card.tsx
#: app/frontend/pages/v2/registrations/new.tsx
#: app/frontend/pages/v2/sessions/new.tsx
msgid "Password"
msgstr "Password"

#: app/frontend/pages/v2/sessions/new.tsx
msgid "Password reset is coming soon"
msgstr "Password reset is coming soon"

#: app/frontend/components/v2/settings/team/danger-zone-card.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Pause"
msgstr "Pause"

#: app/frontend/components/v2/settings/team/danger-zone-card.tsx
msgid "Pause access"
msgstr "Pause access"

#. placeholder {0}: employee.name
#: app/frontend/components/v2/settings/team/danger-zone-card.tsx
msgid "Pause access for {0}?"
msgstr "Pause access for {0}?"

#: app/frontend/components/v2/deals/deal-more-menu.tsx
#: app/frontend/components/v2/deals/deal-more-menu.tsx
msgid "Pause AI"
msgstr "Pause AI"

#: app/frontend/components/v2/voice/recording-player.tsx
msgid "Pause recording"
msgstr "Pause recording"

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Pause this channel"
msgstr "Pause this channel"

#: app/frontend/components/v2/settings/phone-numbers/row-kebab.tsx
msgid "Pause this number"
msgstr "Pause this number"

#: app/frontend/components/v2/inbox/compose/composer-attach-popover.tsx
msgid "PDF, DOCX, XLSX · up to 16 MB"
msgstr "PDF, DOCX, XLSX · up to 16 MB"

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/index.tsx
msgid "Pending"
msgstr "Pending"

#: app/frontend/components/v2/settings/team/team-stats-strip.tsx
msgid "Pending invites"
msgstr "Pending invites"

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/index.tsx
msgid "Pending review"
msgstr "Pending review"

#: app/frontend/components/v2/drawer/entries/company-entry-body.tsx
msgid "People"
msgstr "People"

#: app/frontend/components/v2/drawer/entries/company-entry-body.tsx
msgid "People · {totalCount}"
msgstr "People · {totalCount}"

#: app/frontend/components/v2/deals/mobile-note-sheet.tsx
#: app/frontend/components/v2/deals/note-composer.tsx
msgid "Personal note"
msgstr "Personal note"

#: app/frontend/components/v2/inbox/compose/composer-quick-replies-popover.tsx
msgid "Personal shortcuts · sendable in window"
msgstr "Personal shortcuts · sendable in window"

#: app/frontend/components/v2/inbox/compose/composer-quick-replies-sheet.tsx
msgid "Personal shortcuts. Sendable any time within the 24h window."
msgstr "Personal shortcuts. Sendable any time within the 24h window."

#: app/frontend/components/v2/contacts/create-contact-modal.tsx
#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/components/v2/drawer/entries/contact-entry-body.tsx
#: app/frontend/components/v2/settings/team/profile-card.tsx
#: app/frontend/pages/v2/contacts/show.tsx
msgid "Phone"
msgstr "Phone"

#: app/frontend/lib/settings-nav.ts
#: app/frontend/pages/v2/settings/phone_numbers/index.tsx
#: app/frontend/pages/v2/settings/phone_numbers/index.tsx
msgid "Phone numbers"
msgstr "Phone numbers"

#: app/frontend/components/v2/settings/usage/billed-card.tsx
msgid "Phone numbers and call usage."
msgstr "Phone numbers and call usage."

#: app/frontend/components/v2/inbox/compose/composer-actions-sheet.tsx
#: app/frontend/lib/conversation-formatting.ts
msgid "Photo"
msgstr "Photo"

#: app/frontend/components/v2/inbox/compose/composer-attach-popover.tsx
msgid "Photo from library"
msgstr "Photo from library"

#: app/frontend/components/v2/inbox/chat-panel.tsx
msgid "Pick a conversation"
msgstr "Pick a conversation"

#: app/frontend/components/v2/deals/next-step-composer.tsx
#: app/frontend/components/v2/inbox/mobile-row-pickers.tsx
#: app/frontend/components/v2/inline-edit/date-popover.tsx
msgid "Pick a date"
msgstr "Pick a date"

#: app/frontend/components/v2/inbox/conversation-snooze-sheet.tsx
msgid "Pick a date & time…"
msgstr "Pick a date & time…"

#: app/frontend/components/v2/inbox/context-pane.tsx
msgid "Pick a due date"
msgstr "Pick a due date"

#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/components/v2/contacts/filter-popover.tsx
msgid "Pick a filter below to start narrowing down contacts."
msgstr "Pick a filter below to start narrowing down contacts."

#: app/frontend/components/v2/deals/filter-popover.tsx
#: app/frontend/components/v2/deals/filter-popover.tsx
msgid "Pick a filter below to start narrowing down deals."
msgstr "Pick a filter below to start narrowing down deals."

#: app/frontend/components/v2/settings/billing/trial-banner.tsx
msgid "Pick a plan below. Cancel anytime."
msgstr "Pick a plan below. Cancel anytime."

#: app/frontend/components/v2/inbox/compose/compose-modal.tsx
msgid "Pick a recipient to continue"
msgstr "Pick a recipient to continue"

#: app/frontend/types/v2/buy-number.ts
msgid "Pick a region"
msgstr "Pick a region"

#: app/frontend/components/v2/settings/phone-numbers/buy/step-region.tsx
msgid "Pick a state or metro area. This sets the area code your customers will see."
msgstr "Pick a state or metro area. This sets the area code your customers will see."

#: app/frontend/components/v2/inbox/compose/composer-templates-popover.tsx
#: app/frontend/components/v2/inbox/compose/composer-templates-sheet.tsx
#: app/frontend/components/v2/inbox/compose/template-body.tsx
#: app/frontend/components/v2/inbox/template-picker-bottom-sheet.tsx
#: app/frontend/components/v2/inbox/template-picker-bottom-sheet.tsx
#: app/frontend/components/v2/inbox/template-picker-popover.tsx
#: app/frontend/components/v2/inbox/template-picker-popover.tsx
msgid "Pick a template"
msgstr "Pick a template"

#: app/frontend/components/v2/inbox/failed-template-expander.tsx
msgid "Pick another"
msgstr "Pick another"

#: app/frontend/components/v2/settings/team/team-answers-popover.tsx
msgid "Pick any number that should ring this teammate's phone alongside the AI assistant."
msgstr "Pick any number that should ring this teammate's phone alongside the AI assistant."

#: app/frontend/components/v2/settings/phone-numbers/buy/step-assign.tsx
#: app/frontend/components/v2/settings/phone-numbers/reassign-answerers.tsx
msgid "Pick anyone who should ring when this number gets a call or message."
msgstr "Pick anyone who should ring when this number gets a call or message."

#: app/frontend/components/v2/settings/phone-numbers/buy/step-capabilities.tsx
msgid "Pick at least one. You can add more later, but capabilities can't be removed once a number is purchased."
msgstr "Pick at least one. You can add more later, but capabilities can't be removed once a number is purchased."

#: app/frontend/components/v2/deals/deal-properties-card.tsx
msgid "Pick close date"
msgstr "Pick close date"

#: app/frontend/components/v2/deals/next-step-composer.tsx
#: app/frontend/components/v2/inbox/mobile-row-pickers.tsx
msgid "Pick date"
msgstr "Pick date"

#: app/frontend/components/v2/inbox/conversation-snooze-date-picker-sheet.tsx
msgid "Pick date & time"
msgstr "Pick date & time"

#: app/frontend/components/v2/inbox/compose/freeform-body.tsx
msgid "Pick emoji"
msgstr "Pick emoji"

#: app/frontend/components/v2/inbox/conversation-snooze-date-picker-sheet.tsx
msgid "Pick snooze date and time"
msgstr "Pick snooze date and time"

#: app/frontend/components/v2/assignees/assignee-picker.tsx
msgid "Pick the teammates who own this {entityLabel}."
msgstr "Pick the teammates who own this {entityLabel}."

#: app/frontend/components/v2/companies/index-table.tsx
#: app/frontend/components/v2/landing/feature-pipeline.tsx
#: app/frontend/components/v2/voice/after-call-link-deal.tsx
#: app/frontend/components/v2/voice/after-call-link-deal.tsx
#: app/frontend/pages/v2/companies/index.tsx
msgid "Pipeline"
msgstr "Pipeline"

#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
msgid "Pipeline name"
msgstr "Pipeline name"

#: app/frontend/components/v2/deals/mobile-stage-picker.tsx
#: app/frontend/components/v2/deals/mobile-stage-tabs.tsx
msgid "Pipeline stages"
msgstr "Pipeline stages"

#: app/frontend/components/v2/companies/index-toolbar.tsx
#: app/frontend/pages/v2/companies/index.tsx
msgid "Pipeline value"
msgstr "Pipeline value"

#: app/frontend/pages/v2/settings/billing/show.tsx
#: app/frontend/pages/v2/settings/billing/show.tsx
msgid "Plan & billing"
msgstr "Plan & billing"

#: app/frontend/lib/settings-nav.ts
msgid "Plan, payment method, and invoices."
msgstr "Plan, payment method, and invoices."

#: app/frontend/components/v2/voice/after-call-transcript.tsx
#: app/frontend/components/v2/voice/recording-player.tsx
msgid "Play recording"
msgstr "Play recording"

#: app/frontend/components/v2/settings/phone-numbers/buy/step-country.tsx
msgid "Popular"
msgstr "Popular"

#: app/frontend/components/v2/whatsapp-templates/template-editor-utils.ts
msgid "Portuguese (Brazil)"
msgstr "Portuguese (Brazil)"

#: app/frontend/components/v2/inbox/summary-section.tsx
#: app/frontend/components/v2/voice/sentiment.tsx
#: app/frontend/lib/voice-disposition.ts
msgid "Positive"
msgstr "Positive"

#: app/frontend/pages/v2/dev/components/voice_card.tsx
msgid "Post-call card preview"
msgstr "Post-call card preview"

#: app/frontend/components/v2/whatsapp-templates/follow-up-template-card.tsx
msgid "Post-call follow-up template"
msgstr "Post-call follow-up template"

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/index.tsx
msgid "Pre-approved messages for sending outside the 24-hour window. Synced from Meta every 5 minutes."
msgstr "Pre-approved messages for sending outside the 24-hour window. Synced from Meta every 5 minutes."

#: app/frontend/components/v2/inbox/failed-template-expander.tsx
msgid "Preview"
msgstr "Preview"

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "Preview — not actually sent"
msgstr "Preview — not actually sent"

#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
#: app/frontend/components/v2/inbox/conversation-snooze-date-picker-sheet.tsx
#: app/frontend/components/v2/inline-edit/date-popover.tsx
msgid "Previous month"
msgstr "Previous month"

#: app/frontend/components/v2/landing/landing-footer.tsx
#: app/frontend/components/v2/landing/landing-nav.tsx
msgid "Pricing"
msgstr "Pricing"

#: app/frontend/components/v2/chrome/mobile-bottom-nav.tsx
#: app/frontend/components/v2/deals/deal-contact-card.tsx
msgid "Primary"
msgstr "Primary"

#: app/frontend/components/v2/deals/create-deal-modal.tsx
#: app/frontend/components/v2/deals/deal-contact-picker.tsx
msgid "Primary contact"
msgstr "Primary contact"

#: app/frontend/components/v2/auth/auth-layout.tsx
#: app/frontend/components/v2/landing/landing-footer.tsx
msgid "Privacy"
msgstr "Privacy"

#: app/frontend/components/v2/voice/after-call-more-sheet.tsx
msgid "Private"
msgstr "Private"

#: app/frontend/components/v2/contacts/create-contact-modal.tsx
msgid "Priya Mehta"
msgstr "Priya Mehta"

#: app/frontend/components/v2/landing/landing-footer.tsx
#: app/frontend/components/v2/landing/landing-nav.tsx
msgid "Product"
msgstr "Product"

#: app/frontend/components/v2/companies/properties-section.tsx
#: app/frontend/components/v2/settings/team/profile-card.tsx
#: app/frontend/lib/settings-nav.ts
msgid "Profile"
msgstr "Profile"

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Profile photo"
msgstr "Profile photo"

#: app/frontend/components/v2/companies/properties-section.tsx
#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/components/v2/deals/deal-properties-card.tsx
#: app/frontend/components/v2/deals/mobile-deal-show-panel.tsx
#: app/frontend/components/v2/drawer/entries/contact-entry-body.tsx
#: app/frontend/pages/v2/contacts/show.tsx
msgid "Properties"
msgstr "Properties"

#: app/frontend/components/v2/voice/active-call-widget.tsx
#: app/frontend/components/v2/voice/active-call-widget.tsx
msgid "Quick note"
msgstr "Quick note"

#: app/frontend/components/v2/inbox/chat-panel.tsx
msgid "quick replies"
msgstr "quick replies"

#: app/frontend/components/v2/inbox/chat-panel.tsx
#: app/frontend/components/v2/inbox/compose/composer-quick-replies-popover.tsx
#: app/frontend/components/v2/inbox/compose/composer-quick-replies-popover.tsx
#: app/frontend/components/v2/inbox/compose/composer-quick-replies-sheet.tsx
#: app/frontend/components/v2/inbox/compose/composer-quick-replies-sheet.tsx
msgid "Quick replies"
msgstr "Quick replies"

#: app/frontend/components/v2/inbox/compose/composer-actions-sheet.tsx
#: app/frontend/components/v2/inbox/message-bubble.tsx
#: app/frontend/components/v2/whatsapp-templates/template-editor-utils.ts
msgid "Quick reply"
msgstr "Quick reply"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Quick reply button text"
msgstr "Quick reply button text"

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Read"
msgstr "Read"

#: app/frontend/components/v2/inbox/summary-section.tsx
msgid "Reading this conversation…"
msgstr "Reading this conversation…"

#: app/frontend/components/v2/inbox/chat-header.tsx
#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/inbox/conversation-more-menu.tsx
#: app/frontend/components/v2/inbox/conversation-reassign-sheet.tsx
#: app/frontend/components/v2/settings/phone-numbers/row-kebab.tsx
msgid "Reassign"
msgstr "Reassign"

#. placeholder {0}: assignee.name
#: app/frontend/components/v2/inbox/context-pane.tsx
msgid "Reassign — currently {0}"
msgstr "Reassign — currently {0}"

#: app/frontend/components/v2/inbox/conversation-reassign-sheet.tsx
msgid "Reassign conversation"
msgstr "Reassign conversation"

#: app/frontend/components/v2/deals/deal-more-menu.tsx
#: app/frontend/components/v2/deals/deal-more-menu.tsx
msgid "Reassign owner"
msgstr "Reassign owner"

#: app/frontend/types/v2/deal-filters.ts
msgid "Recency"
msgstr "Recency"

#: app/frontend/components/v2/inbox/template-picker.tsx
#: app/frontend/components/v2/search/cold-start.tsx
msgid "Recent"
msgstr "Recent"

#: app/frontend/components/v2/companies/activity-section.tsx
#: app/frontend/components/v2/companies/company-drawer.tsx
#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/components/v2/drawer/entries/company-entry-body.tsx
#: app/frontend/components/v2/settings/team/recent-activity-card.tsx
#: app/frontend/pages/v2/contacts/show.tsx
msgid "Recent activity"
msgstr "Recent activity"

#: app/frontend/components/v2/search/cold-start.tsx
msgid "Recent searches"
msgstr "Recent searches"

#: app/frontend/components/v2/settings/phone-numbers/buy/teammate-row.tsx
#: app/frontend/pages/v2/settings/channels/show.tsx
msgid "Recommended"
msgstr "Recommended"

#: app/frontend/components/v2/chrome/status-strip.tsx
msgid "Reconnect"
msgstr "Reconnect"

#: app/frontend/components/v2/chrome/status-strip.tsx
#: app/frontend/components/v2/chrome/status-strip.tsx
#: app/frontend/components/v2/voice/active-call-widget.tsx
msgid "Reconnecting…"
msgstr "Reconnecting…"

#: app/frontend/components/v2/settings/team/voice-calling-card.tsx
msgid "Record calls"
msgstr "Record calls"

#: app/frontend/components/v2/inbox/compose/composer-attach-popover.tsx
msgid "Record up to 3 minutes"
msgstr "Record up to 3 minutes"

#: app/frontend/pages/v2/settings/phone_numbers/index.tsx
msgid "Refresh numbers"
msgstr "Refresh numbers"

#: app/frontend/components/v2/voice/call-detail-panel.tsx
msgid "Regenerate AI"
msgstr "Regenerate AI"

#: app/frontend/components/v2/voice/after-call-more-sheet.tsx
msgid "Regenerate AI summary"
msgstr "Regenerate AI summary"

#: app/frontend/components/v2/voice/after-call-card.tsx
msgid "Regenerating the summary…"
msgstr "Regenerating the summary…"

#: app/frontend/components/v2/settings/phone-numbers/phone-numbers-table.tsx
#: app/frontend/types/v2/buy-number.ts
msgid "Region"
msgstr "Region"

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/index.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/index.tsx
msgid "Rejected"
msgstr "Rejected"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
msgid "Rejected and paused templates can be edited unlimited times"
msgstr "Rejected and paused templates can be edited unlimited times"

#: app/frontend/components/v2/settings/phone-numbers/row-kebab.tsx
msgid "Release number"
msgstr "Release number"

#: app/frontend/components/v2/settings/team/answers-on-card.tsx
#: app/frontend/components/v2/settings/team/danger-zone-card.tsx
#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Remove"
msgstr "Remove"

#. placeholder {0}: number.label ?? number.phoneNumber
#: app/frontend/components/v2/settings/team/answers-on-card.tsx
msgid "Remove {0}"
msgstr "Remove {0}"

#. placeholder {0}: contact.displayName
#: app/frontend/components/v2/deals/deal-contact-picker.tsx
msgid "Remove {0} from deal"
msgstr "Remove {0} from deal"

#. placeholder {0}: employee.name
#: app/frontend/components/v2/settings/team/danger-zone-card.tsx
msgid "Remove {0}?"
msgstr "Remove {0}?"

#: app/frontend/components/v2/chrome/mobile-search-overlay.tsx
msgid "Remove {query} from recent searches"
msgstr "Remove {query} from recent searches"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Remove button"
msgstr "Remove button"

#: app/frontend/components/v2/deals/create-deal-modal.tsx
msgid "Remove contact"
msgstr "Remove contact"

#: app/frontend/components/v2/contacts/active-filter-chips.tsx
msgid "Remove filter"
msgstr "Remove filter"

#: app/frontend/components/v2/deals/deal-contact-card.tsx
msgid "Remove from deal"
msgstr "Remove from deal"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Remove media"
msgstr "Remove media"

#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
msgid "Remove stage"
msgstr "Remove stage"

#: app/frontend/components/v2/settings/team/danger-zone-card.tsx
msgid "Remove teammate"
msgstr "Remove teammate"

#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/components/v2/deals/filter-popover.tsx
#: app/frontend/components/v2/deals/filter-popover.tsx
msgid "Remove this filter"
msgstr "Remove this filter"

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Remove this number from Conecto. You'll have to reconnect from Meta to use it again."
msgstr "Remove this number from Conecto. You'll have to reconnect from Meta to use it again."

#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
msgid "Rename deal"
msgstr "Rename deal"

#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
msgid "Rename, reorder, or change stages — you can edit these later in Settings."
msgstr "Rename, reorder, or change stages — you can edit these later in Settings."

#: app/frontend/components/v2/inbox/compose/composer-templates-popover.tsx
msgid "Rendered preview"
msgstr "Rendered preview"

#: app/frontend/components/v2/inbox/conversation-more-menu.tsx
msgid "Reopen conversation"
msgstr "Reopen conversation"

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "Reopens the 24h window to free-text"
msgstr "Reopens the 24h window to free-text"

#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
msgid "Reorder stage"
msgstr "Reorder stage"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Replace"
msgstr "Replace"

#: app/frontend/pages/v2/settings/channels/show.tsx
msgid "Reply to story mentions, DMs, and comments from one place."
msgstr "Reply to story mentions, DMs, and comments from one place."

#: app/frontend/components/v2/settings/team/security-card.tsx
msgid "Require"
msgstr "Require"

#: app/frontend/components/v2/settings/team/security-card.tsx
msgid "Reset"
msgstr "Reset"

#: app/frontend/components/v2/voice/after-call-card.tsx
#: app/frontend/components/v2/voice/call-detail-panel.tsx
msgid "Reset to AI summary"
msgstr "Reset to AI summary"

#: app/frontend/components/v2/inbox/filter-panel.tsx
msgid "Resolved"
msgstr "Resolved"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
msgid "Resubmitting…"
msgstr "Resubmitting…"

#: app/frontend/components/v2/deals/ai-paused-banner.tsx
msgid "Resume AI"
msgstr "Resume AI"

#: app/frontend/components/v2/today/ai-accept-modal.tsx
#: app/frontend/components/v2/today/ai-accept-sheet.tsx
msgid "Review AI draft"
msgstr "Review AI draft"

#: app/frontend/components/v2/settings/team/danger-zone-card.tsx
msgid "Revokes seat. Owned data stays with the workspace."
msgstr "Revokes seat. Owned data stays with the workspace."

#: app/frontend/components/v2/settings/team/access-card.tsx
#: app/frontend/components/v2/settings/team/profile-card.tsx
#: app/frontend/components/v2/settings/team/team-members-table.tsx
msgid "Role"
msgstr "Role"

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Routing"
msgstr "Routing"

#: app/frontend/components/v2/chrome/status-strip.tsx
msgid "Routing calls + messages"
msgstr "Routing calls + messages"

#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
msgid "Sa"
msgstr "Sa"

#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
#: app/frontend/components/v2/landing/feature-pipeline.tsx
msgid "Sales pipeline"
msgstr "Sales pipeline"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Sample · e.g. Alice"
msgstr "Sample · e.g. Alice"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Sample · e.g. Order #1234"
msgstr "Sample · e.g. Order #1234"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Sample code"
msgstr "Sample code"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Sample value for variable {n}"
msgstr "Sample value for variable {n}"

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Sample values applied"
msgstr "Sample values applied"

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Sample values used in the preview →"
msgstr "Sample values used in the preview →"

#: app/frontend/components/v2/assignees/assignee-picker.tsx
#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/components/v2/deals/deal-properties-card.tsx
#: app/frontend/components/v2/deals/filter-popover.tsx
#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
#: app/frontend/components/v2/deals/mobile-note-sheet.tsx
#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/inbox/filter-panel.tsx
#: app/frontend/components/v2/inbox/mobile-row-inline-editor.tsx
#: app/frontend/components/v2/inbox/notes-section.tsx
#: app/frontend/components/v2/inline-edit/inline-text-edit-row.tsx
#: app/frontend/components/v2/settings/phone-numbers/reassign-answerers.tsx
#: app/frontend/components/v2/settings/team/team-answers-popover.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "Save"
msgstr "Save"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
msgid "Save · Resubmit to Meta"
msgstr "Save · Resubmit to Meta"

#: app/frontend/components/v2/inbox/filter-panel.tsx
msgid "Save a combination of filters and it shows up here for one-tap reuse."
msgstr "Save a combination of filters and it shows up here for one-tap reuse."

#: app/frontend/components/v2/deals/filter-popover.tsx
#: app/frontend/components/v2/deals/filter-popover.tsx
msgid "Save as view"
msgstr "Save as view"

#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Save changes"
msgstr "Save changes"

#: app/frontend/components/v2/inbox/filter-panel.tsx
msgid "Save current as view"
msgstr "Save current as view"

#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/components/v2/deals/filter-popover.tsx
#: app/frontend/components/v2/deals/filter-popover.tsx
msgid "Save current filters as a view"
msgstr "Save current filters as a view"

#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Save draft"
msgstr "Save draft"

#: app/frontend/components/v2/deals/next-step-composer.tsx
msgid "Save next step"
msgstr "Save next step"

#: app/frontend/components/v2/deals/note-composer.tsx
msgid "Save note"
msgstr "Save note"

#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Saved as draft · {savedAge}"
msgstr "Saved as draft · {savedAge}"

#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/components/v2/deals/filter-popover.tsx
#: app/frontend/components/v2/inbox/filter-panel.tsx
msgid "Saved views"
msgstr "Saved views"

#: app/frontend/components/v2/voice/call-detail-panel.tsx
msgid "Saves on blur"
msgstr "Saves on blur"

#: app/frontend/components/v2/assignees/assignee-picker.tsx
#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
#: app/frontend/components/v2/settings/phone-numbers/reassign-answerers.tsx
#: app/frontend/components/v2/settings/team/team-answers-popover.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Saving…"
msgstr "Saving…"

#: app/frontend/components/v2/today/ai-accept-modal.tsx
msgid "Schedule 9:00 AM"
msgstr "Schedule 9:00 AM"

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "Schedule a call-back"
msgstr "Schedule a call-back"

#: app/frontend/components/v2/deals/mobile-history-fab-picker.tsx
msgid "Schedule a follow-up, pitch, or close action with a due date."
msgstr "Schedule a follow-up, pitch, or close action with a due date."

#: app/frontend/components/v2/today/ai-accept-sheet.tsx
msgid "Schedule for 9:00 AM"
msgstr "Schedule for 9:00 AM"

#: app/frontend/components/v2/contacts/contact-activity-scope-row.tsx
msgid "Scope"
msgstr "Scope"

#: app/frontend/components/v2/chrome/mobile-search-overlay.tsx
#: app/frontend/components/v2/inbox/rail.tsx
#: app/frontend/components/v2/inbox/sidebar.tsx
#: app/frontend/components/v2/search/command-palette.tsx
#: app/frontend/components/v2/search/command-palette.tsx
#: app/frontend/components/v2/search/search-input.tsx
msgid "Search"
msgstr "Search"

#: app/frontend/components/v2/inbox/template-picker.tsx
msgid "Search {totalCount} approved templates…"
msgstr "Search {totalCount} approved templates…"

#: app/frontend/components/v2/search/palette-footer.tsx
msgid "Search across your workspace"
msgstr "Search across your workspace"

#: app/frontend/components/v2/search/search-input.tsx
msgid "Search anything, or type > for commands"
msgstr "Search anything, or type > for commands"

#: app/frontend/components/v2/inbox/mobile-shell.tsx
msgid "Search by contact name, phone number, or anything that came up in a recent message."
msgstr "Search by contact name, phone number, or anything that came up in a recent message."

#: app/frontend/components/v2/deals/mobile-deals-shell.tsx
msgid "Search by deal title, company, or contact name."
msgstr "Search by deal title, company, or contact name."

#: app/frontend/components/v2/inbox/compose/recipient-picker.tsx
msgid "Search by name, phone, or email. Pasted numbers are auto-validated."
msgstr "Search by name, phone, or email. Pasted numbers are auto-validated."

#: app/frontend/components/v2/inbox/compose/recipient-picker.tsx
msgid "Search by name, phone, or paste a number"
msgstr "Search by name, phone, or paste a number"

#: app/frontend/components/v2/settings/phone-numbers/search-input.tsx
msgid "Search by number, region, or assignee…"
msgstr "Search by number, region, or assignee…"

#: app/frontend/components/v2/companies/search-input.tsx
msgid "Search companies"
msgstr "Search companies"

#: app/frontend/components/v2/companies/search-input.tsx
msgid "Search companies…"
msgstr "Search companies…"

#: app/frontend/components/v2/contacts/search-input.tsx
#: app/frontend/components/v2/inbox/compose/recipient-picker.tsx
msgid "Search contacts"
msgstr "Search contacts"

#: app/frontend/components/v2/deals/deal-contact-picker.tsx
msgid "Search contacts at {companyName}…"
msgstr "Search contacts at {companyName}…"

#: app/frontend/components/v2/deals/create-deal-modal.tsx
msgid "Search contacts by name, email, or phone…"
msgstr "Search contacts by name, email, or phone…"

#: app/frontend/components/v2/contacts/search-input.tsx
#: app/frontend/components/v2/deals/deal-contact-picker.tsx
msgid "Search contacts…"
msgstr "Search contacts…"

#: app/frontend/components/v2/inbox/inbox-list.tsx
#: app/frontend/components/v2/inbox/inbox-list.tsx
#: app/frontend/components/v2/inbox/mobile-shell.tsx
#: app/frontend/components/v2/inbox/mobile-shell.tsx
msgid "Search conversations"
msgstr "Search conversations"

#: app/frontend/components/v2/settings/phone-numbers/buy/step-country.tsx
#: app/frontend/components/v2/settings/phone-numbers/buy/step-country.tsx
msgid "Search countries"
msgstr "Search countries"

#: app/frontend/components/v2/deals/filter-bar.tsx
#: app/frontend/components/v2/deals/mobile-deals-shell.tsx
#: app/frontend/components/v2/voice/after-call-link-deal.tsx
msgid "Search deals"
msgstr "Search deals"

#: app/frontend/components/v2/deals/filter-bar.tsx
#: app/frontend/components/v2/deals/mobile-deals-shell.tsx
msgid "Search deals, companies, contacts…"
msgstr "Search deals, companies, contacts…"

#: app/frontend/components/v2/voice/after-call-link-deal.tsx
msgid "Search deals…"
msgstr "Search deals…"

#: app/frontend/components/v2/deals/timeline-search-field.tsx
msgid "Search messages, notes & calls…"
msgstr "Search messages, notes & calls…"

#: app/frontend/components/v2/settings/team/team-answers-popover.tsx
#: app/frontend/components/v2/settings/team/team-answers-popover.tsx
#: app/frontend/pages/v2/settings/phone_numbers/index.tsx
msgid "Search numbers"
msgstr "Search numbers"

#: app/frontend/components/v2/inbox/link-opportunity-panel.tsx
#: app/frontend/components/v2/inbox/link-opportunity-panel.tsx
msgid "Search opportunities"
msgstr "Search opportunities"

#: app/frontend/components/v2/search/cold-start.tsx
msgid "Search or run a command"
msgstr "Search or run a command"

#: app/frontend/components/v2/search/search-input.tsx
msgid "Search or type > for commands"
msgstr "Search or type > for commands"

#: app/frontend/components/v2/settings/phone-numbers/search-input.tsx
msgid "Search phone numbers"
msgstr "Search phone numbers"

#: app/frontend/components/v2/inbox/compose/composer-quick-replies.tsx
msgid "Search quick replies"
msgstr "Search quick replies"

#: app/frontend/components/v2/settings/phone-numbers/buy/step-region.tsx
msgid "Search regions"
msgstr "Search regions"

#. placeholder {0}: results.length
#: app/frontend/components/v2/search/search-results-list.tsx
msgid "Search results ({0})"
msgstr "Search results ({0})"

#: app/frontend/components/v2/inbox/compose/composer-quick-replies.tsx
msgid "Search shortcuts or content…"
msgstr "Search shortcuts or content…"

#: app/frontend/components/v2/settings/phone-numbers/buy/step-region.tsx
msgid "Search states or metros"
msgstr "Search states or metros"

#: app/frontend/pages/v2/settings/team/index.tsx
msgid "Search team"
msgstr "Search team"

#: app/frontend/components/v2/assignees/assignee-picker.tsx
#: app/frontend/components/v2/assignees/assignee-picker.tsx
#: app/frontend/components/v2/inbox/assignment-popover.tsx
#: app/frontend/components/v2/inbox/assignment-popover.tsx
#: app/frontend/components/v2/inbox/teammates-sub-view.tsx
#: app/frontend/components/v2/inbox/teammates-sub-view.tsx
#: app/frontend/components/v2/settings/phone-numbers/buy/step-assign.tsx
#: app/frontend/components/v2/settings/phone-numbers/buy/step-assign.tsx
#: app/frontend/components/v2/settings/phone-numbers/reassign-answerers.tsx
#: app/frontend/components/v2/settings/phone-numbers/reassign-answerers.tsx
#: app/frontend/pages/v2/settings/team/index.tsx
msgid "Search teammates"
msgstr "Search teammates"

#: app/frontend/pages/v2/settings/team/index.tsx
msgid "Search teammates by name, email, or role…"
msgstr "Search teammates by name, email, or role…"

#: app/frontend/components/v2/inbox/compose/composer-templates.tsx
#: app/frontend/components/v2/inbox/template-picker.tsx
#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/index.tsx
msgid "Search templates"
msgstr "Search templates"

#: app/frontend/components/v2/inbox/compose/composer-templates.tsx
#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/index.tsx
msgid "Search templates…"
msgstr "Search templates…"

#: app/frontend/components/v2/deals/timeline-search-field.tsx
msgid "Search timeline"
msgstr "Search timeline"

#: app/frontend/components/v2/deals/create-deal-modal.tsx
#: app/frontend/components/v2/inbox/compose/recipient-picker.tsx
#: app/frontend/components/v2/settings/phone-numbers/buy/step-country.tsx
msgid "Searching…"
msgstr "Searching…"

#: app/frontend/components/v2/settings/usage/billed-card.tsx
msgid "Seat plan billed separately."
msgstr "Seat plan billed separately."

#: app/frontend/components/v2/settings/billing/billing-footer-note.tsx
#~ msgid "Seats are billed per teammate. Telephony and AI usage are billed separately and appear on your Usage page."
#~ msgstr "Seats are billed per teammate. Telephony and AI usage are billed separately and appear on your Usage page."

#: app/frontend/components/v2/settings/billing/billing-footer-note.tsx
msgid "Seats are billed per teammate. Telephony and AI usage are billed separately and appear on your Usage page. Prices include 16% IVA."
msgstr "Seats are billed per teammate. Telephony and AI usage are billed separately and appear on your Usage page. Prices include 16% IVA."

#: app/frontend/components/v2/landing/landing-footer.tsx
#: app/frontend/components/v2/settings/team/security-card.tsx
msgid "Security"
msgstr "Security"

#: app/frontend/components/v2/companies/company-drawer.tsx
#: app/frontend/components/v2/drawer/entries/company-entry-body.tsx
msgid "See all"
msgstr "See all"

#: app/frontend/components/v2/notifications/notifications-list-content.tsx
msgid "See all notifications →"
msgstr "See all notifications →"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "See all options"
msgstr "See all options"

#: app/frontend/components/v2/voice/recording-player.tsx
msgid "Seek recording (arrow keys to scrub)"
msgstr "Seek recording (arrow keys to scrub)"

#. placeholder {0}: item.title
#: app/frontend/components/v2/inbox/attach-offer-card.tsx
msgid "Select {0}"
msgstr "Select {0}"

#: app/frontend/components/v2/inbox/compose/composer-templates-popover.tsx
msgid "Select a template to preview it here."
msgstr "Select a template to preview it here."

#: app/frontend/components/v2/inbox/chat-panel.tsx
msgid "Select a thread on the left to read the transcript and reply."
msgstr "Select a thread on the left to read the transcript and reply."

#: app/frontend/components/v2/inbox/attach-offer-card.tsx
msgid "Select all"
msgstr "Select all"

#: app/frontend/components/v2/deals/filter-popover.tsx
#: app/frontend/components/v2/deals/filter-popover.tsx
msgid "Select…"
msgstr "Select…"

#. placeholder {0}: selectedRows.length
#: app/frontend/components/v2/inbox/teammates-sub-view.tsx
msgid "Selected · {0}"
msgstr "Selected · {0}"

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "Selected now"
msgstr "Selected now"

#: app/frontend/components/v2/inbox/compose/composer-actions-sheet.tsx
#: app/frontend/components/v2/inbox/compose/composer-actions-sheet.tsx
#: app/frontend/components/v2/inbox/compose/staged-template.tsx
msgid "Send"
msgstr "Send"

#: app/frontend/components/v2/inbox/failed-message-group.tsx
msgid "Send a template"
msgstr "Send a template"

#: app/frontend/pages/v2/settings/channels/show.tsx
msgid "Send and receive messages, voice notes, and templates from your business number."
msgstr "Send and receive messages, voice notes, and templates from your business number."

#: app/frontend/components/v2/settings/team/access-card.tsx
msgid "Send invites and manage seats."
msgstr "Send invites and manage seats."

#: app/frontend/components/v2/inbox/chat-panel.tsx
#: app/frontend/components/v2/inbox/compose/compose-modal.tsx
#: app/frontend/components/v2/inbox/mobile-conversation-detail.tsx
msgid "Send message"
msgstr "Send message"

#: app/frontend/components/v2/today/ai-accept-modal.tsx
#: app/frontend/components/v2/today/ai-accept-sheet.tsx
msgid "Send now"
msgstr "Send now"

#: app/frontend/components/v2/inbox/compose/compose-modal.tsx
#: app/frontend/components/v2/inbox/compose/staged-template.tsx
#: app/frontend/components/v2/inbox/failed-template-expander.tsx
#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "Send template"
msgstr "Send template"

#: app/frontend/components/v2/inbox/compose/channel-chips.tsx
msgid "Send via"
msgstr "Send via"

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "Send WhatsApp"
msgstr "Send WhatsApp"

#: app/frontend/components/v2/inbox/compose/composer-templates-popover.tsx
msgid "Sendable in window"
msgstr "Sendable in window"

#: app/frontend/components/v2/inbox/compose/staged-template.tsx
msgid "Sending as template"
msgstr "Sending as template"

#: app/frontend/components/v2/inbox/compose/compose-modal.tsx
#: app/frontend/components/v2/inbox/compose/compose-modal.tsx
#: app/frontend/components/v2/inbox/compose/staged-template.tsx
#: app/frontend/components/v2/inbox/failed-template-expander.tsx
#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "Sending…"
msgstr "Sending…"

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Sends"
msgstr "Sends"

#: app/frontend/components/v2/inbox/other-ways-popover.tsx
msgid "Sends from your phone · won't be logged"
msgstr "Sends from your phone · won't be logged"

#: app/frontend/components/v2/inbox/message-bubble.tsx
msgid "Sent from WhatsApp Business app"
msgstr "Sent from WhatsApp Business app"

#: app/frontend/components/v2/voice/sentiment.tsx
msgid "Sentiment: {sentiment} — AI-detected"
msgstr "Sentiment: {sentiment} — AI-detected"

#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
#: app/frontend/components/v2/inline-edit/date-popover.tsx
msgid "September"
msgstr "September"

#: app/frontend/components/v2/settings/team/security-card.tsx
msgid "Set 4 months ago"
msgstr "Set 4 months ago"

#: app/frontend/components/v2/inbox/context-pane.tsx
msgid "Set a date"
msgstr "Set a date"

#: app/frontend/components/v2/deals/next-step-composer.tsx
msgid "Set method"
msgstr "Set method"

#: app/frontend/components/v2/deals/mobile-deals-shell.tsx
#: app/frontend/components/v2/deals/pipeline-board.tsx
msgid "Set up a pipeline to start tracking deals through your sales process."
msgstr "Set up a pipeline to start tracking deals through your sales process."

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "Setting up…"
msgstr "Setting up…"

#: app/frontend/components/v2/chrome/user-menu.tsx
#: app/frontend/components/v2/inbox/sidebar.tsx
#: app/frontend/pages/v2/settings/billing/show.tsx
#: app/frontend/pages/v2/settings/billing/show.tsx
#: app/frontend/pages/v2/settings/channels/show.tsx
#: app/frontend/pages/v2/settings/channels/show.tsx
#: app/frontend/pages/v2/settings/channels/show.tsx
#: app/frontend/pages/v2/settings/channels/show.tsx
#: app/frontend/pages/v2/settings/overview/show.tsx
#: app/frontend/pages/v2/settings/overview/show.tsx
#: app/frontend/pages/v2/settings/phone_numbers/index.tsx
#: app/frontend/pages/v2/settings/phone_numbers/index.tsx
#: app/frontend/pages/v2/settings/team/index.tsx
msgid "Settings"
msgstr "Settings"

#. placeholder {0}: number.sharedWith
#: app/frontend/components/v2/settings/team/answers-on-card.tsx
msgid "Shared with {0} teammates"
msgstr "Shared with {0} teammates"

#: app/frontend/components/v2/settings/team/answers-on-card.tsx
msgid "Shared with 1 teammate"
msgstr "Shared with 1 teammate"

#: app/frontend/components/v2/inbox/notes-section.tsx
#: app/frontend/components/v2/inbox/notes-section.tsx
msgid "Show all"
msgstr "Show all"

#. placeholder {0}: regions.length
#: app/frontend/components/v2/settings/phone-numbers/buy/step-region.tsx
msgid "Show all {0} states →"
msgstr "Show all {0} states →"

#: app/frontend/components/v2/inbox/attach-offer-card.tsx
msgid "Show all {itemCount}"
msgstr "Show all {itemCount}"

#: app/frontend/components/v2/inbox/context-pane.tsx
msgid "Show all → Today"
msgstr "Show all → Today"

#: app/frontend/components/v2/inbox/filter-panel.tsx
msgid "Show all teammates →"
msgstr "Show all teammates →"

#: app/frontend/components/v2/voice/active-call-widget.tsx
msgid "Show dial pad"
msgstr "Show dial pad"

#. placeholder {0}: dismissed.length
#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "Show dismissed ({0}) →"
msgstr "Show dismissed ({0}) →"

#: app/frontend/components/v2/inbox/attach-offer-card.tsx
msgid "Show less"
msgstr "Show less"

#: app/frontend/components/v2/auth/auth-text-field.tsx
msgid "Show password"
msgstr "Show password"

#. placeholder {0}: contacts.length
#. placeholder {1}: filters.search
#: app/frontend/pages/v2/contacts/index.tsx
msgid "Showing {0} {contactNoun} for \"{1}\"."
msgstr "Showing {0} {contactNoun} for \"{1}\"."

#. placeholder {0}: contacts.length
#. placeholder {1}: filters.conditions.length
#: app/frontend/pages/v2/contacts/index.tsx
msgid "Showing {0} {contactNoun} matching {1} {filterNoun}."
msgstr "Showing {0} {contactNoun} matching {1} {filterNoun}."

#. placeholder {0}: picker.filtered.length
#. placeholder {1}: templates.length
#: app/frontend/components/v2/inbox/template-picker-bottom-sheet.tsx
#: app/frontend/components/v2/inbox/template-picker-popover.tsx
msgid "Showing {0} of {1}"
msgstr "Showing {0} of {1}"

#. placeholder {0}: picker.filtered.length
#. placeholder {1}: templates.length
#: app/frontend/components/v2/inbox/template-picker-bottom-sheet.tsx
msgid "Showing {0} of {1} · scroll for more"
msgstr "Showing {0} of {1} · scroll for more"

#. placeholder {0}: stats.totalContacts
#: app/frontend/pages/v2/contacts/index.tsx
msgid "Showing all {0} {totalNoun}."
msgstr "Showing all {0} {totalNoun}."

#: app/frontend/components/v2/landing/landing-nav.tsx
#: app/frontend/pages/v2/registrations/new.tsx
#: app/frontend/pages/v2/sessions/new.tsx
msgid "Sign in"
msgstr "Sign in"

#: app/frontend/pages/v2/sessions/new.tsx
msgid "Sign in to Conecto and keep your AI on duty."
msgstr "Sign in to Conecto and keep your AI on duty."

#: app/frontend/components/v2/settings/team/security-card.tsx
msgid "Sign out"
msgstr "Sign out"

#: app/frontend/pages/v2/sessions/new.tsx
msgid "Sign up"
msgstr "Sign up"

#: app/frontend/components/v2/settings/team/security-card.tsx
msgid "Sign-in, sessions, and account safety."
msgstr "Sign-in, sessions, and account safety."

#: app/frontend/components/v2/deals/starter-pipeline-banner.tsx
#: app/frontend/components/v2/deals/starter-pipeline-banner.tsx
msgid "Six stages from first contact to closed — rename, reorder, or change outcomes anytime."
msgstr "Six stages from first contact to closed — rename, reorder, or change outcomes anytime."

#: app/frontend/components/v2/companies/properties-section.tsx
msgid "Size"
msgstr "Size"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Small text under the body, e.g. legal disclaimer."
msgstr "Small text under the body, e.g. legal disclaimer."

#: app/frontend/lib/follow-up-method.ts
#: app/frontend/lib/follow-up-method.ts
#: app/frontend/lib/follow-up-method.ts
#: app/frontend/lib/follow-up-method.ts
#: app/frontend/lib/phone-number-display.ts
msgid "SMS"
msgstr "SMS"

#: app/frontend/components/v2/today/activity-row.tsx
#: app/frontend/components/v2/today/mobile-activity-row.tsx
msgid "Snooze"
msgstr "Snooze"

#: app/frontend/components/v2/inbox/conversation-snooze-sheet.tsx
#: app/frontend/components/v2/inbox/conversation-snooze-sheet.tsx
msgid "Snooze conversation"
msgstr "Snooze conversation"

#: app/frontend/components/v2/inbox/conversation-snooze-date-picker-sheet.tsx
msgid "Snooze until then"
msgstr "Snooze until then"

#: app/frontend/components/v2/inbox/conversation-more-menu.tsx
msgid "Snooze…"
msgstr "Snooze…"

#: app/frontend/components/v2/inbox/filter-panel.tsx
msgid "Snoozed"
msgstr "Snoozed"

#: app/frontend/components/v2/inbox/deal-proposal-card.tsx
#: app/frontend/components/v2/inbox/deal-proposal-card.tsx
#: app/frontend/components/v2/inbox/deal-proposal-card.tsx
msgid "Something went wrong creating the deal — try again."
msgstr "Something went wrong creating the deal — try again."

#: app/frontend/components/v2/inbox/failed-message-group.tsx
msgid "Something went wrong sending this. Try a different way to reach them."
msgstr "Something went wrong sending this. Try a different way to reach them."

#: app/frontend/components/v2/contacts/create-contact-modal.tsx
#: app/frontend/components/v2/deals/create-deal-modal.tsx
#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
#: app/frontend/components/v2/inbox/chat-panel.tsx
#: app/frontend/components/v2/inbox/compose/compose-modal.tsx
#: app/frontend/components/v2/inbox/failed-template-expander.tsx
#: app/frontend/components/v2/inbox/mobile-conversation-detail.tsx
#: app/frontend/components/v2/inbox/suggested-next-step-row.tsx
#: app/frontend/components/v2/inbox/suggested-next-step-row.tsx
msgid "Something went wrong. Please try again."
msgstr "Something went wrong. Please try again."

#: app/frontend/components/v2/chrome/status-strip.tsx
msgid "Something went wrong. Try reconnecting."
msgstr "Something went wrong. Try reconnecting."

#: app/frontend/pages/v2/settings/channels/show.tsx
#: app/frontend/pages/v2/settings/channels/show.tsx
msgid "Soon"
msgstr "Soon"

#: app/frontend/components/v2/companies/index-toolbar.tsx
#: app/frontend/components/v2/contacts/index-toolbar.tsx
#: app/frontend/components/v2/deals/filter-bar.tsx
#: app/frontend/components/v2/deals/filter-bar.tsx
msgid "Sort by"
msgstr "Sort by"

#: app/frontend/components/v2/companies/index-toolbar.tsx
msgid "Sort companies"
msgstr "Sort companies"

#: app/frontend/components/v2/search/search-results-list.tsx
msgid "Sort results"
msgstr "Sort results"

#: app/frontend/components/v2/companies/properties-section.tsx
#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/components/v2/deals/deal-conversations-card.tsx
#: app/frontend/components/v2/deals/deal-properties-card.tsx
#: app/frontend/components/v2/deals/mobile-deal-show-panel.tsx
#: app/frontend/components/v2/drawer/entries/contact-entry-body.tsx
#: app/frontend/pages/v2/contacts/show.tsx
#: app/frontend/types/v2/contact-filters.ts
#: app/frontend/types/v2/deal-filters.ts
msgid "Source"
msgstr "Source"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Source for variable {n}"
msgstr "Source for variable {n}"

#: app/frontend/components/v2/whatsapp-templates/template-editor-utils.ts
msgid "Spanish (Mexico)"
msgstr "Spanish (Mexico)"

#: app/frontend/pages/v2/registrations/new.tsx
msgid "Spin up your AI sales rep in under two minutes."
msgstr "Spin up your AI sales rep in under two minutes."

#: app/frontend/components/v2/deals/mobile-note-sheet.tsx
msgid "Spoke with @maya about the 18% counter…"
msgstr "Spoke with @maya about the 18% counter…"

#: app/frontend/components/v2/settings/team/profile-card.tsx
#: app/frontend/components/v2/settings/team/teammate-hero.tsx
msgid "Staff"
msgstr "Staff"

#: app/frontend/components/v2/deals/create-deal-modal.tsx
#: app/frontend/components/v2/deals/deal-properties-card.tsx
#: app/frontend/components/v2/deals/mobile-deal-show-panel.tsx
#: app/frontend/components/v2/inbox/deal-proposal-card.tsx
#: app/frontend/components/v2/inbox/deal-proposal-card.tsx
#: app/frontend/components/v2/inbox/linked-deal-section.tsx
#: app/frontend/components/v2/voice/after-call-link-deal.tsx
#: app/frontend/components/v2/voice/after-call-link-deal.tsx
#: app/frontend/lib/activity-facets.ts
#: app/frontend/types/v2/deal-filters.ts
msgid "Stage"
msgstr "Stage"

#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
msgid "Stage name"
msgstr "Stage name"

#. placeholder {0}: deal.stage.name
#: app/frontend/components/v2/deals/stage-picker.tsx
msgid "Stage: {0}. Click to change."
msgstr "Stage: {0}. Click to change."

#. placeholder {0}: deal.stage.name
#: app/frontend/components/v2/deals/mobile-stage-picker.tsx
msgid "Stage: {0}. Tap to change."
msgstr "Stage: {0}. Tap to change."

#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
msgid "Stages"
msgstr "Stages"

#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
msgid "Stages can be reordered anytime."
msgstr "Stages can be reordered anytime."

#: app/frontend/pages/v2/settings/billing/show.tsx
msgid "Start 14-day trial"
msgstr "Start 14-day trial"

#: app/frontend/components/v2/landing/landing-nav.tsx
msgid "Start for free"
msgstr "Start for free"

#: app/frontend/components/v2/landing/email-capture.tsx
msgid "Start free"
msgstr "Start free"

#: app/frontend/components/v2/landing/landing-footer.tsx
msgid "Start free trial"
msgstr "Start free trial"

#: app/frontend/components/v2/inbox/inbox-list.tsx
#: app/frontend/components/v2/inbox/mobile-shell.tsx
msgid "Start new conversation"
msgstr "Start new conversation"

#: app/frontend/components/v2/deals/create-deal-modal.tsx
msgid "Start typing to search your contacts."
msgstr "Start typing to search your contacts."

#: app/frontend/components/v2/inbox/compose/recipient-picker.tsx
msgid "Start with {phone}"
msgstr "Start with {phone}"

#: app/frontend/components/v2/settings/billing/trial-banner.tsx
msgid "Start your 14-day free trial"
msgstr "Start your 14-day free trial"

#: app/frontend/components/v2/landing/final-cta.tsx
msgid "Start your free trial today"
msgstr "Start your free trial today"

#: app/frontend/types/v2/contact-filters.ts
msgid "State"
msgstr "State"

#: app/frontend/components/v2/inbox/filter-panel.tsx
#: app/frontend/lib/activity-facets.ts
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/index.tsx
msgid "Status"
msgstr "Status"

#: app/frontend/lib/conversation-formatting.ts
msgid "Sticker"
msgstr "Sticker"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Strikethrough"
msgstr "Strikethrough"

#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
msgid "Su"
msgstr "Su"

#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Submit to Meta for approval"
msgstr "Submit to Meta for approval"

#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Submitting…"
msgstr "Submitting…"

#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "Suggestion dismissed"
msgstr "Suggestion dismissed"

#: app/frontend/components/v2/inbox/summary-section.tsx
#: app/frontend/components/v2/inbox/summary-section.tsx
msgid "Summary"
msgstr "Summary"

#: app/frontend/pages/v2/settings/billing/show.tsx
msgid "Switch anytime — upgrades are prorated, downgrades apply next cycle."
msgstr "Switch anytime — upgrades are prorated, downgrades apply next cycle."

#: app/frontend/components/v2/inbox/inbox-list.tsx
#: app/frontend/components/v2/inbox/mobile-shell.tsx
msgid "Switch back to All to see every conversation, or wait for one to be assigned to you."
msgstr "Switch back to All to see every conversation, or wait for one to be assigned to you."

#: app/frontend/components/v2/inbox/template-picker.tsx
msgid "Switch categories or create a new template from Settings."
msgstr "Switch categories or create a new template from Settings."

#. placeholder {0}: plan.name
#: app/frontend/pages/v2/settings/billing/show.tsx
msgid "Switch to {0}"
msgstr "Switch to {0}"

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/index.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Sync from Meta"
msgstr "Sync from Meta"

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Synced {syncedAge}"
msgstr "Synced {syncedAge}"

#: app/frontend/components/v2/chrome/user-menu.tsx
msgid "System"
msgstr "System"

#: app/frontend/components/v2/deals/mobile-note-sheet.tsx
#: app/frontend/components/v2/deals/note-composer.tsx
#: app/frontend/types/v2/contact-filters.ts
#: app/frontend/types/v2/deal-filters.ts
msgid "Tag"
msgstr "Tag"

#: app/frontend/components/v2/deals/note-composer.tsx
msgid "Tag suggestions"
msgstr "Tag suggestions"

#: app/frontend/components/v2/companies/properties-section.tsx
#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/pages/v2/contacts/show.tsx
msgid "Tags"
msgstr "Tags"

#: app/frontend/components/v2/inbox/compose/composer-attach-popover.tsx
msgid "Take a photo"
msgstr "Take a photo"

#: app/frontend/components/v2/today/mobile-tabs.tsx
#: app/frontend/components/v2/voice/after-call-more-sheet.tsx
#: app/frontend/lib/settings-nav.ts
#: app/frontend/pages/v2/settings/team/index.tsx
#: app/frontend/pages/v2/settings/team/index.tsx
#: app/frontend/pages/v2/settings/team/show.tsx
#: app/frontend/pages/v2/settings/team/show.tsx
msgid "Team"
msgstr "Team"

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Team access"
msgstr "Team access"

#: app/frontend/components/v2/landing/feature-capture.tsx
msgid "Team size"
msgstr "Team size"

#: app/frontend/components/v2/settings/team/team-members-table.tsx
#: app/frontend/pages/v2/settings/team/show.tsx
msgid "Teammate"
msgstr "Teammate"

#: app/frontend/components/v2/inbox/assignment-popover.tsx
#: app/frontend/components/v2/inbox/filter-sheet.tsx
msgid "Teammates"
msgstr "Teammates"

#: app/frontend/components/v2/notifications/notifications-list-content.tsx
msgid "Teammates can @mention you in notes."
msgstr "Teammates can @mention you in notes."

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Teammates who can see and reply to conversations on this channel."
msgstr "Teammates who can see and reply to conversations on this channel."

#: app/frontend/components/v2/settings/usage/daily-spend-chart.tsx
msgid "Telephony only."
msgstr "Telephony only."

#: app/frontend/components/v2/inbox/compose/staged-template.tsx
#: app/frontend/components/v2/inbox/message-bubble.tsx
#: app/frontend/components/v2/whatsapp-templates/follow-up-template-card.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/index.tsx
msgid "Template"
msgstr "Template"

#. placeholder {0}: draft.templateName
#: app/frontend/components/v2/today/ai-accept-sheet.tsx
msgid "Template · {0}"
msgstr "Template · {0}"

#. placeholder {0}: template.name
#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "TEMPLATE · {0}"
msgstr "TEMPLATE · {0}"

#. placeholder {0}: draft.templateName
#: app/frontend/components/v2/today/ai-accept-modal.tsx
msgid "Template · {0} · approved"
msgstr "Template · {0} · approved"

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Template actions"
msgstr "Template actions"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Template category"
msgstr "Template category"

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Template ID"
msgstr "Template ID"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Template name"
msgstr "Template name"

#. placeholder {0}: v.token
#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "Template variable {0}"
msgstr "Template variable {0}"

#: app/frontend/components/v2/inbox/compose/template-body.tsx
msgid "Template variable {number}"
msgstr "Template variable {number}"

#: app/frontend/components/v2/inbox/compose/staged-template.tsx
#: app/frontend/components/v2/inbox/failed-template-expander.tsx
msgid "Template variable {token}"
msgstr "Template variable {token}"

#: app/frontend/components/v2/inbox/chat-panel.tsx
msgid "templates"
msgstr "templates"

#: app/frontend/components/v2/inbox/chat-panel.tsx
#: app/frontend/components/v2/inbox/compose/composer-actions-sheet.tsx
#: app/frontend/components/v2/inbox/compose/composer-templates-popover.tsx
#: app/frontend/components/v2/inbox/compose/composer-templates-sheet.tsx
#: app/frontend/lib/settings-nav.ts
#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/index.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Templates"
msgstr "Templates"

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "Templates are managed in Settings → WhatsApp."
msgstr "Templates are managed in Settings → WhatsApp."

#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Templates are pre-approved messages you can send outside the 24-hour customer service window. Meta reviews each one before approval."
msgstr "Templates are pre-approved messages you can send outside the 24-hour customer service window. Meta reviews each one before approval."

#: app/frontend/components/v2/settings/team/danger-zone-card.tsx
msgid "Temporarily revoke sign-in without removing data."
msgstr "Temporarily revoke sign-in without removing data."

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Temporarily stop sending and receiving messages on this number."
msgstr "Temporarily stop sending and receiving messages on this number."

#: app/frontend/components/v2/auth/auth-layout.tsx
#: app/frontend/components/v2/landing/landing-footer.tsx
msgid "Terms"
msgstr "Terms"

#: app/frontend/components/v2/settings/phone-numbers/row-kebab.tsx
msgid "Test call"
msgstr "Test call"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Text"
msgstr "Text"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Text formatting"
msgstr "Text formatting"

#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
msgid "Th"
msgstr "Th"

#: app/frontend/components/v2/deals/deal-properties-card.tsx
#: app/frontend/components/v2/deals/deal-properties-card.tsx
#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
msgid "That doesn't look like a number."
msgstr "That doesn't look like a number."

#: app/frontend/components/v2/inbox/suggested-next-step-row.tsx
msgid "That suggestion changed — take another look."
msgstr "That suggestion changed — take another look."

#: app/frontend/components/v2/landing/landing-footer.tsx
msgid "The AI-native CRM for teams that sell on WhatsApp. Built for how LATAM does business."
msgstr "The AI-native CRM for teams that sell on WhatsApp. Built for how LATAM does business."

#: app/frontend/components/v2/inbox/failed-message-group.tsx
msgid "The attachment couldn't be uploaded"
msgstr "The attachment couldn't be uploaded"

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "The avatar shown on outbound conversations."
msgstr "The avatar shown on outbound conversations."

#: app/frontend/components/v2/inbox/failed-message-group.tsx
msgid "The carrier rejected delivery, or this number isn't on WhatsApp anymore. Try another channel or double-check the number on the contact card."
msgstr "The carrier rejected delivery, or this number isn't on WhatsApp anymore. Try another channel or double-check the number on the contact card."

#: app/frontend/components/v2/landing/landing-hero.tsx
msgid "The CRM that works while you sell"
msgstr "The CRM that works while you sell"

#: app/frontend/components/v2/landing/feature-capture.tsx
msgid "The moment someone messages, Conecto creates the contact, enriches it, and opens a deal — before you've even read the chat."
msgstr "The moment someone messages, Conecto creates the contact, enriches it, and opens a deal — before you've even read the chat."

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "The name shown in your inbox and shared with teammates."
msgstr "The name shown in your inbox and shared with teammates."

#: app/frontend/components/v2/voice/active-call-widget.tsx
msgid "The number couldn't be reached. You weren't charged."
msgstr "The number couldn't be reached. You weren't charged."

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "The phone number Meta has verified for this account."
msgstr "The phone number Meta has verified for this account."

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "The pin is set per message, at send time"
msgstr "The pin is set per message, at send time"

#: app/frontend/components/v2/landing/testimonials.tsx
msgid "The teams who switched aren't going back"
msgstr "The teams who switched aren't going back"

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "Their reply reopens the 24h window — you'll be able to free-text then."
msgstr "Their reply reopens the 24h window — you'll be able to free-text then."

#: app/frontend/components/v2/chrome/user-menu.tsx
msgid "Theme"
msgstr "Theme"

#. placeholder {0}: preview.recurringLabel
#. placeholder {1}: preview.renewalDateLabel
#: app/frontend/components/v2/settings/phone-numbers/buy/step-confirm.tsx
msgid "Then {0} · renews {1}"
msgstr "Then {0} · renews {1}"

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "There's no WhatsApp conversation with {contactName} yet — start one from the inbox to send a follow-up."
msgstr "There's no WhatsApp conversation with {contactName} yet — start one from the inbox to send a follow-up."

#: app/frontend/components/v2/inbox/attach-offer-card.tsx
msgid "These were captured before the deal existed. They'll stay on {stayOnTarget} either way."
msgstr "These were captured before the deal existed. They'll stay on {stayOnTarget} either way."

#: app/frontend/pages/v2/companies/index.tsx
msgid "They'll appear here as you talk to people from the same workplace."
msgstr "They'll appear here as you talk to people from the same workplace."

#: app/frontend/components/v2/voice/call-detail-panel.tsx
msgid "this contact"
msgstr "this contact"

#: app/frontend/lib/delete-prompt-copy.ts
msgid "This deal and its history will be permanently deleted."
msgstr "This deal and its history will be permanently deleted."

#: app/frontend/components/v2/inbox/message-bubble.tsx
msgid "This message was deleted"
msgstr "This message was deleted"

#: app/frontend/lib/usage-props.ts
msgid "This month"
msgstr "This month"

#: app/frontend/components/v2/settings/usage/usage-stats.tsx
msgid "this period"
msgstr "this period"

#: app/frontend/components/v2/settings/usage/billed-card.tsx
#: app/frontend/components/v2/settings/usage/usage-stats.tsx
msgid "This period so far"
msgstr "This period so far"

#: app/frontend/components/v2/settings/team/teammate-voice-toggle.tsx
msgid "This teammate can place and receive calls."
msgstr "This teammate can place and receive calls."

#: app/frontend/components/v2/settings/team/answers-on-card.tsx
msgid "This teammate isn't answering on any numbers yet."
msgstr "This teammate isn't answering on any numbers yet."

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "This template doesn't use any variables."
msgstr "This template doesn't use any variables."

#: app/frontend/pages/v2/contacts/index.tsx
#: app/frontend/pages/v2/contacts/index.tsx
msgid "this week"
msgstr "this week"

#: app/frontend/components/v2/settings/team/danger-zone-card.tsx
msgid "This will revoke their seat. Conversations and deals they own will stay in the workspace."
msgstr "This will revoke their seat. Conversations and deals they own will stay in the workspace."

#: app/frontend/components/v2/settings/team/danger-zone-card.tsx
msgid "This will revoke their sign-in until you turn it back on. Conversations and deals they own stay put."
msgstr "This will revoke their sign-in until you turn it back on. Conversations and deals they own stay put."

#: app/frontend/components/v2/inbox/conversation-snooze-date-picker-sheet.tsx
msgid "Time"
msgstr "Time"

#: app/frontend/components/v2/settings/team/profile-card.tsx
msgid "Timezone"
msgstr "Timezone"

#: app/frontend/components/v2/contacts/mobile-contact-show-panel.tsx
#: app/frontend/pages/v2/contacts/show.tsx
msgid "Title"
msgstr "Title"

#: app/frontend/components/v2/inbox/chat-panel.tsx
msgid "to send"
msgstr "to send"

#: app/frontend/components/v2/deals/create-deal-modal.tsx
msgid "today"
msgstr "today"

#: app/frontend/components/v2/chrome/mobile-bottom-nav.tsx
#: app/frontend/components/v2/deals/activity-feed.tsx
#: app/frontend/components/v2/deals/deal-properties-card.tsx
#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/inbox/mobile-row-pickers.tsx
#: app/frontend/components/v2/inbox/sidebar.tsx
#: app/frontend/components/v2/landing/feature-today.tsx
#: app/frontend/pages/v2/notifications/index.tsx
#: app/frontend/pages/v2/today/show.tsx
#: app/frontend/pages/v2/today/show.tsx
#: app/frontend/pages/v2/today/show.tsx
#: app/frontend/pages/v2/today/show.tsx
msgid "Today"
msgstr "Today"

#: app/frontend/components/v2/settings/team/security-card.tsx
msgid "Today at 9:14 AM · Chrome"
msgstr "Today at 9:14 AM · Chrome"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Toggle buttons component"
msgstr "Toggle buttons component"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Toggle footer component"
msgstr "Toggle footer component"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Toggle header component"
msgstr "Toggle header component"

#: app/frontend/components/v2/deals/note-composer.tsx
msgid "Toggle note visibility"
msgstr "Toggle note visibility"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Toggle resolved variables"
msgstr "Toggle resolved variables"

#: app/frontend/lib/settings-nav.ts
msgid "Tokens for developers and webhooks."
msgstr "Tokens for developers and webhooks."

#: app/frontend/components/v2/settings/phone-numbers/buy/step-region.tsx
msgid "Toll-free"
msgstr "Toll-free"

#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/inbox/mobile-row-pickers.tsx
#: app/frontend/pages/v2/today/show.tsx
msgid "Tomorrow"
msgstr "Tomorrow"

#: app/frontend/lib/settings-nav.ts
msgid "Tone, guardrails, and handoff rules."
msgstr "Tone, guardrails, and handoff rules."

#: app/frontend/pages/v2/companies/index.tsx
#: app/frontend/pages/v2/contacts/index.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Total"
msgstr "Total"

#: app/frontend/pages/v2/companies/index.tsx
msgid "Total companies"
msgstr "Total companies"

#: app/frontend/pages/v2/contacts/index.tsx
msgid "Total contacts"
msgstr "Total contacts"

#: app/frontend/components/v2/settings/phone-numbers/phone-number-stats.tsx
msgid "Total numbers"
msgstr "Total numbers"

#: app/frontend/components/v2/settings/usage/billed-card.tsx
msgid "Total this period"
msgstr "Total this period"

#: app/frontend/components/v2/deals/create-deal-modal.tsx
msgid "Track a new opportunity through your pipeline"
msgstr "Track a new opportunity through your pipeline"

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Transcribe inbound voice notes so AI can reply to them."
msgstr "Transcribe inbound voice notes so AI can reply to them."

#: app/frontend/components/v2/voice/call-detail-panel.tsx
msgid "Transcribing this call… it'll appear here when it's ready."
msgstr "Transcribing this call… it'll appear here when it's ready."

#: app/frontend/components/v2/voice/call-detail-panel.tsx
#: app/frontend/pages/v2/dev/components/voice_card.tsx
msgid "Transcript"
msgstr "Transcript"

#: app/frontend/lib/settings-nav.ts
msgid "Triggers, routing, and auto-replies."
msgstr "Triggers, routing, and auto-replies."

#: app/frontend/components/v2/landing/trust-strip.tsx
msgid "Trusted by teams that live in WhatsApp"
msgstr "Trusted by teams that live in WhatsApp"

#: app/frontend/components/v2/search/command-list.tsx
msgid "Try \"deal\", \"inbox\", or \"settings\"."
msgstr "Try \"deal\", \"inbox\", or \"settings\"."

#: app/frontend/components/v2/inbox/template-picker.tsx
msgid "Try a different category or a shorter search."
msgstr "Try a different category or a shorter search."

#: app/frontend/components/v2/inbox/inbox-list.tsx
#: app/frontend/components/v2/inbox/mobile-shell.tsx
msgid "Try a different name or phone number."
msgstr "Try a different name or phone number."

#: app/frontend/components/v2/settings/team/team-members-table.tsx
#: app/frontend/pages/v2/settings/phone_numbers/index.tsx
#: app/frontend/pages/v2/settings/team/index.tsx
msgid "Try a different search or filter to see more."
msgstr "Try a different search or filter to see more."

#: app/frontend/components/v2/inbox/compose/composer-quick-replies.tsx
msgid "Try a different search."
msgstr "Try a different search."

#: app/frontend/components/v2/inbox/failed-message-group.tsx
msgid "Try a different template"
msgstr "Try a different template"

#: app/frontend/components/v2/search/search-results-list.tsx
msgid "Try a name, phone number, or a few words from a note."
msgstr "Try a name, phone number, or a few words from a note."

#: app/frontend/components/v2/inbox/compose/composer-templates-popover.tsx
#: app/frontend/components/v2/inbox/compose/composer-templates-sheet.tsx
msgid "Try a shorter search."
msgstr "Try a shorter search."

#: app/frontend/components/v2/settings/phone-numbers/buy/step-confirm.tsx
#: app/frontend/components/v2/voice/active-call-widget.tsx
msgid "Try again"
msgstr "Try again"

#: app/frontend/components/v2/search/cold-start.tsx
msgid "Try searching"
msgstr "Try searching"

#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
msgid "Tu"
msgstr "Tu"

#: app/frontend/components/v2/settings/team/access-card.tsx
msgid "Tune prompts, automations, and templates."
msgstr "Tune prompts, automations, and templates."

#: app/frontend/components/v2/settings/team/teammate-voice-toggle.tsx
msgid "Turn on to let this teammate place and receive calls."
msgstr "Turn on to let this teammate place and receive calls."

#: app/frontend/components/v2/settings/team/security-card.tsx
msgid "Two-factor"
msgstr "Two-factor"

#: app/frontend/components/v2/inbox/chat-panel.tsx
#: app/frontend/components/v2/inbox/mobile-conversation-detail.tsx
msgid "Type a message…"
msgstr "Type a message…"

#: app/frontend/components/v2/inbox/compose/staged-template.tsx
msgid "Type a value"
msgstr "Type a value"

#: app/frontend/components/v2/inbox/compose/freeform-body.tsx
msgid "Type your message…"
msgstr "Type your message…"

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Unarchive"
msgstr "Unarchive"

#: app/frontend/components/v2/deals/deal-properties-card.tsx
#: app/frontend/components/v2/deals/mobile-deal-show-panel.tsx
#: app/frontend/components/v2/inbox/chat-header.tsx
#: app/frontend/components/v2/inbox/conversation-more-menu.tsx
#: app/frontend/components/v2/inbox/filter-panel.tsx
#: app/frontend/components/v2/inline-edit/owner-popover.tsx
#: app/frontend/components/v2/settings/phone-numbers/buy/step-confirm.tsx
#: app/frontend/components/v2/settings/phone-numbers/phone-number-stats.tsx
#: app/frontend/lib/phone-number-display.ts
msgid "Unassigned"
msgstr "Unassigned"

#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "Uncheck"
msgstr "Uncheck"

#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "Undo"
msgstr "Undo"

#: app/frontend/components/v2/voice/after-call-card.tsx
msgid "Undo — restore your note"
msgstr "Undo — restore your note"

#: app/frontend/components/v2/voice/call-detail-panel.tsx
#: app/frontend/components/v2/voice/incoming-call-sheet.tsx
msgid "Unknown caller"
msgstr "Unknown caller"

#: app/frontend/components/v2/deals/deal-conversations-card.tsx
#: app/frontend/components/v2/inbox/contact-section.tsx
msgid "Unknown contact"
msgstr "Unknown contact"

#: app/frontend/components/v2/deals/deal-conversations-card.tsx
msgid "Unlink conversation"
msgstr "Unlink conversation"

#: app/frontend/components/v2/voice/active-call-widget.tsx
msgid "Unmute"
msgstr "Unmute"

#: app/frontend/components/v2/inbox/conversation-more-menu.tsx
msgid "Unmute notifications"
msgstr "Unmute notifications"

#: app/frontend/components/v2/notifications/notification-row.tsx
#: app/frontend/components/v2/notifications/notifications-list-content.tsx
#: app/frontend/pages/v2/notifications/index.tsx
msgid "Unread"
msgstr "Unread"

#: app/frontend/components/v2/today/activity-row.tsx
#: app/frontend/components/v2/today/completed-row.tsx
#: app/frontend/components/v2/today/mobile-activity-row.tsx
msgid "Untitled task"
msgstr "Untitled task"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "up to {limit}"
msgstr "up to {limit}"

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-editor.tsx
msgid "Up to 10 — quick replies, plus URL / call / copy-code actions."
msgstr "Up to 10 — quick replies, plus URL / call / copy-code actions."

#. placeholder {0}: relativeTimeLabel(summary.generatedAt)
#: app/frontend/components/v2/inbox/summary-section.tsx
msgid "Updated {0}"
msgstr "Updated {0}"

#: app/frontend/components/v2/deals/activity-feed.tsx
msgid "Updates"
msgstr "Updates"

#: app/frontend/components/v2/inbox/summary-section.tsx
msgid "Updating…"
msgstr "Updating…"

#. placeholder {0}: plan.name
#: app/frontend/pages/v2/settings/billing/show.tsx
msgid "Upgrade to {0}"
msgstr "Upgrade to {0}"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Uploading…"
msgstr "Uploading…"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "URL button link"
msgstr "URL button link"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "URL button link sample"
msgstr "URL button link sample"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "URL button text"
msgstr "URL button text"

#: app/frontend/lib/settings-nav.ts
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Usage"
msgstr "Usage"

#: app/frontend/components/v2/inbox/compose/staged-template.tsx
msgid "Use"
msgstr "Use"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Use {{n}} to insert variables that fill in at send time."
msgstr "Use {{n}} to insert variables that fill in at send time."

#: app/frontend/components/v2/inbox/compose/freeform-body.tsx
msgid "Use AI draft"
msgstr "Use AI draft"

#: app/frontend/components/v2/voice/after-call-card.tsx
msgid "Use AI summary"
msgstr "Use AI summary"

#: app/frontend/components/v2/inbox/compose/composer-attach-popover.tsx
msgid "Use device camera"
msgstr "Use device camera"

#: app/frontend/components/v2/inbox/compose/composer-templates-popover.tsx
msgid "Use template"
msgstr "Use template"

#: app/frontend/components/v2/whatsapp-templates/follow-up-template-card.tsx
msgid "Used when you message a contact more than 24 hours after they last replied — WhatsApp only allows an approved template then. The AI fills the variables for you."
msgstr "Used when you message a contact more than 24 hours after they last replied — WhatsApp only allows an approved template then. The AI fills the variables for you."

#: app/frontend/components/v2/inbox/template-picker.tsx
msgid "Utility"
msgstr "Utility"

#: app/frontend/components/v2/deals/create-deal-modal.tsx
#: app/frontend/components/v2/deals/deal-properties-card.tsx
#: app/frontend/components/v2/deals/deal-properties-card.tsx
#: app/frontend/components/v2/inbox/create-opportunity-panel.tsx
#: app/frontend/components/v2/inbox/deal-proposal-card.tsx
#: app/frontend/components/v2/inbox/linked-deal-section.tsx
#: app/frontend/lib/activity-facets.ts
#: app/frontend/types/v2/deal-filters.ts
#: app/frontend/types/v2/deal-filters.ts
msgid "Value"
msgstr "Value"

#: app/frontend/components/v2/deals/filter-popover.tsx
msgid "Value amount"
msgstr "Value amount"

#: app/frontend/components/v2/deals/deal-properties-card.tsx
#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
msgid "Value can't be negative."
msgstr "Value can't be negative."

#: app/frontend/components/v2/inbox/compose/template-body.tsx
msgid "Value for {{{number}}}"
msgstr "Value for {{{number}}}"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Variables"
msgstr "Variables"

#: app/frontend/components/v2/inbox/failed-template-expander.tsx
msgid "Variables marked AUTO came from the contact or linked deal. Click any value to override."
msgstr "Variables marked AUTO came from the contact or linked deal. Click any value to override."

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Variables shown above are filled with sample values. At send time, they'll resolve from the linked contact and deal."
msgstr "Variables shown above are filled with sample values. At send time, they'll resolve from the linked contact and deal."

#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "Variables shown are filled with sample values. At send time, they resolve from the linked contact and deal."
msgstr "Variables shown are filled with sample values. At send time, they resolve from the linked contact and deal."

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
msgid "Variables still all have sample values"
msgstr "Variables still all have sample values"

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Verified"
msgstr "Verified"

#. placeholder {0}: kpis.lastTouch.channel
#: app/frontend/pages/v2/contacts/show.tsx
msgid "via {0}"
msgstr "via {0}"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
#: app/frontend/lib/conversation-formatting.ts
msgid "Video"
msgstr "Video"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "Video up to 16 MB · the sample Meta reviews"
msgstr "Video up to 16 MB · the sample Meta reviews"

#: app/frontend/components/v2/settings/phone-numbers/row-kebab.tsx
msgid "View activity"
msgstr "View activity"

#: app/frontend/components/v2/inbox/conversation-more-menu.tsx
msgid "View company"
msgstr "View company"

#: app/frontend/components/v2/inbox/conversation-more-menu.tsx
msgid "View contact"
msgstr "View contact"

#: app/frontend/components/v2/deals/mobile-deal-contact-card.tsx
#~ msgid "View contact {0}"
#~ msgstr "View contact {0}"

#: app/frontend/components/v2/inbox/conversation-more-menu.tsx
msgid "View linked deal"
msgstr "View linked deal"

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "View on WhatsApp"
msgstr "View on WhatsApp"

#: app/frontend/components/v2/voice/after-call-card.tsx
msgid "View transcript"
msgstr "View transcript"

#: app/frontend/components/v2/settings/billing/billing-footer-note.tsx
msgid "View usage →"
msgstr "View usage →"

#: app/frontend/components/v2/deals/mobile-note-sheet.tsx
#: app/frontend/components/v2/deals/note-composer.tsx
#: app/frontend/components/v2/deals/note-composer.tsx
msgid "Visible to team"
msgstr "Visible to team"

#: app/frontend/components/v2/whatsapp-templates/template-editor-utils.ts
msgid "Visit URL"
msgstr "Visit URL"

#: app/frontend/components/v2/chrome/status-strip.tsx
#: app/frontend/components/v2/settings/team/team-members-table.tsx
#: app/frontend/lib/phone-number-display.ts
#: app/frontend/lib/phone-number-display.ts
msgid "Voice"
msgstr "Voice"

#: app/frontend/components/v2/landing/landing-footer.tsx
#: app/frontend/components/v2/settings/team/voice-calling-card.tsx
msgid "Voice & calling"
msgstr "Voice & calling"

#: app/frontend/lib/conversation-formatting.ts
msgid "Voice call"
msgstr "Voice call"

#: app/frontend/components/v2/settings/team/team-member-row.tsx
#: app/frontend/components/v2/settings/team/teammate-voice-toggle.tsx
#: app/frontend/components/v2/settings/team/teammate-voice-toggle.tsx
msgid "Voice calling"
msgstr "Voice calling"

#: app/frontend/components/v2/settings/team/teammate-hero.tsx
#: app/frontend/components/v2/settings/team/voice-calling-card.tsx
msgid "Voice calling is off for this teammate"
msgstr "Voice calling is off for this teammate"

#: app/frontend/components/v2/chrome/status-strip.tsx
msgid "Voice connection"
msgstr "Voice connection"

#: app/frontend/components/v2/settings/team/team-stats-strip.tsx
msgid "Voice enabled"
msgstr "Voice enabled"

#: app/frontend/components/v2/settings/phone-numbers/buy/step-country.tsx
msgid "Voice is included with every number."
msgstr "Voice is included with every number."

#: app/frontend/components/v2/chrome/status-strip.tsx
msgid "Voice isn't enabled for your account"
msgstr "Voice isn't enabled for your account"

#: app/frontend/components/v2/chrome/status-strip.tsx
msgid "Voice isn't enabled for your account."
msgstr "Voice isn't enabled for your account."

#: app/frontend/components/v2/inbox/compose/composer-actions-sheet.tsx
#: app/frontend/components/v2/inbox/compose/composer-attach-popover.tsx
msgid "Voice memo"
msgstr "Voice memo"

#: app/frontend/lib/conversation-formatting.ts
msgid "Voice message"
msgstr "Voice message"

#: app/frontend/components/v2/settings/usage/usage-stats.tsx
msgid "Voice minutes"
msgstr "Voice minutes"

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Voice notes"
msgstr "Voice notes"

#: app/frontend/components/v2/settings/team/team-filter-chips.tsx
#: app/frontend/components/v2/settings/team/team-member-row.tsx
#: app/frontend/components/v2/settings/team/teammate-hero.tsx
msgid "Voice off"
msgstr "Voice off"

#: app/frontend/components/v2/settings/team/team-filter-chips.tsx
#: app/frontend/components/v2/settings/team/team-member-row.tsx
msgid "Voice on"
msgstr "Voice on"

#: app/frontend/components/v2/inbox/other-ways-popover.tsx
msgid "Voice only · log outcome as a note"
msgstr "Voice only · log outcome as a note"

#: app/frontend/components/v2/settings/team/team-stats-strip.tsx
msgid "Voice seats used"
msgstr "Voice seats used"

#: app/frontend/components/v2/settings/phone-numbers/phone-number-stats.tsx
msgid "Voice-capable"
msgstr "Voice-capable"

#: app/frontend/lib/voice-disposition.ts
msgid "Voicemail"
msgstr "Voicemail"

#: app/frontend/lib/voice-disposition.ts
msgid "Voicemail — left a message"
msgstr "Voicemail — left a message"

#: app/frontend/components/v2/landing/feature-today.tsx
msgid "Wake up to a day that's already prioritized"
msgstr "Wake up to a day that's already prioritized"

#: app/frontend/components/v2/contacts/create-contact-modal.tsx
msgid "Want us to finish this profile?"
msgstr "Want us to finish this profile?"

#: app/frontend/components/v2/deals/mobile-deal-edit-sheets.tsx
msgid "We"
msgstr "We"

#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "We couldn't add that. Please try again."
msgstr "We couldn't add that. Please try again."

#: app/frontend/components/v2/voice/call-detail-panel.tsx
msgid "We couldn't analyze this call."
msgstr "We couldn't analyze this call."

#: app/frontend/components/v2/inbox/attach-offer-card.tsx
msgid "We couldn't attach those. Please try again."
msgstr "We couldn't attach those. Please try again."

#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "We couldn't bring that back. Please try again."
msgstr "We couldn't bring that back. Please try again."

#: app/frontend/components/v2/settings/phone-numbers/buy/step-confirm.tsx
msgid "We couldn't calculate the total just now. We won't charge you until we can show the amount."
msgstr "We couldn't calculate the total just now. We won't charge you until we can show the amount."

#: app/frontend/components/v2/voice/after-call-link-deal.tsx
msgid "We couldn't create that deal. Please try again."
msgstr "We couldn't create that deal. Please try again."

#: app/frontend/components/v2/inbox/create-opportunity-panel.tsx
#: app/frontend/components/v2/inbox/create-opportunity-panel.tsx
msgid "We couldn't create that. Please try again."
msgstr "We couldn't create that. Please try again."

#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/inbox/notes-section.tsx
#: app/frontend/components/v2/inbox/notes-section.tsx
#: app/frontend/components/v2/voice/after-call-card.tsx
#: app/frontend/components/v2/voice/after-call-card.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "We couldn't delete that. Please try again."
msgstr "We couldn't delete that. Please try again."

#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/inbox/deal-proposal-card.tsx
#: app/frontend/components/v2/inbox/suggested-next-step-row.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "We couldn't dismiss that. Please try again."
msgstr "We couldn't dismiss that. Please try again."

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "We couldn't draft a follow-up just now. Please try again in a moment."
msgstr "We couldn't draft a follow-up just now. Please try again in a moment."

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "We couldn't fill this template — add the details and send."
msgstr "We couldn't fill this template — add the details and send."

#: app/frontend/pages/v2/deals/show.tsx
msgid "We couldn't find this deal."
msgstr "We couldn't find this deal."

#: app/frontend/components/v2/inbox/link-opportunity-panel.tsx
msgid "We couldn't link that. Please try again."
msgstr "We couldn't link that. Please try again."

#: app/frontend/components/v2/voice/after-call-link-deal.tsx
msgid "We couldn't load the deals. Please try again."
msgstr "We couldn't load the deals. Please try again."

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "We couldn't load the follow-up. Please try again."
msgstr "We couldn't load the follow-up. Please try again."

#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "We couldn't move that. Please try again."
msgstr "We couldn't move that. Please try again."

#: app/frontend/components/v2/voice/after-call-card.tsx
#: app/frontend/components/v2/voice/after-call-card.tsx
msgid "We couldn't regenerate that. Please try again."
msgstr "We couldn't regenerate that. Please try again."

#: app/frontend/components/v2/inbox/mobile-row-pickers.tsx
#: app/frontend/components/v2/inbox/mobile-row-pickers.tsx
#: app/frontend/components/v2/inbox/notes-section.tsx
#: app/frontend/components/v2/inbox/notes-section.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "We couldn't save that. Please try again."
msgstr "We couldn't save that. Please try again."

#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "We couldn't schedule that. Please try again."
msgstr "We couldn't schedule that. Please try again."

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "We couldn't send that. Please try again."
msgstr "We couldn't send that. Please try again."

#: app/frontend/components/v2/inbox/failed-message-group.tsx
msgid "We couldn't send this message"
msgstr "We couldn't send this message"

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "We couldn't set that up. Please try again."
msgstr "We couldn't set that up. Please try again."

#: app/frontend/components/v2/voice/softphone.tsx
#: app/frontend/components/v2/voice/softphone.tsx
msgid "We couldn't start the call. Please try again."
msgstr "We couldn't start the call. Please try again."

#: app/frontend/components/v2/voice/call-detail-panel.tsx
msgid "We couldn't transcribe this call."
msgstr "We couldn't transcribe this call."

#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "We couldn't undo that. Please try again."
msgstr "We couldn't undo that. Please try again."

#: app/frontend/components/v2/inbox/attach-offer-card.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "We couldn't update that. Please try again."
msgstr "We couldn't update that. Please try again."

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "We couldn't upload that file. Try again."
msgstr "We couldn't upload that file. Try again."

#: app/frontend/components/v2/deals/starter-pipeline-banner.tsx
#: app/frontend/components/v2/deals/starter-pipeline-banner.tsx
msgid "We set up a starter pipeline for you"
msgstr "We set up a starter pipeline for you"

#: app/frontend/components/v2/inbox/compose/recipient-picker.tsx
msgid "We'll create the contact when you send the first message."
msgstr "We'll create the contact when you send the first message."

#: app/frontend/components/v2/settings/phone-numbers/buy/step-confirm.tsx
msgid "We'll pick a {regionName} number and connect it to your inbox. Usually live within 30 seconds."
msgstr "We'll pick a {regionName} number and connect it to your inbox. Usually live within 30 seconds."

#. placeholder {0}: data.areaCode
#: app/frontend/components/v2/settings/phone-numbers/buy/step-confirm.tsx
msgid "We'll pick a {regionName} number with area code {0} and connect it to your inbox. Usually live within 30 seconds."
msgstr "We'll pick a {regionName} number with area code {0} and connect it to your inbox. Usually live within 30 seconds."

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "We'll ping you when {firstName} replies"
msgstr "We'll ping you when {firstName} replies"

#: app/frontend/components/v2/deals/mobile-deals-shell.tsx
msgid "We're filtering the pipeline below as you type. Close to see matching deals."
msgstr "We're filtering the pipeline below as you type. Close to see matching deals."

#: app/frontend/components/v2/companies/properties-section.tsx
msgid "Website"
msgstr "Website"

#: app/frontend/pages/v2/sessions/new.tsx
msgid "Welcome back"
msgstr "Welcome back"

#: app/frontend/components/v2/voice/after-call-card.tsx
msgid "What came out of this call?"
msgstr "What came out of this call?"

#: app/frontend/types/v2/buy-number.ts
msgid "What can this number do?"
msgstr "What can this number do?"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
msgid "What does the message say?"
msgstr "What does the message say?"

#: app/frontend/components/v2/settings/usage/included-card.tsx
msgid "What the AI handled for you this period — at no extra cost."
msgstr "What the AI handled for you this period — at no extra cost."

#: app/frontend/components/v2/settings/team/access-card.tsx
msgid "What this teammate can see and change."
msgstr "What this teammate can see and change."

#: app/frontend/lib/settings-nav.ts
msgid "What you get pinged about, and how."
msgstr "What you get pinged about, and how."

#: app/frontend/components/v2/inbox/create-opportunity-panel.tsx
msgid "What's it worth? e.g. $48,000"
msgstr "What's it worth? e.g. $48,000"

#: app/frontend/components/v2/voice/after-call-link-deal.tsx
msgid "What's the deal about?"
msgstr "What's the deal about?"

#: app/frontend/components/v2/inbox/context-pane.tsx
#: app/frontend/components/v2/voice/call-follow-ups.tsx
msgid "What's the follow-up?"
msgstr "What's the follow-up?"

#: app/frontend/components/v2/deals/next-step-composer.tsx
msgid "WHAT'S THE NEXT STEP?"
msgstr "WHAT'S THE NEXT STEP?"

#: app/frontend/components/v2/inbox/create-opportunity-panel.tsx
msgid "What's the opportunity?"
msgstr "What's the opportunity?"

#: app/frontend/components/v2/contacts/row-actions.tsx
#: app/frontend/lib/follow-up-method.ts
#: app/frontend/lib/follow-up-method.ts
#: app/frontend/lib/follow-up-method.ts
#: app/frontend/lib/phone-number-display.ts
#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "WhatsApp"
msgstr "WhatsApp"

#: app/frontend/components/v2/today/ai-accept-modal.tsx
#: app/frontend/components/v2/today/ai-accept-sheet.tsx
msgid "WhatsApp · {contactName}"
msgstr "WhatsApp · {contactName}"

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "WhatsApp · {firstName}"
msgstr "WhatsApp · {firstName}"

#: app/frontend/components/v2/contacts/create-contact-modal.tsx
msgid "WhatsApp · calls"
msgstr "WhatsApp · calls"

#: app/frontend/pages/v2/settings/channels/show.tsx
#: app/frontend/pages/v2/settings/channels/show.tsx
#: app/frontend/pages/v2/settings/channels/show.tsx
msgid "WhatsApp Account"
msgstr "WhatsApp Account"

#: app/frontend/pages/v2/settings/channels/show.tsx
msgid "WhatsApp Business"
msgstr "WhatsApp Business"

#: app/frontend/components/v2/messages/outbound-sender-avatar.tsx
msgid "WhatsApp Business App"
msgstr "WhatsApp Business App"

#: app/frontend/components/v2/inbox/failed-message-group.tsx
msgid "WhatsApp can't reach this number right now"
msgstr "WhatsApp can't reach this number right now"

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "WhatsApp follow-up message"
msgstr "WhatsApp follow-up message"

#: app/frontend/components/v2/companies/properties-section.tsx
msgid "WhatsApp inbound"
msgstr "WhatsApp inbound"

#: app/frontend/components/v2/inbox/failed-message-group.tsx
msgid "WhatsApp is rate-limiting this number"
msgstr "WhatsApp is rate-limiting this number"

#: app/frontend/components/v2/whatsapp-templates/template-component-editors.tsx
#: app/frontend/pages/v2/settings/channels/whatsapp/templates/show.tsx
msgid "WhatsApp message preview"
msgstr "WhatsApp message preview"

#: app/frontend/components/v2/inbox/compose/compose-modal.tsx
msgid "WhatsApp opens the 24-hour reply window once the contact replies. Freeform sends are blocked until then."
msgstr "WhatsApp opens the 24-hour reply window once the contact replies. Freeform sends are blocked until then."

#: app/frontend/components/v2/inbox/failed-message-group.tsx
msgid "WhatsApp paused this send for quality reasons"
msgstr "WhatsApp paused this send for quality reasons"

#: app/frontend/components/v2/inbox/failed-message-group.tsx
msgid "WhatsApp rejected the image or video. Re-attach the file and send again — large videos and unsupported formats are the most common cause."
msgstr "WhatsApp rejected the image or video. Re-attach the file and send again — large videos and unsupported formats are the most common cause."

#: app/frontend/lib/settings-nav.ts
msgid "WhatsApp templates and quick replies."
msgstr "WhatsApp templates and quick replies."

#: app/frontend/lib/settings-nav.ts
msgid "WhatsApp, Instagram, email, and live chat."
msgstr "WhatsApp, Instagram, email, and live chat."

#: app/frontend/components/v2/inbox/mobile-row-pickers.tsx
msgid "When"
msgstr "When"

#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/components/v2/deals/filter-popover.tsx
msgid "where"
msgstr "where"

#: app/frontend/components/v2/contacts/create-contact-modal.tsx
msgid "Where do they work?"
msgstr "Where do they work?"

#: app/frontend/types/v2/buy-number.ts
msgid "Where should this number be from?"
msgstr "Where should this number be from?"

#: app/frontend/components/v2/inbox/mobile-row-pickers.tsx
msgid "Which deal"
msgstr "Which deal"

#: app/frontend/components/v2/settings/team/team-answers-popover.tsx
#: app/frontend/components/v2/settings/team/team-answers-popover.tsx
msgid "Which numbers ring {employeeName}?"
msgstr "Which numbers ring {employeeName}?"

#: app/frontend/components/v2/settings/team/voice-calling-card.tsx
msgid "Whisper next steps and objections"
msgstr "Whisper next steps and objections"

#: app/frontend/components/v2/settings/phone-numbers/reassign-answerers.tsx
#: app/frontend/components/v2/settings/phone-numbers/reassign-answerers.tsx
#: app/frontend/components/v2/settings/phone-numbers/reassign-answerers.tsx
msgid "Who answers this number?"
msgstr "Who answers this number?"

#: app/frontend/lib/settings-nav.ts
msgid "Who changed what, and when."
msgstr "Who changed what, and when."

#: app/frontend/types/v2/buy-number.ts
msgid "Who should answer this number?"
msgstr "Who should answer this number?"

#: app/frontend/components/v2/assignees/assignee-picker.tsx
msgid "Who's assigned?"
msgstr "Who's assigned?"

#: app/frontend/components/v2/today/ai-accept-modal.tsx
msgid "Why this message:"
msgstr "Why this message:"

#: app/frontend/components/v2/contacts/filter-popover.tsx
#: app/frontend/types/v2/contact-filters.ts
#: app/frontend/types/v2/deal-filters.ts
msgid "within"
msgstr "within"

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "Within the 24h window · free text"
msgstr "Within the 24h window · free text"

#: app/frontend/components/v2/companies/pill.tsx
#: app/frontend/components/v2/deals/pipeline-customize-modal.tsx
#: app/frontend/lib/deal-stage.ts
msgid "Won"
msgstr "Won"

#: app/frontend/components/v2/landing/email-capture.tsx
msgid "Work email"
msgstr "Work email"

#: app/frontend/components/v2/auth/auth-submit-button.tsx
#: app/frontend/components/v2/settings/phone-numbers/buy/wizard-frame.tsx
msgid "Working…"
msgstr "Working…"

#: app/frontend/components/v2/inbox/sidebar.tsx
#: app/frontend/lib/settings-nav.ts
#: app/frontend/lib/settings-nav.ts
msgid "Workspace"
msgstr "Workspace"

#: app/frontend/components/v2/settings/team/voice-calling-card.tsx
msgid "Workspace default"
msgstr "Workspace default"

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "Write a quick follow-up…"
msgstr "Write a quick follow-up…"

#: app/frontend/components/v2/voice/after-call-card.tsx
#: app/frontend/lib/voice-disposition.ts
#: app/frontend/lib/voice-disposition.ts
msgid "Wrong number"
msgstr "Wrong number"

#: app/frontend/components/v2/deals/activity-feed.tsx
#: app/frontend/pages/v2/notifications/index.tsx
msgid "Yesterday"
msgstr "Yesterday"

#: app/frontend/components/v2/inbox/conversation-reassign-sheet.tsx
msgid "you"
msgstr "you"

#: app/frontend/components/v2/inbox/conversation-more-menu.tsx
#: app/frontend/components/v2/voice/after-call-transcript.tsx
msgid "You"
msgstr "You"

#: app/frontend/components/v2/inbox/failed-message-group.tsx
msgid "You attempted to send"
msgstr "You attempted to send"

#: app/frontend/components/v2/contacts/create-contact-modal.tsx
msgid "You can edit any field after the contact is created"
msgstr "You can edit any field after the contact is created"

#: app/frontend/components/v2/deals/create-deal-modal.tsx
msgid "You can edit any field after the deal is created"
msgstr "You can edit any field after the deal is created"

#: app/frontend/components/v2/settings/phone-numbers/add-card-interstitial.tsx
msgid "You won't be charged until you pick a number. Cancel anytime."
msgstr "You won't be charged until you pick a number. Cancel anytime."

#: app/frontend/components/v2/inbox/failed-template-expander.tsx
msgid "You'll need an approved WhatsApp template to send while the 24-hour window is closed. Create one in Settings → Channels → WhatsApp → Templates."
msgstr "You'll need an approved WhatsApp template to send while the 24-hour window is closed. Create one in Settings → Channels → WhatsApp → Templates."

#: app/frontend/components/v2/notifications/notifications-list-content.tsx
#: app/frontend/pages/v2/notifications/index.tsx
msgid "You're all caught up."
msgstr "You're all caught up."

#: app/frontend/pages/v2/settings/billing/show.tsx
msgid "You're all set — welcome aboard!"
msgstr "You're all set — welcome aboard!"

#: app/frontend/pages/v2/today/show.tsx
msgid "You're caught up"
msgstr "You're caught up"

#. placeholder {0}: pricing.baseFromLabel
#: app/frontend/components/v2/settings/phone-numbers/add-card-interstitial.tsx
msgid "You're on a trial. To purchase phone numbers, add a credit card. Numbers start at {0} and bill on the day you buy."
msgstr "You're on a trial. To purchase phone numbers, add a credit card. Numbers start at {0} and bill on the day you buy."

#. placeholder {0}: current.planName ?? "free"
#: app/frontend/components/v2/settings/billing/trial-banner.tsx
msgid "You're on the {0} trial"
msgstr "You're on the {0} trial"

#: app/frontend/components/v2/landing/email-capture.tsx
msgid "you@company.com"
msgstr "you@company.com"

#: app/frontend/lib/settings-nav.ts
msgid "Your AI and telephony spend."
msgstr "Your AI and telephony spend."

#: app/frontend/pages/v2/settings/channels/whatsapp/show.tsx
msgid "Your AI assistant replies to inbound messages on this channel."
msgstr "Your AI assistant replies to inbound messages on this channel."

#: app/frontend/components/v2/auth/auth-layout.tsx
msgid "Your AI sales rep that lives in WhatsApp."
msgstr "Your AI sales rep that lives in WhatsApp."

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
msgid "your contact"
msgstr "your contact"

#: app/frontend/components/v2/settings/usage/included-card.tsx
msgid "Your cost for all of this"
msgstr "Your cost for all of this"

#: app/frontend/components/v2/landing/feature-today.tsx
msgid "Your day"
msgstr "Your day"

#: app/frontend/components/v2/voice/after-call-whatsapp.tsx
msgid "Your draft is saved"
msgstr "Your draft is saved"

#: app/frontend/components/v2/settings/billing/trial-banner.tsx
msgid "Your first charge is on {chargeDate}."
msgstr "Your first charge is on {chargeDate}."

#: app/frontend/components/v2/whatsapp-templates/template-edit-submitted-editor.tsx
msgid "Your message will appear here."
msgstr "Your message will appear here."

#: app/frontend/lib/settings-nav.ts
msgid "Your name, email, and password."
msgstr "Your name, email, and password."

#: app/frontend/components/v2/voice/after-call-card.tsx
msgid "Your note"
msgstr "Your note"

#: app/frontend/components/v2/voice/after-call-card.tsx
msgid "Your note · or use the AI summary once it lands"
msgstr "Your note · or use the AI summary once it lands"

#: app/frontend/components/v2/settings/phone-numbers/buy/step-confirm.tsx
msgid "Your number is assigned at purchase"
msgstr "Your number is assigned at purchase"

#: app/frontend/components/v2/landing/feature-pipeline.tsx
msgid "Your pipeline updates while you talk"
msgstr "Your pipeline updates while you talk"

#: app/frontend/pages/v2/settings/usage/show.tsx
msgid "Your spend and what AI handled for you this period."
msgstr "Your spend and what AI handled for you this period."
